export default {
  services_number_title: "Anzahl der wählbaren Dienstleistungen",
  additional_information_after_booking_title:
    "Zusätzliche Infos in Buchungs-E-Mails",
  additional_information_after_booking_subtitle:
    "Wir fügen sie den E-Mails zu neuen, geänderten und anstehenden Buchungen hinzu.",
  additional_information_after_booking_dummy_text:
    "Dies ist ein Beispieltext, der durch zusätzliche Informationen nach der Buchung ersetzt wird, sofern diese in den Serviceeinstellungen angegeben wurden.",
  plugins_storage_100gb_cd_base_pro_name: "Dateispeicher 100 GB",
  plugins_storage_500gb_cd_base_pro_name: "Dateispeicher 500 GB",
  plugins_storage_100gb_cd_base_pro_description:
    "Mehr Speicherplatz für Dateien. Gewinne 100 GB zusätzlichen Platz, um Dateien mit Kunden auszutauschen und Anhänge über Buchungsformulare zu empfangen. Eine ideale Lösung, um die Kommunikation zu verbessern und den Kundenservice zu optimieren.",
  plugins_storage_500gb_cd_base_pro_description:
    "Maximaler Speicherplatz für deine Dateien. Nutze 500 GB Speicherplatz, um Dateien mit Kunden auszutauschen und Anhänge über Buchungsformulare ohne Einschränkungen zu empfangen. Unverzichtbar für schnell wachsende Unternehmen, die Professionalität und Komfort schätzen.",
  bookings_this_month: "Buchungen diesen Monat",
  bookings_all_processed: "Alle Buchungen",
  simple_store_product_transactions_this_month:
    "Verkaufte Produkte diesen Monat",
  files_storage_usage: "Genutzter Speicherplatz",
  files_storage_usage_from_available_prefix: "von verfügbaren",
  not_available_in_standard_plan: "Funktion nicht im Standardplan verfügbar",
  ai_tokens_usage: "Verbrauchte AI-Tokens",
  ai_tokens_usage_from_available_prefix: "von verfügbaren",
  ai_tokens_resets_at: "Wird zurückgesetzt",
  cancel_reason_dropdown_label: "Grund für die Kündigung des Abonnements",
  cancel_subscription_category_1_title: "Technische Probleme",
  cancel_subscription_category_1_reason_1_title:
    "Häufige Abstürze oder Ausfälle",
  cancel_subscription_category_1_reason_2_title: "Langsame Systemleistung",
  cancel_subscription_category_1_reason_3_title:
    "Schwer zu bedienende Benutzeroberfläche",
  cancel_subscription_category_1_reason_4_title:
    "Probleme mit Integrationen (z. B. Zahlungssystem, externe Kalender)",
  cancel_subscription_category_1_reason_5_title:
    "Sicherheitsbedenken (z. B. Datenschutzverletzungen)",
  cancel_subscription_category_1_reason_6_title:
    "Probleme mit der mobilen Mitarbeiter-App (z. B. Abstürze, Bugs)",
  cancel_subscription_category_2_title:
    "Persönliche oder geschäftliche Veränderungen",
  cancel_subscription_category_2_reason_1_title:
    "Änderung des Geschäftsmodells (z. B. geringerer Bedarf an Buchungen)",
  cancel_subscription_category_2_reason_2_title:
    "Budgetbeschränkungen oder finanzielle Schwierigkeiten",
  cancel_subscription_category_2_reason_3_title:
    "Zu viel Arbeitsaufwand, um das System zu verwalten",
  cancel_subscription_category_2_reason_4_title:
    "Schließung oder Verkleinerung des Unternehmens",
  cancel_subscription_category_2_reason_5_title:
    "Keine Zeit, um Buchungen zu verwalten",
  cancel_subscription_category_3_title: "Preis- und Wettbewerbsfaktoren",
  cancel_subscription_category_3_reason_1_title:
    "Günstigere Alternativen verfügbar",
  cancel_subscription_category_3_reason_2_title:
    "Preiserhöhung oder Änderung des Abrechnungsmodells",
  cancel_subscription_category_4_title: "Probleme mit der Benutzererfahrung",
  cancel_subscription_category_4_reason_1_title:
    "Schwierigkeiten bei der Navigation im System",
  cancel_subscription_category_4_reason_2_title: "Fehlende wichtige Funktionen",
  cancel_subscription_category_4_reason_3_title:
    "Zu kompliziert für mein Team oder Unternehmen",
  cancel_subscription_category_4_reason_4_title:
    "Langsamer oder wenig hilfreicher Kundenservice",
  cancel_subscription_category_4_reason_5_title:
    "Begrenzte Anpassungsmöglichkeiten",
  cancel_subscription_category_4_reason_6_title:
    "Komplizierter Einrichtungs- oder Implementierungsprozess",
  cancel_subscription_category_5_title: "Externe und marktbedingte Faktoren",
  cancel_subscription_category_5_reason_1_title:
    "Änderungen in Markttrends (z. B. Wechsel zu Buchungen über soziale Medien)",
  cancel_subscription_category_5_reason_2_title:
    "Wirtschaftskrise oder Abschwung",
  cancel_subscription_category_5_reason_3_title:
    "Änderungen in den gesetzlichen Vorschriften",
  cancel_subscription_category_6_title: "Sonstiges",
  cancel_subscription_category_6_reason_1_title: "Grund nicht aufgeführt",
  cancel_subscription_category_6_reason_2_title:
    "Ich möchte keinen Grund angeben",
  cancel_plan_and_delete_data: "Kündigen und meine Daten löschen",
  cancel_plan_do_nothing: "Nichts tun",
  cancel_plan_and_keep_data_confirmation_label:
    "Bist du sicher, dass du dein Abonnement kündigen, aber deine Daten behalten möchtest?",
  cancel_plan_and_keep_data_confirmation_info:
    "Das Abonnement wird am Ende des bereits bezahlten Abrechnungszeitraums gekündigt. Die Daten werden sicher auf unseren Servern gespeichert und können jederzeit nach der Reaktivierung des Abonnements wiederhergestellt werden.",
  scheduled_cancel_keeps_data_info:
    "Dein Plan wird gekündigt, aber deine Daten bleiben gespeichert",
  no_just_checking_title: "Nein, ich schaue nur",
  payment_deadline_before_start_variable:
    "Zahlungsfrist vor Beginn jeder wiederkehrenden Buchung",
  send_payment_reminder_before_start_variable:
    "Zeit der Zahlungserinnerungsbenachrichtigung vor der Buchung",
  variable_service_reschedule_deadline_before_start:
    "Frist für Terminänderung vor Buchungsbeginn",
  variable_service_cancel_deadline_before_start:
    "Frist für Stornierung vor Buchungsbeginn",
  variable_customer_private_notes: "Private Notizen zum Kunden",
  booking_awaiting_payment_full_description:
    "Vollständige Informationen zur erforderlichen Zahlung",
  booking_awaiting_payment_full_description_example:
    "Die Buchung wird storniert, wenn keine Zahlung innerhalb von 30 min erfolgt. Klicke unten, um zu deiner Buchung zu gelangen und die Zahlung vorzunehmen.",
  recurring_meeting_in_the_past_warning:
    'Ein wiederkehrendes Meeting mit Startdaten in der Vergangenheit kann nicht erstellt werden. Wähle ein Startdatum in der Zukunft oder deaktiviere die Option "Regelmäßig wiederholen".',
  booking_overlaps_dialog_title: "Kalenderkonflikt erkannt",
  booking_overlaps_dialog_message:
    "Bei der Überprüfung der Verfügbarkeit haben wir festgestellt, dass der ausgewählte Termin mit bestehenden Buchungen oder Sperrzeiten kollidiert. Konfliktdetails:",
  booking_overlaps_count: "Anzahl der kollidierenden Buchungen",
  unavailable_slot_overlaps_count: "Anzahl der kollidierenden Sperrzeiten",
  booking_overlaps_dialog_question: "Möchtest du trotzdem fortfahren?",
  selected_date: "Ausgewähltes Datum",
  single_booking: "Einzelbuchung",
  external_api_service_not_enabled_error:
    "Leider ist die API-Funktion für dieses Konto nicht verfügbar.",
  integration_auth_code_expired_error:
    "Die Verbindung konnte nicht abgeschlossen werden, da die Autorisierung abgelaufen ist. Klicken Sie erneut auf „Verbinden“ und schließen Sie die Anmeldung ohne längere Pausen ab.",
  google_calendar_disconnected_info:
    "Google Kalender ist getrennt, weil Google Calendesk keinen Zugriff auf deinen Kalender gibt. Meist wurden beim Verbinden nicht alle Berechtigungen ausgewählt. Verbinde dein Konto erneut und wähle auf der Google-Seite alle Berechtigungen aus, um die wir bitten.",
  google_calendar_reconnect: "Erneut verbinden",
  outlook_mailbox_not_available_error:
    "Der Kalender dieses Microsoft-Kontos konnte nicht verbunden werden. Mögliche Ursachen sind ein Postfach auf einem Firmenserver statt in Microsoft 365, ein Konto ohne aktives Postfach oder ein gelöschtes Postfach. Klären Sie das mit Ihrem Microsoft-365-Administrator.",
  service_not_available_at_selected_time:
    "Der Service ist zum ausgewählten Zeitpunkt nicht verfügbar.",
  service_not_available_pool_full:
    "Der Service ist zu dieser Zeit nicht verfügbar: Im Pool „@{pool}“ ist keine Position frei (belegt: @{used} von @{capacity}).",
  service_not_available_pool_rule:
    "Der Service ist zu dieser Zeit nicht verfügbar: Die freien Positionen des Pools „@{pool}“ sind für andere Buchungen gedacht.",
  service_not_available_resource_taken:
    "Der Service ist zu dieser Zeit nicht verfügbar: Die Ressource „@{resource}“ ist durch eine andere Buchung belegt.",
  offline_mode: "Du bist offline",
  offline_description:
    "Die Anwendung benötigt eine Internetverbindung zum Funktionieren.",
  retry: "Erneut versuchen",
  checking_connection: "Verbindung wird überprüft...",
  waiting_for_connection: "Warten auf Verbindung",
  "2fa_verify_title": "Zwei-Faktor-Authentifizierung",
  "2fa_verify_description":
    "Gib deinen 6-stelligen Code aus deiner Authenticator-App ein oder verwende einen Wiederherstellungscode:",
  "2fa_recovery_code_label": "Wiederherstellungscode",
  "2fa_use_recovery_code": "Wiederherstellungscode verwenden",
  "2fa_use_app_code": "App-Code verwenden",
  "2fa_verify_incorrect_error":
    "Der 2FA-Code ist falsch. Bitte versuche es erneut.",
  "2fa_session_expired_error":
    "Deine 2FA-Sitzung ist abgelaufen. Bitte melde dich erneut an.",
  "2fa_verification_cancelled":
    "Die Zwei-Faktor-Authentifizierung wurde abgebrochen. Bitte versuche es erneut.",
  enable_2fa: "2FA aktivieren",
  enable_2fa_title: "2-Stufen-Verifizierung aktivieren",
  disable_2fa: "2FA deaktivieren",
  disable_2fa_title: "2-Stufen-Verifizierung deaktivieren",
  "2fa_manual_setup": "Kann nicht scannen? Gib diesen Code manuell ein:",
  "2fa_recovery_codes_title": "Wiederherstellungscodes",
  "2fa_download_codes": "Codes herunterladen",
  "2fa_disable_description":
    "Du bist dabei, die 2-Stufen-Verifizierung zu deaktivieren. Das macht dein Konto weniger sicher.",
  "2fa_disable_warning":
    "Das Deaktivieren der 2-Stufen-Verifizierung verringert die Sicherheit deines Kontos.",
  "2fa_verify_to_disable": "Identität überprüfen",
  "2fa_verify_to_disable_description":
    "Gib einen Code aus deiner Authenticator-App ein oder verwende einen Wiederherstellungscode, um die 2-Stufen-Verifizierung zu deaktivieren.",
  warning: "Warnung",
  current_password: "Aktuelles Passwort",
  incorrect_password: "Falsches Passwort. Bitte versuche es erneut.",
  "2fa_setup_failed": "2FA-Einrichtung fehlgeschlagen",
  "2fa_activation_failed": "2FA-Aktivierung fehlgeschlagen",
  "2fa_verification_code": "Verifizierungscode",
  "2fa_disabled_success": "2FA wurde erfolgreich deaktiviert",
  "2fa_disable_failed": "2FA-Deaktivierung fehlgeschlagen",
  "2fa_step_1_password_title": "Passwort eingeben",
  "2fa_step_1_scan_title": "QR-Code scannen",
  "2fa_step_2_verify_title": "Einrichtung überprüfen",
  "2fa_authenticator_apps_required": "Authenticator-App erforderlich",
  "2fa_setup_secure_subtitle":
    "Wähle und installiere eine sichere 2FA-App zum Schutz deines Kontos",
  "2fa_apps_installation_note":
    "Installiere eine dieser Apps auf deinem Handy, bevor du mit der Einrichtung fortfährst.",
  "2fa_scan_with_app": "Scanne diesen QR-Code mit deiner Authenticator-App",
  "2fa_enter_code_from_app":
    "Gib den 6-stelligen Code aus deiner Authenticator-App ein",
  "2fa_recovery_codes_warning":
    "Bewahre diese Codes an einem sicheren Ort auf. Jeder Code kann nur einmal verwendet werden.",
  "2fa_enter_password_to_continue":
    "Gib dein aktuelles Passwort ein, um deinen einzigartigen QR-Code zu generieren",
  "2fa_enter_password_to_disable":
    "Gib dein aktuelles Passwort ein, um die Deaktivierung der 2FA zu bestätigen",
  "2fa_disable_verification_description":
    "Gib dein aktuelles Passwort und einen Code aus deiner Authenticator-App ein oder verwende einen Wiederherstellungscode, um die 2-Stufen-Verifizierung zu deaktivieren.",
  "2fa_recovery_codes_description":
    "Diese Backup-Codes ermöglichen dir den Zugang zu deinem Konto, falls du deine Authenticator-App verlierst. Jeder Code kann nur einmal verwendet werden, bewahre sie an einem sicheren Ort auf.",
  security_settings: "Sicherheitseinstellungen",
  security_settings_description:
    "Verwalte deine Kontosicherheitseinstellungen und Authentifizierungsmethoden.",
  "2fa_security_title": "2-Stufen-Verifizierung",
  "2fa_security_description":
    "Füge deinem Konto eine zusätzliche Sicherheitsebene mit der 2-Stufen-Verifizierung hinzu.",
  reset_password_description:
    "Sende einen Link zum Zurücksetzen des Passworts an deine E-Mail-Adresse.",
  "2fa_enabled_success": "2FA wurde erfolgreich aktiviert",
  linkedin: "LinkedIn",
  profile_company_social_media_linkedin_label_input:
    "Link zu einem LinkedIn-Profil",
  logs_diff_linkedin: "Link zu einem LinkedIn-Profil",
  tiktok: "TikTok",
  profile_company_social_media_tiktok_label_input:
    "Link zu einem TikTok-Profil",
  logs_diff_tiktok: "Link zu einem TikTok-Profil",
  wb_linkedin: "LinkedIn-URL",
  wb_tiktok: "TikTok-URL",
  plugins_calendesk_chat_cd_base_standard_name: "Calendesk Chat",
  plugins_calendesk_chat_cd_base_standard_description:
    "Verbessere deine Kundenkommunikation mit Calendesk Chat. Biete Echtzeit-Support, beantworte Fragen und interagiere direkt von deiner Buchungsseite aus mit deinen Kunden. Perfekt für Unternehmen, die stärkere Kundenbeziehungen aufbauen möchten.",
  plugins_calendesk_chat_cd_base_pro_name: "Calendesk Chat",
  plugins_calendesk_chat_cd_base_pro_description:
    "Verbessere deine Kundenkommunikation mit Calendesk Chat. Biete Echtzeit-Support, beantworte Fragen und interagiere direkt von deiner Buchungsseite aus mit deinen Kunden. Perfekt für Unternehmen, die stärkere Kundenbeziehungen aufbauen möchten.",
  number_of_agents: "Anzahl der Agenten",
  agents_plural: "Agenten",
  integrations_category_customer_support: "Kundensupport",
  chatwoot_title: "Calendesk Chat",
  chatwoot_description:
    "Verwalte deinen Live-Chat-Support. Greife auf das Dashboard zu, konfiguriere Agenten und sieh Gespräche ein.",
  chatwoot_package_not_active:
    "Das Calendesk Chat-Paket ist nicht aktiv. Bitte aktiviere es in deinen Abonnementeinstellungen.",
  chatwoot_setup_title: "Chat-Support einrichten",
  chatwoot_setup_info:
    'Calendesk Chat ist eine separate Anwendung unter <a href="https://chat.calendesk.com" target="_blank">chat.calendesk.com</a>, wo du Kundengespräche verwaltest.',
  chatwoot_setup_sso_warning:
    "Alle Calendesk-Administratoren mit Zugriff auf Integrationen können sich im Chat-Dashboard anmelden.",
  chatwoot_setup_next_steps_title: "Nach der Einrichtung:",
  chatwoot_setup_next_step_1:
    'Ein Chat-Konto wird auf <a href="https://chat.calendesk.com" target="_blank">chat.calendesk.com</a> erstellt',
  chatwoot_setup_next_step_2:
    "Administratoren werden sich mit einem Klick über das Calendesk-Menü im Chat-Dashboard anmelden können",
  chatwoot_setup_next_step_3:
    "Du kannst das Chat-Widget zu deiner Buchungsseite hinzufügen - den Einbettungscode findest du im Chat-Dashboard",
  chatwoot_company_section_title: "Firmendaten",
  chatwoot_admin_section_title: "Chat-Administrator",
  chatwoot_business_name: "Firmenname",
  chatwoot_business_name_hint:
    "Für Kunden im Chat-Widget und in Benachrichtigungen sichtbar",
  chatwoot_admin_name: "Name",
  chatwoot_admin_email: "E-Mail",
  chatwoot_support_email: "Kundensupport-E-Mail",
  chatwoot_support_email_placeholder: "z.B. support@ihrfirma.de",
  chatwoot_support_email_hint:
    "Kunden sehen diese Adresse als Absender von E-Mail-Antworten Ihres Teams",
  chatwoot_start_integration: "Einrichten",
  chatwoot_integration_active: "Calendesk Chat ist aktiv und einsatzbereit.",
  chatwoot_dashboard_info:
    'Verwalte deine Gespräche, Agenten und Einstellungen im Chat-Dashboard unter <a href="https://chat.calendesk.com" target="_blank">chat.calendesk.com</a>.',
  chatwoot_sso_warning:
    "Alle Calendesk-Administratoren mit Zugriff auf Integrationen können sich mit einem Klick im Chat-Dashboard anmelden.",
  chatwoot_open_dashboard: "Dashboard öffnen",
  chatwoot_agent_limit: "Agentenplätze",
  chatwoot_buy_more_agents: "Mehr Agenten benötigt? Paket upgraden",
  chatwoot_integration_success:
    "Calendesk Chat wurde erfolgreich eingerichtet!",
  chatwoot_integration_error:
    "Calendesk Chat konnte nicht eingerichtet werden. Bitte versuche es erneut oder kontaktiere den Support.",
  chatwoot_sso_error:
    "Das Chat-Dashboard konnte nicht geöffnet werden. Bitte versuche es erneut oder kontaktiere den Support.",
  chatwoot_suspend_button: "Pausieren",
  chatwoot_suspend_title: "Calendesk Chat pausieren",
  chatwoot_suspend_warning:
    "Die Pausierung deaktiviert das Chat-Widget auf der Website für Endkunden, <strong>hat jedoch keinen Einfluss auf die Paketaktivität oder die damit verbundenen Gebühren</strong>.<br><br>Um das Paket zu kündigen, gehe zu <strong>Abrechnungen → Abo</strong> und wähle <strong>Deaktivieren</strong>.",
  chatwoot_suspend_confirm: "Pausieren",
  chatwoot_suspend_success: "Calendesk Chat wurde pausiert.",
  chatwoot_suspend_error:
    "Calendesk Chat konnte nicht pausiert werden. Bitte versuche es erneut oder kontaktiere den Support.",
  chatwoot_suspended_info: "Ihr Calendesk Chat-Konto ist derzeit pausiert.",
  chatwoot_suspended_data_preserved:
    "Alle Ihre Gespräche und Einstellungen werden gespeichert und bei der Reaktivierung wiederhergestellt.",
  chatwoot_reactivate_button: "Reaktivieren",
  chatwoot_reactivation_success: "Calendesk Chat wurde reaktiviert!",
  chatwoot_reactivation_error:
    "Calendesk Chat konnte nicht reaktiviert werden. Bitte versuche es erneut oder kontaktiere den Support.",
  chatwoot_suspended_tooltip: "Pausiert - klicken zum Reaktivieren",
  chatwoot_agent_limit_exceeded:
    "Du hast @{current} Agenten, aber dein Paket erlaubt nur @{limit}.",
  chatwoot_agent_limit_contact_support:
    "Um Calendesk Chat zu reaktivieren, kontaktiere bitte unser Support-Team. Wir helfen dir, die Anzahl der Agenten an dein Paketlimit anzupassen.",
  contact_support: "Support kontaktieren",
  chatwoot_min_agents_info:
    "Mindestens @{count} Agenten erforderlich basierend auf Ihrer aktuellen Calendesk Chat-Konfiguration.",
  chatwoot_close_confirm_title: "Formular schließen?",
  chatwoot_close_confirm_warning:
    "Ihre eingegebenen Daten wurden nicht gespeichert und gehen verloren.",
  chatwoot_close_confirm_yes: "Schließen",
  chatwoot_close_confirm_no: "Zurück zum Formular",
  dialog_close_confirm_title: "Schließen?",
  dialog_close_confirm_warning: "Nicht gespeicherte Änderungen gehen verloren.",
  dialog_close_confirm_yes: "Schließen",
  dialog_close_confirm_no: "Abbrechen",
  reports: "Berichte",
  reports_granularity: "Gruppieren nach",
  reports_revenue: "Umsatz & Zahlungen",
  reports_bookings: "Buchungen",
  reports_team: "Mein Team",
  reports_customers: "Kunden & Handel",
  reports_clients: "Kunden",
  reports_subscriptions: "Abonnements",
  reports_products: "Produkte",
  reports_tab_revenue: "Umsatz",
  date_range: "Zeitraum",
  vs_previous_period: "vs vorheriger Zeitraum",
  reports_revenue_timeline: "Umsatz im Zeitverlauf",
  reports_top_services: "Top-Dienstleistungen",
  reports_top_products: "Top-Produkte",
  reports_payment_providers: "Zahlungsmethoden",
  reports_payment_methods_count: "Transaktionen nach Zahlungsmethode",
  reports_payment_methods_value: "Umsatz nach Zahlungsmethode",
  reports_payment_timeline: "Zahlungen im Zeitverlauf",
  reports_bookings_timeline: "Buchungen im Zeitverlauf",
  reports_by_service: "Nach Dienstleistung",
  reports_by_employee: "Nach Mitarbeiter",
  reports_by_delivery_type: "Nach Lieferart",
  reports_cancellation_reasons: "Stornierungsgründe",
  reports_by_day: "Nach Wochentag",
  reports_by_hour: "Nach Stunde",
  reports_heatmap: "Buchungs-Heatmap",
  reports_employee_performance: "Team-Leistung",
  reports_service_ranking: "Dienstleistungsranking",
  reports_by_category: "Nach Kategorie",
  reports_locations: "Standorte",
  reports_customer_segments: "Kundenbindung",
  reports_top_customers: "Top-Kunden",
  reports_product_revenue_timeline: "Produktumsatz im Zeitverlauf",
  reports_booking_revenue_timeline: "Buchungsumsatz im Zeitverlauf",
  reports_top_subscriptions: "Top-Abonnements",
  reports_subscription_timeline: "Neue Abonnements im Zeitverlauf",
  reports_subscription_revenue_timeline: "Abonnementumsatz im Zeitverlauf",
  reports_revenue_forecast: "Umsatzprognose",
  reports_bookings_forecast: "Buchungsprognose",
  reports_section_key_metrics: "Kennzahlen",
  reports_section_key_metrics_tooltip:
    "<b>Kennzahlen</b><br><br>Deine wichtigsten Geschäftskennzahlen im gewählten Zeitraum. Pfeile zeigen Veränderungen im Vergleich zum vorherigen Zeitraum gleicher Länge.",
  reports_section_trends: "Trends",
  reports_section_trends_tooltip:
    "<b>Trends</b><br><br>Wie sich dein Umsatz und deine Buchungen im gewählten Zeitraum verändert haben.",
  reports_section_revenue: "Umsatz",
  reports_section_revenue_tooltip:
    "<b>Umsatz</b><br><br>Gesamteinnahmen aus allen Quellen im gewählten Zeitraum. Nur <b>abgeschlossene Zahlungen</b> werden gezählt.<br><br>Enthält:<br>• <b>Umsatzaufschlüsselung</b> — aus Buchungen, Abonnements und Produkten<br>• <b>Durchschn. Buchungswert</b> und <b>Buchungszahlungsrate</b><br>• <b>Umsatzverlauf</b> — wie sich die Einnahmen im Zeitverlauf verändert haben<br>• <b>Top-Dienstleistungen, Abonnements und Produkte</b> — nach Umsatz sortiert<br>• <b>Zahlungsmethoden</b> — Transaktionsanzahl und Umsatz pro Methode",
  reports_section_bookings: "Buchungen",
  reports_section_bookings_tooltip:
    "<b>Buchungen</b><br><br>Buchungsstatus, Volumen im Zeitverlauf und Aufschlüsselung nach Dienstleistung und Teammitglied im gewählten Zeitraum.<br><br>Enthält:<br>• <b>Statusaufschlüsselung</b> — genehmigt, erledigt, storniert<br>• <b>Buchungsverlauf</b> — Volumenveränderungen im Zeitverlauf<br>• <b>Buchungsumsatz</b> — wie sich der Buchungsumsatz im Zeitverlauf verändert hat<br>• <b>Nach Dienstleistung und Teammitglied</b> — am häufigsten gebuchte Dienste und am meisten beschäftigte Mitarbeiter",
  reports_section_patterns: "Buchungsmuster",
  reports_section_patterns_tooltip:
    "<b>Buchungsmuster</b><br><br>Wann deine Kunden am liebsten buchen. Nutze das zur Optimierung deines Zeitplans.<br><br>Enthält:<br>• <b>Heatmap der Stoßzeiten</b> — beliebteste Tage und Uhrzeiten<br>• <b>Beliebtester Tag</b> — welcher Wochentag die meisten Buchungen hat<br>• <b>Nach Uhrzeit</b> — Verteilung der Buchungen über den Tag",
  reports_section_employees: "Mein Team",
  reports_section_employees_tooltip:
    "<b>Mein Team</b><br><br>Wie jedes Teammitglied im gewählten Zeitraum abgeschnitten hat.<br><br>Enthält:<br>• <b>Erledigte Buchungen</b> — Anzahl abgeschlossener Buchungen pro Person<br>• <b>Generierter Umsatz</b> — Einnahmen aus ihren Buchungen<br>• <b>Kalenderauslastung</b> — wie viel der verfügbaren Arbeitszeit gebucht war",
  reports_section_services: "Dienstleistungen",
  reports_section_services_tooltip:
    "<b>Dienstleistungen</b><br><br>Beliebteste Dienstleistungen und ihre Einnahmen im gewählten Zeitraum.<br><br>Enthält:<br>• <b>Buchungen pro Dienstleistung</b> — Anzahl genehmigter und erledigter Buchungen<br>• <b>Umsatz pro Dienstleistung</b> — generierte Einnahmen",
  reports_section_locations: "Standorte",
  reports_section_locations_tooltip:
    "<b>Standorte</b><br><br>Leistungsaufschlüsselung nach Standort und Durchführungsart im gewählten Zeitraum.",
  reports_section_customers: "Kunden",
  reports_section_customers_tooltip:
    "<b>Kunden</b><br><br>Wer am häufigsten bucht, wer am meisten ausgibt und wie engagiert deine Kunden im gewählten Zeitraum sind.<br><br>Enthält:<br>• <b>Neue Kunden</b> — registriert im gewählten Zeitraum<br>• <b>Aktive Kunden</b> — hatten mindestens eine Buchung<br>• <b>Bindungsdiagramm</b> — Erstbesucher, Wiederkehrende und treue Stammkunden<br>• <b>Top-Kunden</b> — mit den höchsten Ausgaben im gewählten Zeitraum",
  reports_section_customer_overview: "Kunden",
  reports_section_customer_overview_tooltip:
    "<b>Kunden</b><br><br>Diese Werte umfassen deine gesamte Geschichte und ändern sich nicht mit dem Datumsfilter.",
  reports_section_customer_activity: "Aktivität im Zeitraum",
  reports_section_customer_activity_tooltip:
    "<b>Aktivität im Zeitraum</b><br><br>Wie sich deine Kunden im gewählten Zeitraum verhalten haben — Buchungen, Bindung und Präferenzen.",
  reports_section_products: "Produkte",
  reports_section_products_tooltip:
    "<b>Produkte</b><br><br>Produktverkäufe, Umsatz im Zeitverlauf und Bestseller im gewählten Zeitraum.<br><br>Enthält:<br>• <b>Gesamter Produktumsatz</b> im gewählten Zeitraum<br>• <b>Umsatzverlauf</b> — wie sich die Produktverkäufe über die Zeit verändert haben<br>• <b>Top-Produkte</b> — Bestseller nach Umsatz",
  reports_section_subscriptions: "Abonnements",
  reports_section_subscriptions_tooltip:
    "<b>Abonnements</b><br><br>Umsatz, Verlängerungen und Nutzung deiner Abo-Pläne im gewählten Zeitraum.<br><br>Enthält:<br>• <b>Aktive Abonnements</b> — wie viele Kunden gerade einen aktiven Plan haben<br>• <b>Umsatz</b> — wie viel du im gewählten Zeitraum mit Abonnements verdient hast<br>• <b>Verlängerungsrate</b> — wie viele Abonnenten mehr als einmal bezahlt haben (höher = Kunden kommen wieder)<br>• <b>Neue Abonnements</b> — wie viele neue Abonnements pro Zeitraum abgeschlossen wurden<br>• <b>Abonnementumsatz</b> — wie sich der Abonnementumsatz im Zeitverlauf verändert hat<br>• <b>Top-Abonnements</b> — welche Pläne am meisten Geld einbringen<br>• <b>Nutzung</b> — nutzen die Abonnenten ihre enthaltenen Buchungen tatsächlich?",
  reports_section_payments: "Zahlungen",
  reports_section_payments_tooltip:
    "<b>Zahlungen</b><br><br>Transaktionsdaten und Aufschlüsselung nach Zahlungsmethode im gewählten Zeitraum.<br><br>Enthält:<br>• <b>Gesamttransaktionen</b> — Anzahl abgeschlossener Zahlungen<br>• <b>Buchungszahlungsrate</b> — Anteil bezahlter Buchungen<br>• <b>Nach Zahlungsmethode</b> — Transaktionsanzahl und Umsatz pro Methode",
  reports_section_booking_status: "Buchungsstatus",
  reports_section_cancellation_reasons: "Stornierungsgründe",
  reports_section_peak_hours: "Stoßzeiten",
  reports_section_peak_hours_tooltip:
    "<b>So liest du dieses Diagramm:</b><br><br><b>Zeilen</b> = Wochentage<br><b>Spalten</b> = Uhrzeiten (00:00–23:00)<br><br>Jede Zelle zeigt die <b>Gesamtzahl</b> genehmigter und erledigter Buchungen, die an diesem Tag und zu dieser Stunde über den <b>gesamten gewählten Zeitraum</b> geplant waren.<br><br><b>Beispiel:</b> Wenn du 3 Monate gewählt hast, zeigt die Zelle Montag 10:00 wie viele Buchungen an allen Montagen um 10:00 in diesen 3 Monaten zusammen stattfanden.<br><br>🟦 Dunklere Farbe = mehr Buchungen",
  reports_section_busiest_day: "Geschäftigster Wochentag",
  stats_monday: "Montag",
  stats_tuesday: "Dienstag",
  stats_wednesday: "Mittwoch",
  stats_thursday: "Donnerstag",
  stats_friday: "Freitag",
  stats_saturday: "Samstag",
  stats_sunday: "Sonntag",
  stats_mon: "Mo",
  stats_tue: "Di",
  stats_wed: "Mi",
  stats_thu: "Do",
  stats_fri: "Fr",
  stats_sat: "Sa",
  stats_sun: "So",
  reports_section_delivery_type: "Nach Liefertyp",
  reports_section_peak_times: "Beliebteste Zeiten",
  reports_bookings_by_hour: "Buchungen nach Uhrzeit",
  reports_bookings_by_service: "Top Dienstleistungen",
  reports_bookings_by_employee: "Top Teammitglieder",
  reports_booking_lead_time: "Buchungsvorlaufzeit",
  reports_bookings_by_location: "Buchungen nach Standort",
  reports_employee_performance_note:
    'Kalenderauslastung zeigt "--", wenn für dieses Teammitglied keine Arbeitszeiten festgelegt wurden.',
  reports_customer_segments_chart: "Kundensegmente",
  reports_customer_segments_note:
    "Teilt deine aktiven Kunden in drei Gruppen basierend auf der Buchungshistorie auf. Alle drei ergeben zusammen die aktiven Kunden.",
  reports_services_by_category: "Buchungen nach Kategorie",
  reports_service_ranking_note:
    "Sortiert nach Anzahl der Buchungen. Klicke auf eine Spalte, um neu zu sortieren.",
  reports_mrr_trend: "Neue Abonnements",
  reports_subscription_usage: "Abonnement-Nutzung",
  reports_subscription_usage_tooltip:
    "Nutzen deine Abonnenten die Buchungen, die in ihren Plänen enthalten sind?<br><br>• <b>Buchungslimit-Nutzung</b> — wenn ein Plan 10 Buchungen enthält und ein Kunde 3 genutzt hat, sind das 30%. Das ist der Durchschnitt aller Abonnenten.<br>• <b>Ungenutzte Buchungen</b> — die Gesamtzahl der enthaltenen Buchungen, die niemand genutzt hat. Eine hohe Zahl bedeutet, dass Abonnenten verfügbare Buchungen verschwenden.",
  stats_revenue: "Umsatz",
  stats_bookings: "Buchungen",
  stats_subscriptions: "Abonnements",
  stats_products: "Produkte",
  stats_new_customers: "Neue Kunden",
  stats_cancellation_rate: "Stornoquote",
  stats_avg_booking_value: "Durchschn. Buchungswert",
  stats_total_revenue: "Gesamtumsatz",
  stats_from_bookings: "Buchungen",
  stats_from_products: "Produkte",
  stats_from_subscriptions: "Abonnements",
  stats_active_employees: "Aktive Mitarbeiter",
  stats_team_revenue: "Teamumsatz",
  stats_schedule_fill_rate: "Kalenderauslastung",
  stats_total_booked_hours: "Gebuchte Stunden gesamt",
  stats_total_bookings: "Alle Buchungen",
  stats_approved: "Genehmigt",
  stats_done: "Erledigt",
  stats_cancelled: "Storniert",
  stats_payment: "Ausstehende Zahlung",
  stats_status: "Status",
  stats_service: "Dienstleistung",
  stats_employee: "Mitarbeiter",
  stats_delivery_type: "Lieferart",
  stats_share: "Anteil",
  stats_reason: "Grund",
  stats_cancellations: "Stornierungen",
  stats_category: "Kategorie",
  stats_location: "Standort",
  stats_type: "Typ",
  stats_provider: "Methode",
  stats_transactions: "Transaktionen",
  stats_value: "Gesamt",
  stats_product: "Produkt",
  stats_quantity: "Menge",
  stats_subscription: "Abonnement",
  stats_customer: "Kunde",
  stats_email: "E-Mail",
  stats_customers_served: "Bediente Kunden",
  stats_utilization: "Auslastung",
  stats_available_hours: "Verfügbare Stunden",
  stats_booked_hours: "Gebuchte Stunden",
  stats_unique_customers: "Einzigartige Kunden",
  stats_total_customers: "Alle Kunden",
  stats_active_customers: "Aktive Kunden",
  stats_returning_customers: "Wiederkehrende Kunden",
  stats_retention_rate: "Bindungsrate",
  stats_customer_ltv: "Kundenwert",
  stats_avg_days_between_visits: "Durchschn. Tage zw. Buchungen",
  stats_preferred_delivery: "Bevorzugter Standort",
  stats_preferred_payment: "Bevorzugte Zahlung",
  stats_total_spent: "Gesamtausgaben",
  stats_total_sold: "Gesamt verkauft",
  stats_product_revenue: "Produktumsatz",
  stats_active_subscriptions: "Aktive Abonnements",
  stats_subscription_revenue: "Abonnementumsatz",
  stats_renewal_rate: "Verlängerungsrate",
  stats_active_users: "Aktive Nutzer",
  stats_avg_utilization: "Buchungslimit-Nutzung",
  stats_booking_limit_usage: "Buchungslimit-Nutzung",
  stats_unused_booking_slots: "Ungenutzte Buchungen",
  stats_unused_bookings: "Ungenutzte Buchungen",
  stats_total_transactions: "Alle Transaktionen",
  stats_total_value: "Gesamtwert",
  stats_booking_payment_rate: "Buchungszahlungsrate",
  stats_method: "Methode",
  stats_day: "Tag",
  stats_hour: "Stunde",
  stats_busiest_day: "Aktivster Tag",
  stats_busiest_hour: "Aktivste Stunde",
  stats_average_lead_time: "Durchschn. Tage im Voraus",
  stats_median_lead_time: "Median Tage im Voraus",
  stats_month: "Monat",
  stats_projected: "Prognose",
  stats_low_estimate: "Untere Schätzung",
  stats_high_estimate: "Obere Schätzung",
  stats_period: "Zeitraum",
  stats_count: "Anzahl",
  stats_bookings_count: "Buchungen",
  stats_name: "Name",
  stats_cancellation_rate_tooltip:
    "Wie oft Buchungen storniert werden.<br><br><b>Formel:</b> storniert ÷ (genehmigt + erledigt + storniert)<br><b>Beispiel:</b> 10 Buchungen, 2 storniert = <b>20%</b>",
  stats_customer_ltv_tooltip:
    "Wie viel ein Kunde insgesamt bei dir ausgegeben hat — über die gesamte Kundengeschichte, nicht nur im gewählten Zeitraum.",
  stats_utilization_tooltip:
    "Durchschnittliche Auslastung in deinem Team. Pro Mitarbeiter: gebuchte Stunden ÷ verfügbare Stunden.<br><br><b>Verfügbare Stunden</b> ergeben sich aus dem <b>Verfügbarkeitsplan</b> des Mitarbeiters. Freie Tage und Ausnahmen werden berücksichtigt.<br><br>Beispiel: Ein Mitarbeiter arbeitet Mo–Fr, 9:00–17:00 (40 Std./Woche). Sind 30 Stunden gebucht, beträgt die Auslastung 75%.",
  stats_booking_payment_rate_tooltip:
    "Anteil der bezahlten Buchungen an allen im gewählten Zeitraum geplanten Buchungen.<br><br>Gezählt nach Leistungsdatum — eine heute für Mai erstellte Buchung erscheint im Bericht für Mai.",
  stats_renewal_rate_tooltip:
    "Wie viele Abonnenten ihren Plan nach der ersten Zahlung verlängert haben — ein Zeichen für Kundenzufriedenheit.",
  stats_average_lead_time_tooltip:
    "Wie viele Tage im Voraus Kunden durchschnittlich buchen. Hohe Zahlen bedeuten vorausschauende Planung; niedrige bedeuten Last-Minute-Buchungen.",
  stats_median_lead_time_tooltip:
    "Typische Anzahl der Tage, die Kunden im Voraus buchen. Anders als der Durchschnitt wird diese Zahl durch wenige sehr frühe oder späte Buchungen kaum beeinflusst.",
  stats_low_estimate_tooltip:
    "Das untere Ende der Prognose — deine Ergebnisse könnten auf diesem Niveau liegen, wenn der nächste Zeitraum ruhiger ist als üblich.",
  stats_high_estimate_tooltip:
    "Das obere Ende der Prognose — das optimistische Szenario für den nächsten Zeitraum.",
  stats_booking_status_tooltip:
    "Aufschlüsselung deiner Buchungen nach Status — <b>genehmigt</b>, <b>erledigt</b> und <b>storniert</b> — im gewählten Zeitraum.",
  stats_unused_booking_slots_tooltip:
    "Die Gesamtzahl der Buchungen, die Abonnenten hätten machen können (basierend auf ihren Planlimits), aber nicht gemacht haben.<br><br><b>Beispiel:</b> 3 Abonnenten haben je einen Plan mit 10 Buchungen/Monat. Einer nutzte 7, einer 3, einer 0. Das ergibt 3 + 7 + 10 = <b>20 ungenutzte Buchungen</b>.<br><br>Eine hohe Zahl könnte bedeuten, dass deine Limits zu großzügig sind oder Abonnenten eine Erinnerung zum Buchen brauchen.",
  stats_active_subscriptions_tooltip:
    "Neue Abonnements, die im gewählten Zeitraum gestartet wurden. Das ist <b>nicht</b> die Gesamtzahl aller aktiven Abonnenten.",
  stats_avg_utilization_tooltip:
    'Manche Abo-Pläne enthalten eine bestimmte Anzahl an Buchungen (z.B. "10 Buchungen pro Monat"). Das zeigt, welchen Prozentsatz dieser Buchungen deine Abonnenten tatsächlich genutzt haben.<br><br><b>Beispiel:</b> Ein Kunde kauft einen Plan mit 10 Buchungen/Monat, bucht aber nur 3 Mal → das sind 30% Nutzung.<br><br>Ein niedriger Prozentsatz bedeutet, dass Abonnenten nicht voll nutzen, wofür sie bezahlt haben. Zählt nur genehmigte und erledigte Buchungen.',
  stats_new_customers_tooltip:
    "Neue Kunden, die sich im gewählten Zeitraum registriert haben. Basierend auf dem Erstellungsdatum des Kontos.",
  stats_total_revenue_tooltip:
    "Gesamteinnahmen im gewählten Zeitraum aus:<br>• Buchungen<br>• Abonnements<br>• Produktverkäufen<br><br>Nur <b>abgeschlossene Zahlungen</b> werden gezählt, basierend auf dem Zahlungsdatum.",
  stats_from_bookings_tooltip:
    "Einnahmen aus Buchungszahlungen im gewählten Zeitraum. Nur <b>abgeschlossene Zahlungen</b> werden gezählt.",
  stats_from_products_tooltip:
    "Einnahmen aus Einmalkäufen von Produkten im gewählten Zeitraum.",
  stats_from_subscriptions_tooltip:
    "Einnahmen aus Abonnementzahlungen im gewählten Zeitraum.",
  stats_total_bookings_tooltip:
    "Gesamtzahl der Buchungen mit Status <b>genehmigt</b> und <b>erledigt</b> im gewählten Zeitraum. <b>Stornierte</b> und Buchungen mit <b>ausstehender Zahlung</b> werden nicht gezählt.",
  stats_approved_tooltip:
    "Anzahl der Buchungen mit Status <b>genehmigt</b> im gewählten Zeitraum.",
  stats_done_tooltip:
    "Anzahl der Buchungen mit Status <b>erledigt</b> im gewählten Zeitraum.",
  stats_cancelled_tooltip:
    "Buchungen, die im gewählten Zeitraum <b>storniert</b> wurden — von Kunden oder dir.",
  stats_active_employees_tooltip:
    "Teammitglieder mit mindestens einer genehmigten oder erledigten Buchung im gewählten Zeitraum.",
  stats_team_revenue_tooltip:
    "Gesamteinnahmen aus Buchungen aller Teammitglieder im gewählten Zeitraum. Nur abgeschlossene Zahlungen werden gezählt.",
  stats_schedule_fill_rate_tooltip:
    'Wie viel der verfügbaren Zeit deines Teams mit Buchungen belegt ist.<br><br><b>So rechnen wir:</b><br>1. Für jedes Teammitglied prüfen wir jeden Tag im Zeitraum<br>2. Für jeden Tag prüfen wir den Zeitplan — spezielle Datumsüberschreibungen (freie Tage, Sonderstunden) haben Vorrang vor dem Wochenplan<br>3. Wir addieren alle gebuchten Stunden (genehmigte und erledigte Buchungen)<br>4. Auslastung = gebuchte Stunden ÷ verfügbare Stunden<br>5. Wir bilden den Durchschnitt über alle Teammitglieder<br><br><b>Beispiel:</b> Anna hat 40h verfügbar, 20h gebucht → 50%. Mark hat 40h verfügbar, 30h gebucht → 75%. Durchschnitt = <b>62,5%</b><br><br>Teammitglieder ohne Zeitplan werden übersprungen. "--" bedeutet, dass niemand einen Zeitplan hat.',
  stats_total_booked_hours_tooltip:
    "Gesamtstunden, die im gewählten Zeitraum für Buchungen im gesamten Team aufgewendet wurden.",
  stats_customers_served_tooltip:
    "Anzahl verschiedener Kunden, mit denen dieses Teammitglied im gewählten Zeitraum gearbeitet hat.",
  stats_available_hours_tooltip:
    'Wie viele Stunden dieses Teammitglied im gewählten Zeitraum arbeiten konnte, basierend auf seinem Zeitplan.<br><br><b>So rechnen wir:</b> Wir prüfen jeden Tag im Zeitraum. Hat ein Tag eine spezielle Überschreibung (z.B. ein freier Tag), verwenden wir diese. Sonst gilt der reguläre Wochenplan.<br><br><b>Beispiel:</b> Mo–Fr 9:00–17:00. Zeitraum = Mo bis So → 5 Arbeitstage × 8h = <b>40h</b>. Wenn der Mittwoch als frei markiert ist, werden es 4 × 8h = <b>32h</b>.<br><br>"--" bedeutet, dass kein Zeitplan festgelegt ist.',
  stats_booked_hours_tooltip:
    "Arbeitsstunden, die tatsächlich mit Buchungen gefüllt waren, im gewählten Zeitraum.",
  stats_total_tooltip:
    "Gesamtzahl der bei dir registrierten Kunden — über die gesamte Zeit, nicht nur im gewählten Zeitraum.",
  stats_new_tooltip:
    "Kunden, die im gewählten Zeitraum zum ersten Mal gebucht haben — sie hatten vorher keine Buchungen.",
  stats_active_tooltip:
    "Kunden, die im gewählten Zeitraum mindestens eine Buchung mit Status <b>genehmigt</b> oder <b>erledigt</b> hatten.",
  stats_returning_tooltip:
    "Kunden, die bereits vor dem gewählten Zeitraum gebucht haben und im gewählten Zeitraum wiedergekehrt sind.",
  stats_ltv_tooltip:
    "Durchschnittlicher Gesamtbetrag, den ein Kunde seit seiner Registrierung ausgegeben hat — über die gesamte Zeit, nicht nur im gewählten Zeitraum.",
  stats_preferred_delivery_type_tooltip:
    "Der häufigste Standorttyp, den deine Kunden buchen — z. B. Google Meet, Adresse, Telefon oder Microsoft Teams.",
  stats_total_customers_tooltip:
    "Gesamtzahl registrierter Kunden — über die gesamte Zeit, nicht nur im gewählten Zeitraum.",
  stats_preferred_payment_method_tooltip:
    "Die Zahlungsmethode, die deine Kunden am häufigsten für Buchungen verwenden.",
  stats_active_customers_tooltip:
    "Kunden, die im gewählten Zeitraum mindestens eine Buchung hatten.",
  stats_returning_customers_tooltip:
    "Kunden, die vor dem gewählten Zeitraum gebucht haben und im Zeitraum wiedergekommen sind. Bei <b>Gesamtzeitraum</b> ist das Ergebnis 0.",
  stats_retention_rate_tooltip:
    "Wie viel Prozent der aktiven Kunden schon vorher bei dir gebucht haben.<br><br><b>Formel:</b> wiederkehrend ÷ aktiv × 100<br><b>Beispiel:</b> 10 aktive, 6 wiederkehrende = <b>60%</b>",
  stats_avg_days_between_visits_tooltip:
    "Wie viele Tage durchschnittlich zwischen den Buchungen von Kunden vergehen, die mehr als einmal kommen.",
  stats_total_sold_tooltip:
    "Anzahl der im gewählten Zeitraum verkauften Produkte.",
  stats_product_revenue_tooltip:
    "Gesamteinnahmen aus Produktverkäufen im gewählten Zeitraum.",
  stats_subscription_revenue_tooltip:
    "Gesamteinnahmen aus Abonnementzahlungen im gewählten Zeitraum.",
  stats_active_users_tooltip:
    "Abonnenten, die im gewählten Zeitraum mindestens eine Buchung mit ihrem Abonnement gemacht haben.",
  stats_total_value_tooltip:
    "Summe aller <b>abgeschlossenen</b> Zahlungstransaktionen (Buchungen, Produkte und Abonnements) im gewählten Zeitraum.",
  stats_busiest_day_tooltip:
    "Der Wochentag mit den meisten Buchungen im gewählten Zeitraum.",
  stats_busiest_hour_tooltip:
    "Die Tageszeit mit den meisten Buchungen im gewählten Zeitraum.",
  stats_peak_times_tooltip:
    "Tag und Stunde mit den meisten Buchungen mit Status <b>genehmigt</b> und <b>erledigt</b> im gewählten Zeitraum.",
  stats_bookings_by_hour_tooltip:
    "Wie sich die Buchungen auf die Tagesstunden im gewählten Zeitraum verteilen.",
  stats_bookings_by_service_tooltip:
    "Welche Dienstleistungen im gewählten Zeitraum am meisten gebucht wurden.",
  stats_bookings_by_employee_tooltip:
    "Welche Teammitglieder im gewählten Zeitraum die meisten Buchungen bearbeitet haben.",
  stats_booking_lead_time_tooltip:
    "Wie weit im Voraus Kunden buchen — die Anzahl der Tage zwischen Buchungserstellung und Buchungsdatum.",
  stats_bookings_by_location_tooltip:
    "Wie sich die Buchungen auf deine Standorte im gewählten Zeitraum verteilen.",
  stats_avg_booking_value_tooltip:
    "Der durchschnittliche Betrag pro Buchung im gewählten Zeitraum.<br><br><b>Formel:</b> Buchungsumsatz ÷ Anzahl bezahlter Buchungen",
  stats_mrr_tooltip:
    "Gesamtumsatz aus Abonnementzahlungen im gewählten Zeitraum. Zeigt die Summe aller bezahlten Abonnementtransaktionen, nicht eine normalisierte Monatsrate.",
  stats_top_clients_tooltip:
    "Deine umsatzstärksten Kunden im gewählten Zeitraum, nach Gesamtumsatz sortiert.",
  stats_top_service_tooltip:
    "Die Dienstleistung mit den meisten Buchungen im gewählten Zeitraum.",
  stats_bookings_timeline_tooltip:
    "Wie sich die Anzahl der Buchungen im gewählten Zeitraum verändert hat. Beinhaltet Buchungen mit Status <b>genehmigt</b> und <b>erledigt</b>.<br><br><b>Prognose:</b> gestrichelte Linie für kommende Zeiträume — Buchungen, die bereits geplant sind (<b>genehmigt</b> oder <b>ausstehende Zahlung</b>).",
  stats_peak_hours_heatmap_tooltip:
    "Heatmap, die zeigt, wann die meisten Buchungen stattfinden — nach Wochentag und Uhrzeit. Dunklere Felder = mehr Buchungen.",
  stats_booking_revenue_tooltip:
    "Umsatz nur aus Buchungszahlungen im gewählten Zeitraum — ohne Produktverkäufe und Abonnements.",
  stats_total_transactions_tooltip:
    "Gesamtzahl der Zahlungstransaktionen im gewählten Zeitraum, aus allen Quellen.",
  stats_revenue_timeline_tooltip:
    "Einnahmen nach Quelle aufgeschlüsselt — Buchungen, Abonnements und Produkte. Nur abgeschlossene Zahlungen, basierend auf dem Zahlungsdatum. Klicke auf Legendeneinträge, um Linien ein- oder auszublenden.<br><br><b>Prognose</b>: gestrichelte Linien zeigen prognostizierte Einnahmen — aus bereits bezahlten oder ausstehenden Buchungen sowie geschätztem Umsatz aus aktiven Abonnements.",
  stats_revenue_top_services_table_tooltip:
    "Dienstleistungen nach Umsatz im gewählten Zeitraum sortiert.",
  stats_revenue_top_products_table_tooltip:
    "Produkte nach Umsatz im gewählten Zeitraum sortiert.",
  stats_payment_providers_chart_tooltip:
    "Anzahl <b>abgeschlossener</b> Transaktionen nach Zahlungsmethode (z. B. Stripe, Bar, Karte) im gewählten Zeitraum.",
  stats_payment_methods_count_chart_tooltip:
    "Wie viele Transaktionen über jede Zahlungsmethode im gewählten Zeitraum abgewickelt wurden.",
  stats_payment_methods_value_chart_tooltip:
    "Gesamtumsatz über jede Zahlungsmethode im gewählten Zeitraum.",
  stats_booking_status_chart_tooltip:
    "Buchungen nach Status — <b>genehmigt</b>, <b>erledigt</b>, <b>storniert</b> und <b>ausstehende Zahlung</b> — im gewählten Zeitraum.",
  stats_cancellation_reasons_chart_tooltip:
    "Häufigste Gründe, warum Kunden ihre Buchungen im gewählten Zeitraum storniert haben.",
  stats_busiest_day_chart_tooltip:
    "Welche Wochentage die meisten Buchungen im gewählten Zeitraum haben.",
  stats_delivery_type_chart_tooltip:
    "Wie sich die Buchungen auf Durchführungsarten verteilen — vor Ort, online, telefonisch usw. — im gewählten Zeitraum.",
  stats_customer_segments_chart_tooltip:
    "Wie engagiert deine aktiven Kunden im gewählten Zeitraum sind:<br>• <b>Erstbesucher</b> — erste Buchung überhaupt, keine vorherige Geschichte<br>• <b>Wiedergekommen</b> — hatten vorher Buchungen, einmal in diesem Zeitraum<br>• <b>Stammkunden</b> — hatten vorher Buchungen und kamen 2+ Mal in diesem Zeitraum",
  stats_top_customers_table_tooltip:
    "Gesamtausgaben im gewählten Zeitraum — umfasst alle Zahlungen des Kunden: Buchungen, Abonnements und Produkte.",
  stats_employee_table_tooltip:
    "Leistungsübersicht für jedes Teammitglied — Buchungen, Stunden und Auslastung im gewählten Zeitraum.",
  stats_service_table_tooltip:
    "Leistungsübersicht für jede Dienstleistung — Buchungen und Umsatz im gewählten Zeitraum.",
  stats_services_by_category_tooltip:
    "Anzahl genehmigter und erledigter Buchungen pro Dienstleistungskategorie im gewählten Zeitraum.",
  stats_booking_revenue_timeline_tooltip:
    "Wie sich der Buchungsumsatz im gewählten Zeitraum verändert hat.",
  stats_subscription_revenue_timeline_tooltip:
    "Wie sich der Abonnementumsatz im gewählten Zeitraum verändert hat.",
  stats_product_revenue_timeline_tooltip:
    "Wie sich der Produktumsatz im gewählten Zeitraum verändert hat.",
  stats_subscription_timeline_tooltip: "Anzahl neuer Abonnements pro Zeitraum.",
  stats_top_subscriptions_table_tooltip:
    "Abonnement-Pläne nach Umsatz im gewählten Zeitraum sortiert.",
  stats_top_products_table_tooltip:
    "Produkte nach Umsatz im gewählten Zeitraum sortiert.",
  stats_not_assigned: "Nicht zugewiesen",
  stats_low: "Niedrig",
  stats_medium: "Mittel",
  stats_high: "Hoch",
  stats_insufficient: "Unzureichende Daten",
  stats_type_name: "Lieferart",
  stats_new_subscriptions: "Neue Abonnements",
  stats_new: "Neu",
  stats_returning: "Wiederkehrend",
  stats_first_time: "Erstbesucher",
  stats_first_time_tooltip:
    "Kunden ohne Buchungen vor dem gewählten Zeitraum — das ist ihr erster Besuch.",
  stats_came_back: "Wiedergekommen",
  stats_came_back_tooltip:
    "Kunden, die vorher Buchungen hatten und einmal in diesem Zeitraum gebucht haben.",
  stats_loyal: "Stammkunden",
  stats_loyal_tooltip:
    "Kunden, die vorher Buchungen hatten und 2+ Mal in diesem Zeitraum gebucht haben.",
  stats_staff: "Mitarbeiter",
  stats_payment_timeout: "Zahlungszeitüberschreitung",
  stats_calendar_sync: "Kalender-Synchronisation",
  stats_in_person: "Adresse",
  stats_phone: "Telefon",
  stats_other: "Andere",
  stats_stripe: "Stripe",
  stats_cash: "Bar",
  stats_card: "Karte",
  stats_transfer: "Überweisung",
  stats_google_meet: "Google Meet",
  stats_zoom: "Zoom",
  stats_microsoft_teams: "Microsoft Teams",
  stats_skype: "Skype",
  stats_whatsapp: "WhatsApp",
  stats_client: "Kunde",
  stats_no_payment: "Zahlungszeitüberschreitung",
  stats_external: "Kalender-Synchronisation",
  bulk_operation_progress: "Verarbeitung: @{done} von @{total}",
  bulk_operation_counting: "Datensätze werden gezählt...",
  bulk_action_delete_events: "Ereignisse löschen",
  bulk_action_delete_users: "Benutzer löschen",
  bulk_action_update_users: "Benutzer aktualisieren",
  bulk_action_export_users: "Benutzer exportieren",
  bulk_action_add_to_group: "Zu Gruppen hinzufügen",
  bulk_action_remove_from_group: "Aus Gruppen entfernen",
  bulk_action_send_notification: "Benachrichtigungen senden",
  bulk_action_update_bookings: "Buchungen aktualisieren",
  bulk_action_export_events: "Ereignisse exportieren",
  bulk_action_export_unavailable_booking_slots: "Kalendersperren exportieren",
  bulk_action_update_employees: "Mitarbeiter aktualisieren",
  bulk_action_delete_employees: "Mitarbeiter löschen",
  bulk_action_delete_resources: "Ressourcen löschen",
  bulk_action_delete_tags: "Etiketten löschen",
  bulk_action_delete_groups: "Gruppen löschen",
  bulk_action_delete_locations: "Standorte löschen",
  bulk_action_delete_availability_schedules: "Verfügbarkeitspläne löschen",
  bulk_action_delete_subscriptions: "Abonnements löschen",
  bulk_action_delete_store_products: "Produkte löschen",
  bulk_action_delete_store_transactions: "Transaktionen löschen",
  bulk_action_delete_user_subscriptions: "Kundenabonnements löschen",
  bulk_action_cancel_user_subscriptions: "Kundenabonnements kündigen",
  bulk_action_delete_newsletter: "Newsletter-Adressen löschen",
  bulk_action_export_newsletter: "Newsletter exportieren",
  bulk_action_delete_websites: "Webseiten löschen",
  bulk_action_disable_websites: "Webseiten deaktivieren",
  bulk_action_delete_mobile_apps: "Mobile Apps löschen",
  bulk_action_export_employees: "Mitarbeiter exportieren",
  bulk_notification_sending: "Benachrichtigungen werden gesendet...",
  bulk_export_generating: "Datei wird generiert...",
  bulk_export_sent_to_email: "Datei wurde an Ihre E-Mail gesendet",
  bulk_export_sent_to_email_with_errors:
    "Datei wurde an Ihre E-Mail gesendet. Verarbeitet: @{processed}, Fehler: @{failed}.",
  download_csv: "CSV herunterladen",
  selection_all_on_page:
    "Alle @{amount} Einträge auf dieser Seite sind ausgewählt.",
  selection_select_all_records:
    "Alle @{total} Einträge auf allen Seiten auswählen",
  selection_all_records_selected:
    "Alle @{total} Einträge auf allen Seiten sind ausgewählt.",
  your_overview: "Deine Übersicht",
  add_widget: "Widget hinzufügen",
  widget_group_revenue: "Umsatz",
  widget_group_bookings: "Buchungen",
  widget_group_clients: "Kunden",
  widget_group_team: "Mein Team",
  widget_group_subscriptions: "Abonnements",
  widget_group_products: "Produkte",
  widget_revenue_kpi: "Umsatz",
  widget_bookings_kpi: "Buchungen",
  widget_new_clients_kpi: "Neue Kunden",
  widget_cancellation_rate: "Stornoquote",
  widget_top_clients: "Top-Kunden",
  widget_peak_hours_heatmap: "Stoßzeiten",
  widget_avg_booking_value: "Durchschn. Buchungswert",
  widget_payment_method: "Bevorzugte Zahlungsmethode",
  widget_bookings_timeline: "Buchungen im Zeitverlauf",
  widget_booking_status: "Buchungsstatus",
  widget_busiest_day: "Aktivster Tag",
  widget_busiest_hour: "Aktivste Stunde",
  widget_avg_lead_time: "Durchschn. Vorlaufzeit",
  widget_active_clients: "Aktive Kunden",
  widget_retention_rate: "Bindungsrate",
  widget_employee_utilization: "Terminauslastung",
  widget_top_service: "Top-Dienstleistung",
  widget_active_subscriptions: "Aktive Abonnements",
  widget_mrr: "Aboeinnahmen",
  widget_product_revenue: "Produktumsatz",
  widget_booking_revenue: "Buchungsumsatz",
  widget_total_transactions: "Alle Transaktionen",
  widget_payment_conversion: "Buchungszahlungsrate",
  widget_revenue_timeline: "Umsatz im Zeitverlauf",
  widget_revenue_top_services_table: "Top Dienstleistungen nach Umsatz",
  widget_revenue_top_products_table: "Top Produkte nach Umsatz",
  widget_payment_providers_chart: "Zahlungsmethoden",
  widget_booking_status_chart: "Buchungsstatus-Verteilung",
  widget_cancellation_reasons_chart: "Stornierungsgründe",
  widget_busiest_day_chart: "Buchungen nach Wochentag",
  widget_delivery_type_chart: "Verteilung nach Durchführungsart",
  widget_customer_segments_chart: "Kundensegmente",
  widget_top_customers_table: "Top Kunden (vollständige Tabelle)",
  widget_employee_table: "Mitarbeiterleistung",
  widget_service_table: "Dienstleistungsübersicht",
  widget_subscription_timeline: "Neue Abonnements im Zeitverlauf",
  widget_subscription_revenue_timeline: "Abonnementumsatz im Zeitverlauf",
  widget_top_subscriptions_table: "Top Abonnement-Pläne",
  widget_product_revenue_timeline: "Produktumsatz im Zeitverlauf",
  widget_top_products_table: "Top Produkte",
  widget_booking_revenue_timeline: "Buchungsumsatz im Zeitverlauf",
  widget_bookings_by_service_table: "Buchungen nach Dienstleistung",
  widget_bookings_by_employee_table: "Top Teammitglieder",
  widget_bookings_by_hour_chart: "Buchungen nach Uhrzeit",
  widget_locations_table: "Buchungen nach Standort",
  widget_total_clients: "Alle Kunden",
  widget_customer_ltv: "Kundenwert (LTV)",
  widget_returning_clients: "Wiederkehrende Kunden",
  widget_avg_days_between_visits: "Durchschn. Tage zwischen Besuchen",
  widget_first_time_clients: "Erstkunden",
  widget_loyal_clients: "Treue Kunden",
  widget_services_by_category_chart: "Buchungen nach Kategorie",
  widget_renewal_rate: "Verlängerungsrate",
  widget_subscription_utilization: "Abo-Auslastung",
  widget_unused_booking_slots: "Ungenutzte Buchungsplätze",
  widget_total_products_sold: "Verkaufte Produkte",
  restore_defaults: "Standard wiederherstellen",
  restore_defaults_warning:
    "Dadurch wird dein Dashboard auf die Standard-Widgets zurückgesetzt. Dein aktuelles Layout geht verloren.",
  drag_to_reorder: "Zum Neuordnen ziehen",
  tooltip_add_widget: "Neues Widget zum Dashboard hinzufügen",
  tooltip_edit_layout: "Widgets neu anordnen oder entfernen",
  tooltip_restore_defaults: "Standard-Widget-Layout wiederherstellen",
  tooltip_save_layout: "Aktuelles Widget-Layout speichern",
  tooltip_remove_widget: "Dieses Widget entfernen",
  add_more_widgets: "Weitere Widgets hinzufügen",
  all_time: "Gesamtzeitraum",
  remove_from_group: "Aus Gruppe entfernen",
  change_status_to_approved: "Als genehmigt setzen",
  change_status_to_payment: "Als ausstehende Zahlung setzen",
  change_status_to_cancelled: "Als storniert setzen",
  change_status_to_done: "Als erledigt setzen",
  bulk_operation_already_active:
    "Du hast bereits einen aktiven Massenvorgang. Bitte warte, bis er abgeschlossen ist.",
  go_to_fakturownia: "Zu den eFakturierung-Einstellungen",
  invoice_no_integration_tooltip:
    "Rechnung aktiviert, aber die eFakturierung-Integration ist nicht aktiv",
  affiliate: "Empfehlungsprogramm",
  affiliate_page_title: "Empfehlungsprogramm",
  affiliate_join_title: "Am Empfehlungsprogramm teilnehmen",
  affiliate_join_description:
    "Teile deinen Link und verdiene für jeden neuen Kunden, der Calendesk abonniert.",
  affiliate_accept_terms: "Ich akzeptiere die Teilnahmebedingungen",
  affiliate_terms_link_text: "Teilnahmebedingungen lesen",
  affiliate_join_button: "Jetzt teilnehmen",
  affiliate_balance_title: "Empfehlungsguthaben",
  affiliate_link_title: "Dein Empfehlungslink",
  affiliate_link_description:
    "Teile diesen Link, um neue Kunden zu empfehlen und zu verdienen.",
  affiliate_copy_link: "Link kopieren",
  affiliate_link_copied: "Link in die Zwischenablage kopiert!",
  affiliate_request_payout: "Auszahlung anfordern",
  affiliate_payout_method_title: "Auszahlungsmethode wählen",
  affiliate_payout_balance_credit: "Guthabengutschrift",
  affiliate_payout_balance_credit_description:
    "Verwende deine Einnahmen als Gutschrift für dein Abonnement.",
  affiliate_payout_bank_transfer: "Banküberweisung",
  affiliate_payout_bank_transfer_info:
    "Für eine Banküberweisung (min. {minAmount} netto) sende nach dem Absenden eine Rechnung an support@calendesk.com.",
  affiliate_payout_bank_transfer_below_min:
    "Eine Banküberweisung braucht mindestens {minAmount}. Verdiene noch ein bisschen mehr oder nutze die Guthaben-Option.",
  affiliate_payout_confirm: "Auszahlung bestätigen",
  affiliate_payout_success: "Auszahlungsantrag erfolgreich eingereicht.",
  affiliate_join_success: "Du nimmst jetzt am Empfehlungsprogramm teil.",
  affiliate_no_referrals:
    "Noch keine Empfehlungen. Teile deinen Link, um zu verdienen!",
  affiliate_no_payouts: "Noch keine Transaktionen.",
  affiliate_referrals_title: "Empfehlungen",
  affiliate_payouts_title: "Transaktionsverlauf",
  affiliate_status_pending: "Ausstehend",
  affiliate_status_rewarded: "Belohnt",
  affiliate_status_rejected: "Abgelehnt",
  affiliate_status_approved: "Genehmigt",
  affiliate_status_completed: "Abgeschlossen",
  affiliate_payout_method_balance: "Guthabengutschrift",
  affiliate_payout_method_bank: "Banküberweisung",
  affiliate_payout_method_adjustment: "Korrektur",
  affiliate_welcome_bonus_banner:
    "Du hast einen Willkommensbonus! {amount} Rabatt auf dein erstes Abonnement.",
  affiliate_welcome_bonus_applied: "Willkommensbonus: -{amount}",
  affiliate_welcome_bonus_plan_note: "-{amount} auf die erste Zahlung",
  first_payment: "Erste Zahlung",
  affiliate_welcome_bonus_dashboard_title:
    "Auf dich wartet ein Willkommensbonus",
  affiliate_welcome_bonus_dashboard_description:
    "Sichere dir {amount} Rabatt auf dein erstes Calendesk-Abo.",
  affiliate_welcome_bonus_dashboard_cta: "Plan wählen",
  affiliate_column_tenant: "Kunde",
  affiliate_column_registered: "Registriert",
  affiliate_column_subscribed: "Abonniert",
  affiliate_column_status: "Status",
  affiliate_column_reward: "Belohnung",
  affiliate_column_date: "Datum",
  affiliate_column_amount: "Betrag",
  affiliate_column_method: "Typ",
  affiliate_column_note: "Grund",
  affiliate_modal_headline: "Verdiene durch Empfehlungen von Calendesk",
  affiliate_modal_cta_dismiss: "Vielleicht später",
  affiliate_accept_terms_with_link_prefix: "Ich akzeptiere die",
  affiliate_accept_terms_with_link_anchor: "Teilnahmebedingungen",
  affiliate_total_earned: "Gesamteinnahmen",
  affiliate_total_paid: "Ausgezahlt",
  affiliate_hero_badge_new: "NEU",
  affiliate_hero_badge_label: "Empfehlungsprogramm für dein Business",
  affiliate_hero_headline_main: "Teile deinen Link. Verdiene an jeder",
  affiliate_hero_headline_accent: "Buchung.",
  affiliate_hero_subhead:
    "Jeder neue Kunde, den du bringst, bringt dir eine Provision, automatisch ausgezahlt. Alles siehst du live in deinem Calendesk-Panel.",
  affiliate_hero_cta_primary: "Am Programm teilnehmen",
  affiliate_hero_cta_secondary: "AGB ansehen",
  affiliate_hero_headline:
    "Empfiehl Calendesk: 50 PLN für dich und 50 PLN für das neue Unternehmen!",
  affiliate_hero_lead:
    "Stimme den AGB zu, tritt dem Programm bei und hol dir deinen Empfehlungslink. Für jeden Kunden, der ein Calendesk-Konto eröffnet und ein Abo bezahlt, bekommst du eine Prämie. Auch das empfohlene Unternehmen profitiert: es bekommt einen Willkommensbonus.",
  affiliate_hero_fine_print:
    "Laufzeit 01.04.2026 – 31.03.2028. Grenze von 2.000 PLN brutto für Teilnehmer ohne angemeldetes Gewerbe. Abrechnung in PLN, USD, EUR oder GBP.",
  affiliate_reward_you_label: "Du bekommst",
  affiliate_reward_you_amount: "50 PLN",
  affiliate_reward_you_suffix: "netto",
  affiliate_reward_you_note: "für jedes neue Unternehmen bei Calendesk",
  affiliate_reward_new_label: "Das neue Unternehmen bekommt",
  affiliate_reward_new_amount: "50 PLN",
  affiliate_reward_new_suffix: "netto",
  affiliate_reward_new_note: "Rabattcode für das Calendesk-Abonnement",
  affiliate_preview_copy: "Kopieren",
  affiliate_preview_saldo_label: "Guthaben · dieser Monat",
  affiliate_preview_delta: "+7 Empfehlungen",
  affiliate_preview_last_reward_title: "Letzte Prämie",
  affiliate_preview_paid_out: "Ausgezahlt",
  affiliate_preview_recent_title: "Letzte Empfehlungen",
  affiliate_preview_recent_count: "7 diesen Monat",
  affiliate_preview_col_business: "Unternehmen",
  affiliate_preview_col_reward: "Prämie",
  affiliate_preview_col_status: "Status",
  affiliate_preview_status_reward: "PRÄMIE",
  affiliate_preview_status_30days: "30 TAGE",
  affiliate_hero_preview_link_title: "Dein Empfehlungslink",
  affiliate_hero_preview_link_description:
    "Teile ihn mit Kunden und Freunden. Die Provision gehört dir.",
  affiliate_hero_preview_this_month: "Diesen Monat",
  affiliate_hero_preview_trend: "+34% vs. Vormonat",
  affiliate_hero_preview_recent_title: "Letzte Empfehlungen",
  affiliate_hero_preview_recent_count: "12 diesen Monat",
  affiliate_hero_sample_data:
    "Beispieldaten. Deine echten Zahlen erscheinen nach dem Beitritt.",
  affiliate_hero_preview_label: "Vorschau",
  affiliate_announcement_title:
    "Schnappt euch je 50 PLN: du und deine Freunde!",
  affiliate_announcement_description:
    "Teile deinen Link. Sobald ein neues Unternehmen ein Abo bezahlt, bekommt ihr beide je 50 PLN.",
  affiliate_announcement_description_2:
    "Die Prämie zahlst du dir per Überweisung aus oder nutzt sie für dein eigenes Calendesk-Konto.",
  affiliate_announcement_cta_learn_more: "Mehr erfahren",
  affiliate_announcement_cta_dismiss: "Vielleicht später",
  affiliate_hero_benefit_1:
    "Verdiene an jedem neuen Abo. Unbegrenzte Empfehlungen*",
  affiliate_hero_benefit_2:
    "Das empfohlene Unternehmen erhält einen Rabattcode aufs Abo",
  affiliate_hero_benefit_3: "Live-Tracking deiner Empfehlungen im Panel",
  affiliate_suspended_title: "Dein Affiliate-Programm ist pausiert",
  affiliate_suspended_message:
    "Neue Auszahlungen sind gestoppt und das Calendesk-Team prüft dein Konto. Bei Fragen melde dich beim Support.",
  affiliate_rejection_cancelled_before_30d:
    "Empfohlener Kunde hat vor Ablauf der 30-Tage-Qualifizierung gekündigt.",
  affiliate_rejection_duplicate_tenant:
    "Empfohlener Kunde war bereits als Duplikat im System.",
  affiliate_rejection_fraud:
    "Als nicht autorisierte oder betrügerische Empfehlung markiert.",
  affiliate_rejection_lifetime_cap_exceeded:
    "Dein Programm hat das Lebenszeit-Verdienstlimit erreicht.",
  affiliate_rejection_note_label: "Hinweis vom Support:",
  affiliate_leave_program: "Affiliate-Programm verlassen",
  affiliate_leave_dialog_title: "Affiliate-Programm verlassen?",
  affiliate_leave_dialog_warning:
    "Du sammelst keine neuen Belohnungen mehr und dein Affiliate-Link funktioniert nicht mehr.",
  affiliate_leave_dialog_rejoin_hint:
    "Du kannst jederzeit zurückkommen. Dein Code und deine Historie bleiben gespeichert.",
  affiliate_leave_dialog_confirm: "Programm verlassen",
  affiliate_leave_success: "Du hast das Affiliate-Programm verlassen.",
  affiliate_preview_copy_locked:
    "Akzeptiere die Teilnahmebedingungen und tritt dem Programm bei, um deinen Link zu erstellen.",
  affiliate_code_title: "Dein Empfehlungscode",
  affiliate_code_description:
    "Kunden können diesen Code beim Kauf ihres ersten Abonnements eingeben.",
  affiliate_copy_code: "Code kopieren",
  affiliate_code_copied: "Code in die Zwischenablage kopiert!",
  affiliate_terms_title: "Deine Konditionen",
  affiliate_terms_description:
    "Individuelle Konditionen, vereinbart mit Calendesk. Sie haben Vorrang vor den Standardbedingungen des Programms.",
  affiliate_terms_reward_monthly: "Belohnung pro Kunde mit Monatsplan",
  affiliate_terms_reward_yearly: "Belohnung pro Kunde mit Jahresplan",
  affiliate_terms_amount_net: "{amount} netto",
  affiliate_terms_percent_yearly:
    "{percent}% dessen, was der Kunde im ersten Jahr netto zahlt",
  affiliate_terms_percent_monthly:
    "{percent}% dessen, was der Kunde in den ersten 3 Monaten netto zahlt",
  affiliate_terms_discount: "Rabatt für den Kunden",
  affiliate_terms_discount_value: "{amount} auf die erste Abozahlung",
  affiliate_terms_qualification: "Qualifizierungszeitraum",
  affiliate_terms_qualification_value:
    "{days} Tage ab der ersten Zahlung des Kunden",
  affiliate_terms_payout: "Auszahlung",
  affiliate_terms_payout_value:
    "Ab {amount} netto, per Überweisung gegen deine Rechnung",
  affiliate_terms_own_tax_id:
    "Der Kunde kauft das Abonnement mit eigenen Daten und eigener Steuernummer. Ein Konto, das mit deiner Steuernummer oder mit einer Steuernummer bezahlt wird, die schon gezahlt hat, bringt keine Belohnung.",
  affiliate_contact_title: "Dein Ansprechpartner bei Calendesk",
  affiliate_contact_description:
    "Fragen zu Konditionen, Kunden oder Auszahlungen? Schreib deinem Ansprechpartner.",
  affiliate_column_plan: "Plan",
  affiliate_column_source: "Quelle",
  affiliate_column_qualifies_at: "Qualifiziert am",
  affiliate_plan_month: "Monatlich",
  affiliate_plan_year: "Jährlich",
  affiliate_source_link: "Link",
  affiliate_source_code: "Code",
  affiliate_source_admin: "Von Calendesk hinzugefügt",
  affiliate_rejection_cancelled_before_qualification:
    "Empfohlener Kunde hat vor Ende des Qualifizierungszeitraums gekündigt.",
  affiliate_rejection_refunded:
    "Die Zahlung des empfohlenen Kunden wurde erstattet.",
  affiliate_rejection_not_covered_by_payments:
    "Die Nettozahlungen des Kunden im Qualifizierungszeitraum lagen unter der Belohnung.",
  affiliate_rejection_returning_customer:
    "Der Kunde hat schon früher für Calendesk bezahlt (gleiche E-Mail-Adresse oder Steuernummer).",
  affiliate_rejection_partner_account:
    "Das Konto gehört einem Calendesk-Partner oder wurde mit deiner Steuernummer bezahlt.",
  fakturownia_department_id_title: "Abteilungs-ID",
  fakturownia_department_id_hint:
    "Leer lassen, um die Standardabteilung zu verwenden.",
  fakturownia_department_id_description:
    "Numerische ID der InvoiceOcean-Abteilung, die Rechnungen aus Calendesk ausstellen soll. Jede Abteilung kann eigene Verkäuferdaten und Standardhinweise haben — praktisch, wenn ein InvoiceOcean-Konto mehrere Vertriebskanäle bedient (z. B. Shopify + Calendesk).",
  fakturownia_additional_settings_title: "Zusätzliche Einstellungen",
  fakturownia_additional_settings_subtitle:
    "Diese Felder sind optional und für eine Standardintegration nicht erforderlich. Fülle sie nur aus, wenn du anpassen möchtest, wie Rechnungen ausgestellt werden.",
  fakturownia_credentials_error:
    "Verbindung zu InvoiceOcean fehlgeschlagen. Prüfe API-Token und Konto-URL.",
  fakturownia_department_id_single_hint:
    "Dein InvoiceOcean-Konto hat nur eine Abteilung. Lege eine weitere Abteilung in InvoiceOcean an, um Rechnungen separat zu leiten.",
  fakturownia_department_id_no_results:
    "Keine Abteilungen in diesem InvoiceOcean-Konto gefunden.",
  google_calendar_auth_error:
    "Google Kalender konnte nicht verbunden werden, da der Zugriff verweigert oder nicht alle erforderlichen Berechtigungen erteilt wurden. Bitte versuche es erneut und erlaube den Zugriff auf deinen Kalender.",
  outlook_calendar_auth_error:
    "Outlook-Kalender konnte nicht verbunden werden, da der Zugriff verweigert oder nicht alle erforderlichen Berechtigungen erteilt wurden. Bitte versuche es erneut und erlaube den Zugriff auf deinen Kalender.",
  gov_status_demo_ok: "Demo (akzeptiert)",
  availability_status: "Status",
  availability_period: "Zeitraum",
  availability_status_active: "Aktiv",
  availability_status_active_tooltip:
    "Dieser Zeitplan ist derzeit aktiv und mindestens einem Mitarbeiter oder einer Dienstleistung zugewiesen.",
  availability_status_planned: "Geplant",
  availability_status_planned_tooltip:
    "Dieser Zeitplan wird auf Basis des Zuweisungszeitraums zu einem zukünftigen Datum aktiv.",
  availability_status_inactive: "Inaktiv",
  availability_status_inactive_tooltip:
    "Dieser Zeitplan war in der Vergangenheit aktiv, aber sein Zuweisungszeitraum ist bereits abgelaufen.",
  availability_status_unassigned: "Nicht zugewiesen",
  availability_status_unassigned_tooltip:
    "Dieser Zeitplan ist keinem Mitarbeiter oder keiner Dienstleistung zugewiesen.",
  availability_period_none: "–",
  availability_period_indefinite: "Unbefristet",
  availability_period_various: "Verschiedene Zeiträume",
  availability_period_no_start: "Seit Beginn",
  availability_period_no_end: "Unbefristet",
  availability_period_assigned_to: "Zugewiesen an",
  edit_schedule: "Zeitplan bearbeiten",
  services_and_categories: "Dienstleistungen und Kategorien",
  included_in_selected_category: "In der ausgewählten Kategorie enthalten",
  availability_schedule_color: "Farbe des Plans",
  availability_schedule_color_tooltip:
    "Farbe des Plans in der Verfügbarkeitsvorschau. Legen Sie sie fest, um Pläne leichter zu unterscheiden, wenn ein Mitarbeiter oder eine Dienstleistung mehrere hat.",
  employee_color_tooltip:
    "Mit dieser Farbe werden die Buchungen des Mitarbeiters im Kalender markiert. Legen Sie sie fest, um Buchungen auf einen Blick zuzuordnen.",
  availability_period_from: "Startdatum",
  availability_period_to: "Enddatum",
  availability_period_no_end_date: "Kein Enddatum",
  availability_period_no_start_date: "Kein Startdatum",
  availability_period_days: "@{count} Tage",
  availability_period_day_one: "1 Tag",
  availability_assign_type_locked:
    "Dieser Zeitplan ist bereits einem anderen Zieltyp (Mitarbeiter oder Dienste) zugeordnet. Das Mischen von Typen ist nicht erlaubt.",
  availability_overlap_title: "Überlappende Zeiträume",
  availability_schedules: "Verfügbarkeitspläne",
  availability_calendar_preview: "Zeitplan-Übersicht",
  availability_calendar_select_target:
    "Wählen Sie ein Ziel aus, um die Vorschau anzuzeigen.",
  availability_calendar_no_schedule: "Kein Zeitplan",
  availability_calendar_day_off: "Freier Tag",
  availability_exception_hours_prefilled:
    "Die Stunden wurden aus deinem Standard-Zeitplan für diesen Wochentag übernommen. Du kannst sie nur für diese Ausnahme anpassen.",
  availability_schedule_created:
    "Zeitplan erstellt. Weise ihn Mitarbeitern oder Dienstleistungen zu, damit Kunden buchen können.",
  availability_exception_day_off:
    "Freier Tag – basierend auf der Standardwoche. Fügen Sie Stunden hinzu, um diesen Tag verfügbar zu machen.",
  availability_calendar_show_for: "Verfügbarkeit anzeigen für",
  availability_preview_info:
    "Die Vorschau zeigt, welcher Zeitplan an welchem Tag gilt und welche Stunden sich daraus ergeben. Freie Termine für Kunden finden Sie im Buchungskalender.",
  availability_view_team: "Teamplan",
  availability_view_year: "Jahr",
  availability_view_month: "Monat",
  availability_test_info:
    "Teste die Verfügbarkeit so, wie Kunden sie sehen: wähle Standort, Leistung und Mitarbeiter. Die freien Termine stammen aus derselben Buchungslogik wie deine Buchungsseite.",
  availability_test_location_online: "Online",
  availability_test_location_phone: "Telefon",
  availability_test_no_location: "Ohne Standort",
  availability_test_any_employee: "Beliebiger Mitarbeiter",
  availability_test_variant: "Variante",
  availability_view_day: "Tag",
  availability_view_week: "Woche",
  availability_test_morning: "Vormittag",
  availability_test_afternoon: "Nachmittag",
  availability_test_evening: "Abend",
  availability_test_free_slots: "freie Termine",
  availability_test_available_employees: "verfügbare Mitarbeiter",
  availability_test_first_slot: "nächster Termin",
  availability_test_no_slots: "Keine Termine",
  availability_test_none_short: "Keine",
  availability_test_pick_service:
    "Wähle eine Leistung, um die Verfügbarkeit zu testen",
  availability_test_unbookable:
    "Kunden sehen hier keine Uhrzeit. Prüfe den Zeitplan des Mitarbeiters im Reiter Zeitplan-Übersicht oder seine Arbeitszeiten.",
  availability_test_week_hint:
    "Eine ganze Zeile ohne Termine bedeutet, dass der Mitarbeiter die ganze Woche nicht buchbar ist.",
  availability_preview_profile_hours_info:
    "Diesem Mitarbeiter ist kein Zeitplan zugewiesen. Es gelten die im Profil festgelegten Arbeitszeiten (alte Version des Arbeitsplans).",
  availability_preview_profile_hours_short: "Arbeitszeiten aus dem Profil",
  availability_preview_service_fallback_info:
    "Diese Dienstleistung hat keinen eigenen Zeitplan. Die Termine ergeben sich aus den Zeitplänen der Mitarbeiter, die sie ausführen.",
  availability_preview_service_fallback_short: "Zeitpläne der Mitarbeiter",
  previous_month: "Vorheriger Monat",
  next_month: "Nächster Monat",
  availability_calendar_no_availability_hint:
    "Dieser Tag liegt außerhalb des Zeitplans. Kunden sehen hier keine freien Termine.",
  availability_period_title: "Gültigkeitszeitraum",
  availability_period_dialog_info:
    "Legen Sie den Zeitraum fest, in dem der Zeitplan für diese Zuweisung gilt. Innerhalb eines einzelnen Mitarbeiters oder einer einzelnen Dienstleistung dürfen sich die Zeitplanzeiträume nicht überschneiden.",
  availability_set_period: "Gültigkeitszeitraum festlegen",
  availability_set_period_assign_first:
    "Weisen Sie den Zeitplan zuerst Mitarbeitern oder Dienstleistungen zu",
  availability_timeline_caption_single:
    "Zeitachse der Zeitpläne dieser Zuweisung (@{year})",
  availability_timeline_caption_multi_employees:
    "Zeitachse für @{count} ausgewählte Mitarbeiter (@{year})",
  availability_timeline_caption_multi_services:
    "Zeitachse für @{count} ausgewählte Dienstleistungen (@{year})",
  availability_overlap_days: "Überschneidende Tage",
  availability_today_short: "heute",
  availability_schedule_label: "Zeitplan",
  availability_overlap_conflict_target:
    "„@{target}“ hat in diesem Zeitraum bereits den Zeitplan „@{name}“ (@{from} – @{to}).",
  availability_overlap_resolve_hint:
    "Ändern Sie diesen Zeitraum oder verkürzen Sie die Zeiträume der oben aufgeführten Zeitpläne, um die Änderungen zu speichern.",
  copy_suffix: "(Kopie)",
  availability_schedule_duplicated: "Zeitplan wurde dupliziert",
  availability_unassign_employees_first:
    "Entfernen Sie zuerst die zugewiesenen Mitarbeiter",
  availability_unassign_services_first:
    "Entfernen Sie zuerst die zugewiesenen Dienstleistungen",
  availability_schedule_timezone_differs_info:
    "Die Zeiten in diesem Zeitplan gelten für die Zeitzone @{timezone}, nicht für deine (@{user_timezone}). Zum Beispiel ist 09:00 in diesem Zeitplan bei dir @{example}.",
  availability_timezone_previous_day: "am Vortag",
  availability_timezone_next_day: "am Folgetag",
  availability_timezone_differs_tooltip:
    "Dieser Zeitplan nutzt eine andere Zeitzone als deine (@{timezone}).",
  employee_working_hours_timezone_info:
    "Diese Zeiten gelten für die Zeitzone deines Unternehmens (@{timezone}), nicht für deine (@{user_timezone}).",
  color_group_pastel: "Pastell",
  color_group_solid: "Kräftige Farben",
  wb_settings_group_website: "Website und SEO",
  wb_settings_group_booking: "Buchungen",
  wb_settings_group_client_account: "Kundenkonto",
  wb_settings_group_header_footer: "Kopf- und Fußzeile",
  wb_settings_group_advanced: "Integrationen und Erweitert",
  wb_settings_filter: "Einstellung suchen",
  wb_settings_filter_empty: "Keine Einstellung passt zu deiner Suche.",
  wb_hide_booking_prices: "Preise in Kundenbuchungen ausblenden",
  wb_hide_booking_prices_tooltip:
    "Kunden sehen nach der Anmeldung keine Preise in ihrer Buchungsliste.",
  wb_hide_payments: "Zahlungsbereich im Kundenkonto ausblenden",
  wb_hide_payments_tooltip:
    "Angemeldete Kunden sehen weder den Zahlungsbereich, ihre Transaktionshistorie noch den Bereich der gespeicherten Karte.",
  wb_hide_profile_billing_data: "Rechnungsdaten im Kundenkonto ausblenden",
  wb_hide_profile_billing_data_tooltip:
    "Kunden können in ihren Kontoeinstellungen keine Rechnungsdaten hinterlegen. Registrierungs- und Buchungsformulare bleiben unverändert.",
  wb_hide_profile_photo_upload: "Ändern des Profilbilds deaktivieren",
  wb_hide_profile_photo_upload_tooltip:
    "Kunden können in ihrem Konto kein eigenes Profilbild hochladen.",
  wb_favicon_url_tooltip:
    "Das Symbol im Browser-Tab. Die URL kopierst du aus der Fotogalerie: Klicke auf eine Bildvorschau, unten siehst du die Adresse.",
  wb_og_image_url_tooltip:
    "Das Bild, das erscheint, wenn jemand einen Link zu deiner Website teilt, z. B. auf Facebook (og:image). Die URL kopierst du aus der Fotogalerie: Klicke auf eine Bildvorschau, unten siehst du die Adresse.",
  wb_newsletter_success_url_tooltip:
    "Die Adresse, auf die Kunden nach der Newsletter-Anmeldung weitergeleitet werden. Leer lassen, damit sie auf der Seite bleiben.",
  wb_account_activation_success_url_tooltip:
    "Die Adresse, auf die Kunden nach dem Klick auf den Aktivierungslink in der E-Mail gelangen.",
  wb_section_group_content: "Inhalt",
  wb_section_group_offer: "Angebot",
  wb_section_group_booking_flow: "Buchungsablauf",
  wb_section_group_form: "Formular",
  wb_section_group_account: "Kundenkonto",
  wb_section_group_menu: "Seiten und Navigation",
  wb_section_group_company: "Firmendaten und Social Media",
  wb_section_group_images: "Bilder und Galerie",
  wb_section_group_map: "Karte",
  wb_section_group_appearance: "Aussehen",
  wb_section_group_other: "Sonstiges",
  wb_section_group_booking_form: "Buchungsformular",
  html_editor_tooltip_fullscreen: "Vollbild",
  html_editor_tooltip_fullscreen_exit: "Vollbild beenden",
  wb_setting_tooltip_help_link: "Zum Öffnen der Anleitung klicken",
  wb_enable_discounts_tooltip:
    "Beim Bezahlen einer Buchung, eines Abos oder Produkts sehen Kunden ein Feld für einen Rabattcode. Die Codes selbst legst du in Stripe im Bereich Gutscheine an.",
  wb_enable_discounts_tooltip_url:
    "https://calendesk.com/help/how-do-you-create-discount-codes",
  wb_hide_booking_employees_tooltip:
    "Kunden sehen bei der Buchung keine Mitarbeiternamen, sie wählen nur Leistung und Termin. Diese Einstellung betrifft nur die Website, prüfe daher auch die Benachrichtigungsvorlagen im Calendesk-Panel und entferne dort die Mitarbeiterdaten, wenn Kunden sie nicht sehen sollen.",
  wb_hide_time_zone_tooltip:
    "Kunden sehen neben dem Kalender keinen Zeitzonen-Umschalter. Die Uhrzeiten erscheinen in der aus ihrem Browser erkannten Zeitzone und, falls diese nicht unterstützt wird, in der Zeitzone deines Unternehmens (@{timeZone}).",
  gdpr_fields: "Einwilligungen des Kunden",
  gdpr_field_required: "erforderliche Einwilligung",
  wb_account_title_tooltip:
    "Überschrift über den Links zum Kundenkonto in der Fußzeile. Darunter sieht der Kunde die Anmeldung und die Registrierung, und nach dem Anmelden seine Buchungen und Einstellungen.",
  wb_align_center_tooltip:
    "Setzt den Inhalt der Abschnitt in die Mitte ihrer Höhe statt an den oberen Rand. Den Unterschied siehst du vor allem in hohen Abschnitte mit wenig Text.",
  wb_any_employee_enabled_tooltip:
    "Aktiviert: Der Schritt zur Mitarbeiterauswahl füllt sich selbst mit der Option „beliebige Person“ und der Kunde geht direkt zur Terminauswahl; über „Ändern“ kann er weiterhin eine bestimmte Person auswählen. Deaktiviert: Der Kunde wählt selbst eine Person aus der Liste, in der „beliebige Person“ die erste Option ist.",
  wb_book_now_label_tooltip:
    "Dein eigener Text auf der Schaltfläche, die der Kunde klickt, um den gewählten Termin zu bestätigen. Wenn du das Feld leer lässt, zeigt die Schaltfläche die Standardbeschriftung „Buchen“.",
  wb_booking_dynamic_form_tooltip:
    "Füge dem Buchungsformular eigene Fragen hinzu, zum Beispiel ein Feld für Anmerkungen oder einen Dateianhang. Jedes Feld kannst du ausgewählten Leistungen zuordnen, dann sieht der Kunde es nur bei der Buchung dieser Leistungen.",
  wb_button_tooltip:
    "Die Schaltfläche in dieser Abschnitt. Lege ihre Beschriftung fest und die Seite, auf die der Kunde nach dem Klick kommt.",
  wb_button_size_tooltip:
    "Die Größe der Schaltflächen in der oberen Leiste deiner Website. Wähle von XS (sehr klein) bis XL (sehr groß).",
  wb_buttons_tooltip:
    "Die Schaltflächen in dieser Abschnitt. Jede hat eine eigene Beschriftung und führt den Kunden auf eine Seite, die du auswählst.",
  wb_buttons_position_tooltip:
    "Legt fest, wo die Schaltflächen in der Abschnitt stehen: am linken Rand, in der Mitte oder rechts.",
  wb_calendar_max_date_tooltip:
    "Der Kunde kann Termine höchstens bis zum gewählten Tag ansehen und buchen. Spätere Daten zeigt der Kalender gar nicht an.",
  wb_calendar_min_date_tooltip:
    "Der Kunde sieht freie Termine erst ab dem gewählten Tag. Frühere Daten lassen sich weder ansehen noch buchen, praktisch zum Beispiel, wenn die Buchung ab einem bestimmten Datum startet.",
  wb_color_bg_tooltip:
    "Die Hintergrundfarbe der meisten Abschnitte auf deiner Website. Abschnitte mit aktivierter Option „Farben invertieren“ verwenden stattdessen den zweiten Hintergrund.",
  wb_color_bg_2_tooltip:
    "Die Ersatz-Hintergrundfarbe. Sie erscheint in Abschnitten mit aktivierter Option „Farben invertieren“, sodass du auf der Seite zwei Hintergrundfarben abwechseln kannst.",
  wb_color_primary_tooltip:
    "Die Hauptfarbe deiner Website. Du siehst sie auf Schaltflächen, Links und hervorgehobenen Elementen, zum Beispiel im Buchungskalender.",
  wb_color_text_tooltip:
    "Die Textfarbe in Abschnitte mit dem ersten Hintergrund. Wähle eine Farbe, die sich deutlich vom Hintergrund abhebt, sonst ist der Text schlecht lesbar.",
  wb_color_text_2_tooltip:
    "Die Textfarbe in Abschnitte mit dem zweiten Hintergrund. Achte auf einen deutlichen Kontrast zur zweiten Hintergrundfarbe.",
  wb_column_width_tooltip:
    "Wie viel der Abschnittsbreite eine Bewertung auf dem Computer einnimmt. Gib einen Prozentwert an, zum Beispiel 50 für zwei Bewertungen nebeneinander, 33 für drei. Auf dem Handy nehmen Bewertungen immer die volle Breite ein.",
  wb_company_address_tooltip:
    "Die Adresse deiner Firma in der Fußzeile der Seite, im Kontaktbereich.",
  wb_company_email_tooltip:
    "Die E-Mail-Adresse in der Fußzeile der Seite. Mit einem Klick öffnet sich beim Kunden eine neue Nachricht an dich.",
  wb_company_name_tooltip:
    "Der Name deiner Firma in der oberen Leiste der Seite. Schreibe ihn so, wie ihn die Kunden sehen sollen.",
  wb_company_phone_tooltip:
    "Die Telefonnummer in der Fußzeile der Seite. Auf dem Handy kann der Kunde darauf tippen und dich sofort anrufen.",
  wb_company_slogan_tooltip:
    "Ein kurzer Slogan deiner Firma, sichtbar unter dem Logo in der Buchungssektion. Ein Satz, der dem Kunden sagt, was du machst.",
  wb_container_fluid_tooltip:
    "Streckt den Inhalt der Abschnitt über die volle Breite des Browserfensters. Ausgeschaltet: Der Inhalt bleibt in einer schmaleren Spalte in der Mitte, was auf großen Bildschirmen meist ruhiger wirkt.",
  wb_count_places_in_dates_tooltip:
    "Bei Gruppenleistungen sieht der Kunde neben dem Datum die Gesamtzahl der freien Plätze statt der Zahl der freien Uhrzeiten. Das funktioniert nur bei Leistungen, an denen mehr als eine Person teilnehmen kann.",
  wb_custom_code_tooltip:
    "Platz für eigenen Code, zum Beispiel ein Skript für Chat, Statistiken oder ein Werbe-Pixel. Der eingefügte Code läuft auf allen Unterseiten. Diese Option ist für Fortgeschrittene.",
  wb_cycle_tooltip:
    "Die Fotos in der Galerie wechseln von selbst, ohne Klicken. Wie schnell, stellst du im Feld „Geschwindigkeit der Änderung in Millisekunden“ ein.",
  wb_dark_mode_tooltip:
    "Stellt die gesamte Website auf dunkle Farben um. Wähle dazu dunkle Hintergründe und helle Textfarben, damit alles lesbar bleibt.",
  wb_date_label_tooltip:
    "Deine eigene Beschriftung für das Feld, in dem der Kunde den Tag der Buchung wählt, zum Beispiel „Tag des Termins wählen“.",
  wb_description_tooltip:
    "Text unter der Überschrift der Abschnitt. Beschreibe hier kurz, was du anbietest oder was der Kunde in diesem Teil der Seite findet.",
  wb_elevation_tooltip:
    "Die Stärke des Schattens unter der oberen Leiste der Website, von 0 (kein Schatten) bis 24 (starker Schatten). Der Schatten trennt die Leiste optisch vom Seiteninhalt.",
  wb_email_form_success_url_tooltip:
    "Nach dem Absenden des Formulars landet der Kunde auf der Adresse, die du hier angibst, zum Beispiel auf einer Dankesseite. Wenn du sie festlegst, wird die Meldung über das Absenden des Formulars nicht angezeigt.",
  wb_email_sent_tooltip:
    "Der Text, der nach dem Absenden anstelle des Formulars erscheint, zum Beispiel „Danke, wir melden uns bald“. Ein Kunde, den du auf eine andere Adresse weiterleitest, sieht ihn nicht.",
  wb_email_subject_tooltip:
    "Diesen Text siehst du als Betreff der E-Mail mit den Antworten aus dem Formular. Wähle etwas Wiedererkennbares, zum Beispiel „Anfrage über die Website“, damit du diese Nachrichten in deinem Postfach leicht findest.",
  wb_employee_info_label_tooltip:
    "Ein kurzer Text über der Mitarbeiterliste, zum Beispiel „Wähle die Person, bei der du buchen möchtest“. Er erscheint nur dann, wenn der Kunde etwas zu wählen hat, also wenn mehr als eine Person die Leistung ausführt.",
  wb_employee_label_tooltip:
    "Deine eigene Beschriftung für die Auswahlliste, aus der der Kunde einen Mitarbeiter wählt, zum Beispiel „Fachkraft“ oder „Therapeut“.",
  wb_employee_list_tooltip:
    "Wähle, welche Mitarbeiter in diesem Abschnitt der Seite sichtbar sein sollen. Der Kunde sieht nur die markierten Personen, in der Reihenfolge der Liste.",
  wb_employee_search_tooltip:
    "Über der Mitarbeiterliste erscheint ein Suchfeld für die Suche nach Nachnamen. Der Kunde sieht es erst dann, wenn mindestens fünf Mitarbeiter auf der Liste stehen.",
  wb_end_calendar_time_tooltip:
    "Die letzte Uhrzeit, die im Wochenkalender auf der Seite sichtbar ist. Termine nach dieser Uhrzeit werden nicht angezeigt, stelle sie so ein, dass sie deine Arbeitszeiten abdeckt.",
  wb_expand_collapse_service_panels_tooltip:
    "Die Leistungsliste ist zu Kategorien zusammengeklappt, und der Kunde klappt die Gruppe, die ihn interessiert, mit einem Klick auf. Praktisch, wenn du viele Leistungen hast und eine lange Liste unübersichtlich wird.",
  wb_facebook_tooltip:
    "Der Link zu deinem Facebook-Profil. Sobald du ihn einträgst, erscheint auf der Seite ein Facebook-Symbol, das zum Profil führt.",
  wb_features_tooltip:
    "Eine Liste von Elementen, die in dieser Abschnitt als Kacheln erscheinen, zum Beispiel die Vorteile deines Angebots oder Meinungen von Kunden. Jedes Element hat einen eigenen Titel, eine Beschreibung und ein Bild.",
  wb_forgotten_password_confirmation_modal_tooltip:
    "Einstellungen für die Meldung, die der Kunde sieht, nachdem er ein neues Passwort angefordert hat. Sie bestätigt, dass der Link zum Ändern des Passworts an die angegebene E-Mail-Adresse gegangen ist.",
  wb_forgotten_password_modal_tooltip:
    "Einstellungen für das Fenster, in dem der Kunde seine E-Mail-Adresse eingibt, um ein neues Passwort für sein Kundenkonto festzulegen.",
  wb_forgotten_password_modal_confirmation_subtitle_tooltip:
    "Der Text der Meldung, nachdem die E-Mail zur Passwortänderung verschickt wurde. Sag dem Kunden, dass der Link in seinem Postfach liegt und was er tun soll, wenn die E-Mail nicht angekommen ist.",
  wb_forgotten_password_modal_confirmation_title_tooltip:
    "Überschrift der Meldung, die der Kunde nach dem Anfordern eines neuen Passworts sieht, zum Beispiel: „Prüfe dein Postfach“",
  wb_forgotten_password_subtitle_tooltip:
    "Text unter der Überschrift des Fensters zur Passwortänderung. Erkläre dem Kunden, dass er nach Eingabe seiner E-Mail-Adresse einen Link zum Festlegen eines neuen Passworts bekommt.",
  wb_forgotten_password_title_tooltip:
    "Überschrift des Fensters, in dem der Kunde eine Passwortänderung anfordert. Halte sie kurz, zum Beispiel: „Passwort vergessen?“",
  wb_form_tooltip:
    "Stelle die Felder des Kontaktformulars zusammen, zum Beispiel ein Feld für die Nachricht, die E-Mail-Adresse oder einen Dateianhang. Alles, was der Kunde einträgt, bekommst du per E-Mail.",
  wb_form_position_tooltip:
    "Wähle, auf welcher Seite des Abschnitts das Formular steht: links oder rechts. Auf dem Handy bestimmt dieselbe Option die Reihenfolge: „links“ zeigt das Formular über dem Inhalt, „rechts“ darunter.",
  wb_gallery_distance_tooltip:
    "Der Abstand zwischen den Fotos in der Galerie, in Pixel. Sinnvoll sind 0 bis 50. Je größer der Abstand, desto schmaler werden die Fotos.",
  wb_gallery_height_tooltip:
    "Die Höhe der Galerie in Pixel, zum Beispiel 200 für einen niedrigen Streifen, 500 für eine große Galerie. Alle Fotos passen sich dieser Höhe an.",
  wb_gallery_image_number_tooltip:
    "Wie viele Fotos auf dem Computer nebeneinander zu sehen sind, bevor die Galerie weiterblättert. Meist funktionieren 1 bis 4 gut.",
  wb_gallery_mobile_image_number_tooltip:
    "Wie viele Fotos auf dem Handy nebeneinander zu sehen sind. Auf einem kleinen Bildschirm bleibst du am besten bei 1, höchstens 2.",
  wb_gallery_style_tooltip:
    "Das Aussehen der Galeriesteuerung. Stil 1 legt Pfeile und Punkte auf die Fotos, Stil 2 setzt sie unter die Galerie, Stil 3 funktioniert wie 1, aber ohne den dunklen Balken unter den Punkten.",
  wb_gallery_width_tooltip:
    "Wie viel der Abschnittsbreite die Galerie auf dem Computer einnimmt. Gib einen Prozentwert von 10 bis 100 an, zum Beispiel 50 für die halbe Breite. Auf dem Handy nimmt die Galerie immer die volle Breite ein.",
  wb_gdpr_fields_tooltip:
    "Füge die Einwilligungen hinzu, die der Kunde beim Anlegen eines Kontos ankreuzt, zum Beispiel eine Marketing-Einwilligung. Jede kannst du als Pflicht markieren. Den Text der Einwilligung und die Entscheidung des Kunden speichern wir bei seinem Konto.",
  wb_google_tag_id_tooltip:
    "Die Kennung deines Google Tag Manager Containers, zum Beispiel GTM-XXXXXX. Sobald du sie einträgst, sammelst du Statistiken zu den Besuchen und bindest Google Tools ein.",
  wb_height_tooltip:
    "Die Höhe der Abschnitt in Pixel, zum Beispiel 400 für eine niedrige Abschnitt, 700 für eine Abschnitt über den größten Teil des Bildschirms. Bei mehr Inhalt wird die Abschnitt von selbst größer.",
  wb_hide_arrows_tooltip:
    "Blendet die Pfeile zum Blättern in der Galerie aus. Aktiviere es, wenn die Fotos nur automatisch wechseln sollen.",
  wb_hide_booking_time_to_tooltip:
    "Der Kunde sieht nur die Startzeit des Termins, ohne Endzeit und Dauer. Praktisch, wenn die tatsächliche Dauer der Leistung manchmal von der im System eingestellten abweicht.",
  wb_hide_delimiters_tooltip:
    "Blendet die Punkte unter der Galerie aus, mit denen man zu einem bestimmten Foto springen kann. Die Galerie wirkt dadurch aufgeräumter.",
  wb_hide_footer_tooltip:
    "Blendet die Fußzeile am Ende aller Unterseiten aus, zusammen mit den Kontaktdaten und den Social-Media-Symbolen.",
  wb_hide_header_tooltip:
    "Blendet die obere Leiste mit Logo und Menü auf allen Unterseiten aus. Praktisch, wenn du die Seite in eine andere Website einbettest.",
  wb_hide_login_tooltip:
    "Schaltet die Anmeldung auf der ganzen Website aus. Der Kunde sieht keine Anmelde-Buttons und keine Bereiche, die erst nach dem Anmelden verfügbar sind, und erledigt alles ohne Kundenkonto.",
  wb_hide_signup_tooltip:
    "Schaltet das Anlegen neuer Kundenkonten aus. Kunden, die schon ein Konto haben, können sich weiterhin anmelden, aber niemand Neues kann sich registrieren.",
  wb_html_code_tooltip:
    "Eigener HTML-Code, der als Inhalt dieser Abschnitt angezeigt wird. Nutze ihn, wenn die fertigen Abschnitte nicht ausreichen und du etwas Eigenes einfügen willst.",
  wb_image_contain_tooltip:
    "Zeigt das ganze Foto ohne Zuschnitt, auch wenn daneben leere Ränder bleiben. Ausgeschaltet: Das Foto füllt den ganzen Rahmen, seine Ränder können aber abgeschnitten werden.",
  wb_image_height_tooltip:
    "Die Höhe des Fotos in Pixel, zum Beispiel 200. Das Foto wird an diese Höhe angepasst.",
  wb_image_hide_tooltip:
    "Schaltet das Foto in dieser Abschnitt auf allen Geräten aus. Der Inhalt nimmt den frei gewordenen Platz ein.",
  wb_image_hide_on_mobile_tooltip:
    "Blendet das Foto nur auf Handys aus, damit es auf dem kleinen Bildschirm keinen Platz wegnimmt. Auf dem Computer bleibt das Foto.",
  wb_image_margin_bottom_tooltip:
    "Der leere Abstand unter dem Foto, in Pixel. Sinnvoll sind 0 bis 50. Ein höherer Wert schiebt den Text weiter vom Foto weg.",
  wb_image_position_tooltip:
    "Die Position des Fotos im Verhältnis zum Inhalt der Abschnitt: links, rechts oder mittig, oben oder unten.",
  wb_image_rounded_tooltip:
    "Wie stark die Ecken des Fotos abgerundet sind: von scharfen Ecken über eine leichte Rundung bis zum vollen Kreis. Ein Kreis wirkt gut bei Fotos von Personen.",
  wb_image_to_right_tooltip:
    "Verschiebt das Foto rechts neben den Text. Sichtbar auf Computern; auf Handys stehen Foto und Text immer untereinander.",
  wb_image_width_tooltip:
    "Die Breite des Fotos in Pixel, maximal 1200. Auf Handys füllt das Foto immer die ganze Breite des Bildschirms.",
  wb_image_zoom_on_click_tooltip:
    "Nach einem Klick öffnet sich ein Foto aus der Galerie vergrößert auf dem ganzen Bildschirm. Der Kunde kann sich die Details ansehen.",
  wb_init_calendar_title_tooltip:
    "Die Überschrift des Bildschirms, auf dem der Kunde eine Leistung wählt, zum Beispiel „Was möchtest du buchen?“. Sie verschwindet, sobald der Kunde eine Leistung gewählt hat.",
  wb_initial_location_select_tooltip:
    "Im Feld für den Standort ist sofort der erste verfügbare Standort eingestellt, der Kunde kann ihn ändern. Ist die Option aus, muss der Kunde selbst einen Standort wählen, bevor er freie Termine sieht.",
  wb_initial_service_selection_tooltip:
    "Vor dem Kalender wählt der Kunde die Leistung auf einem eigenen Bildschirm, die Liste ist dort nach Kategorien gruppiert. Bei nur einer Leistung ohne Varianten erscheint dieser Bildschirm nicht.",
  wb_instagram_tooltip:
    "Der Link zu deinem Instagram-Profil. Sobald du ihn einträgst, erscheint auf der Seite ein Instagram-Symbol, das zum Profil führt.",
  wb_interval_tooltip:
    "Wie oft die Galerie das Foto von selbst wechselt, in Millisekunden. 1000 ist eine Sekunde; 4000 bis 8000 funktioniert meist gut. Setzt die aktivierte Option „Automatisches Umschalten“ voraus.",
  wb_interval_minutes_tooltip:
    "In welchem Abstand der Wochenkalender die nächsten Zeilen mit Uhrzeiten zeichnet, zum Beispiel alle 15 oder alle 30 Minuten. Ein kleinerer Wert bedeutet ein dichteres Raster und eine genauere Tagesansicht.",
  wb_invert_colors_tooltip:
    "Vertauscht die Farben in dieser Abschnitt: Der erste Hintergrund wird zum zweiten, und die Textfarbe passt sich entsprechend an. So hebt sich die Abschnitt von den benachbarten ab.",
  wb_latitude_tooltip:
    "Die erste der beiden Zahlen, die einen Ort auf der Karte angeben, zum Beispiel 52.2297. Öffne Google Maps, klicke mit der rechten Maustaste auf deinen Ort, und ganz oben im Menü siehst du beide Zahlen; ein Klick darauf kopiert sie in die Zwischenablage. Trag hier die erste ein, mit einem Punkt statt einem Komma.",
  wb_linkedin_tooltip:
    "Der Link zu deinem LinkedIn-Profil. Sobald du ihn einträgst, erscheint auf der Seite ein LinkedIn-Symbol, das zum Profil führt.",
  wb_location_search_tooltip:
    "Über der Standortliste erscheint ein Suchfeld für die Suche nach dem Namen. Der Kunde sieht es erst dann, wenn mindestens fünf Standorte auf der Liste stehen.",
  wb_login_modal_tooltip:
    "Einstellungen für das Fenster, in dem sich der Kunde bei seinem Kundenkonto anmeldet. Hier änderst du die Texte, die in diesem Fenster zu sehen sind.",
  wb_login_subtitle_tooltip:
    "Ein kurzer Text, den der Kunde oben im Anmeldefenster sieht, direkt unter dem Titel. Du kannst hier zum Beispiel den Kunden begrüßen oder erklären, wofür das Konto da ist.",
  wb_longitude_tooltip:
    "Die zweite der aus Google Maps kopierten Zahlen, zum Beispiel 21.0122, also die nach dem Komma. Trag sie mit einem Punkt statt einem Komma ein.",
  wb_main_pages_number_tooltip:
    "Lege fest, wie viele Seiten im oberen Menü als eigene Buttons erscheinen. Die übrigen Seiten findet der Kunde in der Ausklappliste daneben.",
  wb_map_maker_hide_tooltip:
    "Blendet die rote Markierung aus, die deinen Standort anzeigt. Die Karte wird weiterhin angezeigt, nur ohne Kennzeichnung des Ortes.",
  wb_menu_column_1_tooltip:
    "Seiten, die in der ersten Spalte der Links in der Fußzeile angezeigt werden. Der Kunde kommt mit einem Klick dorthin.",
  wb_menu_column_2_tooltip:
    "Seiten, die in der zweiten Spalte der Links in der Fußzeile angezeigt werden, neben der ersten.",
  wb_menu_title_tooltip:
    "Überschrift über der Liste der Links in der Fußzeile, zum Beispiel „Schnellzugriff“ oder „Menü“. Der Kunde sieht sie über der ersten Spalte mit Seiten.",
  wb_more_pages_button_tooltip:
    "Die Beschriftung des Buttons, der im oberen Menü die weiteren Seiten ausklappt, wenn nicht alle als eigene Reiter Platz haben.",
  wb_newsletter_input_placeholder_tooltip:
    "Der Text, der im leeren Feld für die E-Mail-Adresse im Newsletter-Abschnitt zu sehen ist, zum Beispiel „Deine E-Mail-Adresse“. Er zeigt dem Kunden, was er eintragen soll.",
  wb_newsletter_success_message_tooltip:
    "Diese Meldung erscheint auf der Seite, wenn sich ein Kunde für den Newsletter anmeldet, zum Beispiel „Schau in dein Postfach und bestätige die Anmeldung“. Der Kunde bekommt dann eine E-Mail mit einem Bestätigungslink.",
  wb_only_services_with_subscriptions_tooltip:
    "Der Kunde sieht nur die Leistungen aus seinem aktiven Abo. Achtung: ohne Abo und nach dem Abmelden ist die Liste leer.",
  wb_page_list_tooltip:
    "Wähle, welche Seiten als Menüpunkte erscheinen. Der Kunde sieht sie in der hier festgelegten Reihenfolge.",
  wb_primary_language_tooltip:
    "Die Sprache, in der Kunden deine Seite sehen, zum Beispiel die Schaltflächen, die Formulare und die Buchungsansicht.",
  wb_privacy_policy_page_tooltip:
    "Wähle die Seite mit deiner Datenschutzerklärung aus. Der Kunde öffnet sie, indem er beim Anlegen eines Kontos auf den Link im angezeigten Hinweis klickt.",
  wb_redirect_after_login_tooltip:
    "Wähle die Seite, auf der der Kunde direkt nach dem Anmelden landet, zum Beispiel die Seite mit der Terminbuchung.",
  wb_redirect_after_signup_tooltip:
    "Wähle die Seite, auf der der Kunde direkt nach dem Anlegen des Kontos landet, zum Beispiel die Seite mit der Terminbuchung.",
  wb_redirect_logo_tooltip:
    "Wähle die Seite, die sich beim Klick auf das Logo im oberen Menü öffnet. Meistens ist das die Startseite.",
  wb_regulations_page_tooltip:
    "Wähle die Seite mit deinen AGB aus. Der Kunde öffnet sie, indem er beim Anlegen eines Kontos auf den Link im Hinweis zur Annahme der AGB klickt.",
  wb_require_billing_data_tooltip:
    "Der Kunde muss Rechnungsdaten angeben, um die Buchung abzuschließen. Das funktioniert nur, wenn du die Anzeige der Rechnungsdaten im Formular eingeschaltet hast.",
  wb_require_phone_number_tooltip:
    "Der Kunde kann die Buchung ohne Telefonnummer nicht abschließen. Das funktioniert nur, wenn das Telefonfeld im Formular sichtbar ist.",
  wb_section_text_tooltip:
    "Text in der Abschnitt mit dem Formular. Erkläre dem Kunden darin, wofür das Formular ist und was nach dem Absenden passiert.",
  wb_select_date_hour_tooltip:
    "Dein eigener Text über dem Kalender mit den freien Terminen, zum Beispiel „Wähle einen passenden Termin“.",
  wb_select_date_title_label_tooltip:
    "Die Überschrift über dem Kalender in dem Schritt, in dem der Kunde Tag und Uhrzeit des Termins wählt, zum Beispiel „Termin wählen“.",
  wb_select_employees_title_label_tooltip:
    "Die Überschrift über der Mitarbeiterliste in dem Schritt, in dem der Kunde eine Person wählt, zum Beispiel „Bei wem möchtest du buchen?“.",
  wb_select_locations_title_label_tooltip:
    "Die Überschrift über der Standortliste in dem Schritt, in dem der Kunde den Ort des Termins wählt, zum Beispiel „Wo möchtest du buchen?“.",
  wb_select_services_title_label_tooltip:
    "Die Überschrift über der Leistungsliste in dem Schritt, in dem der Kunde eine Leistung wählt, zum Beispiel „Leistung wählen“.",
  wb_selected_services_tooltip:
    "Die Überschrift über der Liste der Termine, die der Kunde in den Warenkorb gelegt hat, zum Beispiel „Deine ausgewählten Termine“. Nur sichtbar, wenn der Buchungswarenkorb eingeschaltet ist.",
  wb_selection_order_tooltip:
    "Du legst fest, in welcher Reihenfolge der Kunde die Buchungsschritte durchläuft: Leistung, Standort, Mitarbeiter. Bei mehreren Standorten lohnt es sich, mit ihnen zu beginnen.",
  wb_separate_online_locations_tooltip:
    "Der Kunde wählt einen bestimmten Dienst: Google Meet, Zoom, Teams oder WhatsApp. Ohne diese Option sieht er einen einzigen Eintrag „online“ für alle Online-Treffen.",
  wb_service_label_tooltip:
    "Deine eigene Beschriftung für die Auswahlliste, aus der der Kunde eine Leistung wählt, zum Beispiel „Beratung“ oder „Art des Termins“.",
  wb_service_list_tooltip:
    "Lass das Feld leer, dann zeigt der Abschnitt alle deine Leistungen, auch die, die du später hinzufügst. Wenn du bestimmte Leistungen auswählst, musst du jede neue hier ergänzen.",
  wb_service_search_tooltip:
    "Über der Leistungsliste erscheint ein Suchfeld für die Suche nach dem Namen. Der Kunde sieht es erst dann, wenn mindestens fünf Leistungen auf der Liste stehen.",
  wb_show_active_button_tooltip:
    "Hebt im oberen Menü den Namen der Seite hervor, auf der sich der Kunde gerade befindet, damit er sich leichter zurechtfindet.",
  wb_show_billing_data_tooltip:
    "Der Kunde sieht im Formular die Möglichkeit, Rechnungsdaten anzugeben, als Firma oder als Privatperson. Er entscheidet selbst, ob er sie ausfüllt, es sei denn, du legst sie zusätzlich als Pflicht fest.",
  wb_show_booked_slots_tooltip:
    "Belegte Uhrzeiten bleiben im Kalender durchgestrichen sichtbar und lassen sich nicht anklicken. Der Kunde sieht dann, dass der Tag stark gefragt ist, statt einer leeren Liste von Uhrzeiten.",
  wb_show_company_name_tooltip:
    "Entscheide, ob neben dem Logo in der oberen Leiste der Name deiner Firma zu sehen ist. Schalte es aus, wenn das Logo allein reicht.",
  wb_show_expand_collapse_button_tooltip:
    "Wenn ein Tag viele freie Uhrzeiten hat, sieht der Kunde nur die ersten sechs und eine Schaltfläche, um den Rest aufzuklappen. So bleibt die Liste kürzer und übersichtlicher.",
  wb_show_name_surname_tooltip:
    "Wenn du das einschaltest, gibt der Kunde bei der Buchung Vor- und Nachnamen an. Wenn du es ausschaltest, verschwinden die Felder und die E-Mail-Adresse reicht aus.",
  wb_show_phone_number_tooltip:
    "Wenn du das einschaltest, erscheint im Buchungsformular ein Feld für die Telefonnummer. Praktisch, wenn du deine Kunden anrufst oder ihnen SMS schickst.",
  wb_show_remind_password_link_tooltip:
    "Wenn du das einschaltest, sieht der Kunde auf der Anmeldeseite einen Link zur Passworterinnerung. Ein Klick öffnet ein Fenster, in dem er seine E-Mail-Adresse angibt und einen Link für ein neues Passwort bekommt.",
  wb_show_service_column_tooltip:
    "Neben dem Kalender sieht der Kunde ein Feld mit der Zusammenfassung der gewählten Leistung: Name, Preis und Dauer. Ist die Option aus, bleibt nur der Kalender mit den Terminen.",
  wb_show_service_description_tooltip:
    "Unter der gewählten Leistung sieht der Kunde ihre Beschreibung aus dem Calendesk-Panel. Längere Beschreibungen werden gekürzt, den vollen Text klappt der Kunde über den Link „Mehr anzeigen“ auf.",
  wb_show_sign_in_button_tooltip:
    "Zeigt im oberen Menü einen Button, mit dem der Kunde das Anmeldefenster für sein Kundenkonto öffnet. Ihn sehen nur Personen, die nicht angemeldet sind.",
  wb_show_sign_up_button_tooltip:
    "Zeigt im oberen Menü einen Button, mit dem der Kunde das Fenster zum Anlegen eines Kundenkontos öffnet. Ihn sehen nur Personen, die nicht angemeldet sind.",
  wb_sign_in_button_tooltip:
    "Text und Aussehen des Anmelde-Buttons im oberen Menü. Hier änderst du zum Beispiel die Beschriftung des Buttons und seinen Stil.",
  wb_sign_up_button_tooltip:
    "Text und Aussehen des Buttons zum Anlegen eines Kontos im oberen Menü. Hier änderst du zum Beispiel die Beschriftung des Buttons und seinen Stil.",
  wb_sign_up_modal_tooltip:
    "Einstellungen für das Fenster, in dem der Kunde ein Kundenkonto anlegt. Hier schaltest du unter anderem den Hinweis auf die AGB und die Rechnungsdaten ein.",
  wb_sign_up_terms_info_tooltip:
    "Bei der Registrierung sieht der Kunde einen Hinweis, dass er mit dem Anlegen eines Kontos die AGB und die Datenschutzerklärung akzeptiert. Wähle unten beide Seiten aus, sonst funktionieren die Links in diesem Hinweis nicht.",
  wb_start_calendar_time_tooltip:
    "Die erste Uhrzeit, die im Wochenkalender auf der Seite sichtbar ist. Frühere Uhrzeiten werden nicht angezeigt, stelle sie auf den Beginn deines Arbeitstags ein.",
  wb_subtitle_tooltip:
    "Eine kurze Zeile unter dem Titel der Abschnitt. Ein guter Platz für einen Satz, der die Überschrift weiterführt.",
  wb_summary_headline_tooltip:
    "Die Überschrift des Fensters, das der Kunde direkt nach einer erfolgreichen Buchung sieht, zum Beispiel „Danke für deine Buchung!“.",
  wb_summary_text_tooltip:
    "Der Text im Fenster mit der Buchungsbestätigung, unter der Überschrift. Sag dem Kunden, was als Nächstes passiert, zum Beispiel dass er eine Bestätigung per E-Mail bekommt.",
  wb_text_tooltip:
    "Der Haupttext dieser Abschnitt. Du kannst ihn formatieren, zum Beispiel fett schreiben oder Listen hinzufügen.",
  wb_text_hide_tooltip:
    "Blendet den Text neben dem Formular aus. Das Formular nimmt dann mehr Platz ein.",
  wb_text_margin_bottom_tooltip:
    "Der leere Abstand unter dem Bewertungstext, in Pixel. Sinnvoll sind 0 bis 50.",
  wb_tiktok_tooltip:
    "Der Link zu deinem TikTok-Profil. Sobald du ihn einträgst, erscheint auf der Seite ein TikTok-Symbol, das zum Profil führt.",
  wb_title_tooltip:
    "Die Hauptüberschrift dieser Abschnitt. Dein Kunde sieht sie als große Schrift oben in der Abschnitt.",
  wb_twitter_tooltip:
    "Der Link zu deinem Profil auf X (früher Twitter). Sobald du ihn einträgst, erscheint auf der Seite ein X-Symbol, das zum Profil führt.",
  wb_use_booking_cart_tooltip:
    "Der Kunde kann mehrere Termine in den Warenkorb legen, auch für verschiedene Leistungen, und alle auf einmal mit einer Bestätigung buchen. Ohne Warenkorb wird jeder Termin einzeln gebucht.",
  wb_view_flat_tooltip:
    "Entfernt den Schatten von den Buchungsfeldern, sodass sie flach und minimalistisch wirken. Ausgeschaltet: Die Felder haben einen dezenten Schatten.",
  wb_view_rounded_tooltip:
    "Wie stark die Ecken der Buchungsfelder und des Kalenders abgerundet sind: von scharfen Ecken bis zu einer starken Rundung.",
  wb_website_description_tooltip:
    "Eine Beschreibung deiner Seite für Suchmaschinen, zum Beispiel Google. Der Kunde sieht sie in den Suchergebnissen unter dem Namen der Seite und beim Teilen des Links, aber nicht auf der Seite selbst.",
  wb_youtube_tooltip:
    "Der Link zu deinem YouTube-Kanal. Sobald du ihn einträgst, erscheint auf der Seite ein YouTube-Symbol, das zum Kanal führt.",
  wb_zoom_tooltip:
    "Wie nah die Karte herangezoomt ist, auf einer Skala von 1 bis 20. Der Wert 12 zeigt eine ganze Stadt, 16 zeigt eine Straße und ihre Umgebung.",
  custom_duration_value: "Anderer Wert…",
  payment_authentication_failed_error:
    "Deine Bank hat die Zahlung nicht bestätigt. Versuche es noch einmal und schließe die Bestätigung in deiner Banking-App ab. Wenn es weiterhin fehlschlägt, nutze eine andere Karte oder schreib uns im Chat.",
  insufficient_funds_error:
    "Auf deiner Karte ist nicht genug Guthaben, deshalb hat die Bank die Zahlung abgelehnt. Lade das Konto auf oder nutze eine andere Karte und versuche es erneut.",
  card_declined_error:
    "Deine Bank hat die Zahlung mit dieser Karte abgelehnt. Nutze eine andere Karte oder frag bei deiner Bank nach dem Grund. Wenn du Hilfe brauchst, schreib uns im Chat.",
  wb_auto_save_short: "Autosave",
  wb_save_status_saving: "Speichern...",
  wb_save_status_saved_at: "Gespeichert um @{time}",
  wb_save_status_error: "Speichern fehlgeschlagen",
  wb_save_retry: "Erneut versuchen",
  wb_change_history: "Änderungsverlauf",
  wb_step_generic: "Einstellung geändert",
  wb_step_moved_section: "Abschnitt verschoben",
  wb_step_added_section: "Abschnitt hinzugefügt",
  wb_step_added_page: "Unterseite hinzugefügt",
  wb_step_updated_page: "Unterseite geändert",
  wb_booking_dynamic_form: "Felder des Buchungsformulars",
  wb_form: "Formularfelder",
  wb_buttons: "Schaltflächen",
  wb_buttons_position: "Position der Schaltfläche",
  wb_form_position: "Formular Position",
  wb_image_position: "Position der Bilder",
  hide_client_facing_ids_checkbox:
    "Buchungs- und Transaktionsnummern (IDs) vor Kunden verbergen",
  hide_client_facing_ids_tooltip:
    "<b>Welche Nummern werden verborgen?</b><br>Nummern von Buchungen, Abonnements, gekauften Produkten, Transaktionen und Zahlungen.<br><br><b>Wo sehen Kunden sie nicht mehr?</b><br>• in der Buchungsbestätigung auf der Website<br>• im Kundenpanel: Buchungen, Zahlungen, Abonnements<br>• in Standard-E-Mail-Benachrichtigungen<br>• auf der Stripe-Zahlungsseite<br>• in den Namen der Rechnungspositionen (die Rechnungsnummer selbst bleibt)<br><br>Im Adminbereich siehst du immer alle Nummern. Wenn du die Buchungsnummer selbst in deine Benachrichtigungsvorlage einfügst, funktioniert sie weiterhin.",
  variable_employee_title: "Position des Mitarbeiters",
  employee_example_title: "Leitender Spezialist",
  news: "Neuigkeiten",
  no_news_yet: "Noch keine Neuigkeiten",
  mark_all_news_as_read: "Alle als gelesen markieren",
  news_read_more: "Mehr erfahren",
  menu: "Menü",
  news_unread_tooltip: "Neuigkeiten - ungelesen: @{amount}",
  news_intro_title: "Neu: Systemneuigkeiten",
  news_intro_text:
    "Ab jetzt findest du alle Calendesk-Änderungen und Neuigkeiten unter dieser Glocke.",
  spotlight_got_it: "Alles klar",
  mobile_menu_intro_title: "Neu: unteres Menü",
  mobile_menu_intro_text:
    "Menü, Kalender, neue Buchungen, Verkauf und Kunden findest du jetzt in der unteren Leiste.",
  merge_clients_title: "Kunden zusammenführen",
  merge_clients_single_title: "Mit einem anderen Kunden zusammenführen",
  merge_clients_target_label: "Konto, das bleibt",
  merge_clients_add_client: "Kunden zum Zusammenführen hinzufügen",
  merge_clients_account_summary: "Buchungen: @{bookings}",
  merge_clients_warning:
    "Die anderen Konten werden gelöscht und ihre E-Mail-Adressen können sich nicht mehr anmelden. Alle Buchungen und der Benachrichtigungsverlauf gehen auf das verbleibende Konto über. Der Kunde erhält keine Nachricht. Die Notizen der Kundenkarten werden zusammengeführt. Leere Felder des verbleibenden Kontos werden mit Daten der anderen Konten gefüllt, und was sich nicht übernehmen lässt, landet in der Notiz. Das lässt sich nicht rückgängig machen.",
  merge_clients_refusal_has_payments:
    "Dieses Konto hat Zahlungen oder Abonnements und kann nicht zusammengeführt werden.",
  merge_clients_refusal_not_client:
    "Dieses Konto gehört zu einem Mitarbeiter und kann nicht zusammengeführt werden.",
  merge_clients_success: "Kunden zusammengeführt.",
  merge_clients_selection_hint: "Wähle 2 bis 5 Kundenkonten aus.",
  merge_clients_confirm: "Zusammenführen",
  max_user_bookings_period: "In welchem Zeitraum?",
  max_user_bookings_period_info:
    "Beispiel: Limit 1 mit einem Zeitraum von 30 Tagen bedeutet, dass ein Kunde diese Dienstleistung frühestens 30 Tage nach dem letzten Besuch wieder buchen kann. Es zählt das Besuchsdatum, nicht der Tag der Buchung. Die Buchungsseite deiner Kunden blockiert Buchungen über dem Limit. Im Admin-Panel und in der Mitarbeiter-App kannst du Buchungen trotzdem hinzufügen, du siehst nur eine Warnung.",
  booking_limit_dialog_title: "Buchungslimit erreicht",
  booking_limit_dialog_message:
    "Buchungslimit für diese Dienstleistung: @{max} pro Kunde. Das Limit ist bereits erreicht. Möchtest du die Buchung trotzdem erstellen?",
  booking_limit_dialog_message_period:
    "Buchungslimit für diese Dienstleistung: @{max} pro Kunde innerhalb von @{period}. Das Limit ist bereits erreicht. Möchtest du die Buchung trotzdem erstellen?",
  logs_diff_max_user_bookings_period: "Zeitraum des Buchungslimits pro Kunde",
  "account_email-change": "Änderung der E-Mail-Adresse - Bestätigung",
  "account_email-change_info":
    "Nachricht mit Bestätigungslink, die an die neue Adresse geht, wenn ein Kunde seine E-Mail ändert. Die Änderung wird erst nach dem Klick auf den Link wirksam.",
  "account_email-change_email_subject_client":
    "Bestätige deine neue E-Mail-Adresse bei [COMPANY_NAME]",
  "account_email-change_email_text_client":
    "<h1>Bestätige deine neue E-Mail-Adresse</h1><p>Wir haben eine Anfrage erhalten, die E-Mail-Adresse deines Kontos bei [COMPANY_NAME] auf [NEW_EMAIL] zu ändern. Klicke unten, um die neue Adresse zu bestätigen. Die Änderung wird erst nach der Bestätigung wirksam. Falls du das nicht warst, ignoriere diese Nachricht.</p>",
  "account_email-change_email_cta_button_client": "Neue Adresse bestätigen",
  "account_email-changed": "Änderung der E-Mail-Adresse - Benachrichtigung",
  "account_email-changed_info":
    "Infonachricht an die bisherige Adresse nach einer bestätigten E-Mail-Änderung.",
  "account_email-changed_email_subject_client":
    "Die E-Mail-Adresse deines Kontos bei [COMPANY_NAME] wurde geändert",
  "account_email-changed_email_text_client":
    "<h1>E-Mail-Adresse geändert</h1><p>Die E-Mail-Adresse deines Kontos bei [COMPANY_NAME] wurde auf [NEW_EMAIL] geändert. Falls du das nicht warst, kontaktiere uns bitte umgehend.</p>",
  variable_new_email: "Neue E-Mail-Adresse",
  email_change_pending_banner:
    "Die Änderung deiner E-Mail-Adresse wartet auf Bestätigung. Wir haben einen Link an @{email} gesendet. Bis zum Klick bleibt die aktuelle Adresse aktiv.",
  email_change_pending_sent_info:
    "Wir haben einen Bestätigungslink an @{email} gesendet. Die E-Mail-Adresse ändert sich erst nach dem Klick.",
  email_change_cancel_button: "Änderung abbrechen",
  email_change_resend_success: "Der Link wurde erneut gesendet.",
  email_change_resend_too_soon:
    "Wir haben den Link gerade eben gesendet. Warte ein paar Sekunden und versuche es erneut.",
  email_change_cancel_success:
    "Die Änderung der E-Mail-Adresse wurde abgebrochen.",
  email_change_confirm_success:
    "Deine E-Mail-Adresse wurde geändert. Melde dich mit der neuen Adresse an.",
  email_change_confirm_error:
    "Der Bestätigungslink ist abgelaufen oder ungültig. Melde dich an und sende ihn aus deinen Profileinstellungen erneut.",
  account_activation_completed:
    "Dein Konto ist aktiv. Melde dich an, um loszulegen.",
  email_change_confirm_taken_error:
    "Diese E-Mail-Adresse wird bereits von einem anderen Konto verwendet. Melde dich an und starte die Änderung mit einer anderen Adresse neu.",
  email_change_no_pending:
    "Es wartet keine Änderung der E-Mail-Adresse auf Bestätigung.",
  notification_category_14: "Änderung der E-Mail-Adresse",
  wb_employee_selection_mode: "Mitarbeiterauswahl bei der Buchung",
  wb_employee_selection_mode_any_person_first:
    "Kunde wählt eine Person, „beliebige Person“ steht auf der Liste",
  wb_employee_selection_mode_specific_only: "Kunde wählt eine bestimmte Person",
  wb_employee_selection_mode_auto_assign:
    "Auswahlschritt überspringen, automatisch zuweisen",
  wb_employee_selection_mode_tooltip:
    "Legt fest, wie der Schritt der Mitarbeiterauswahl funktioniert. „Kunde wählt eine Person“ zeigt die Liste, in der „beliebige Person“ die erste Option ist. „Kunde wählt eine bestimmte Person“ blendet die Option „beliebige Person“ aus, der Kunde muss also jemanden aus der Liste wählen. „Auswahlschritt überspringen“ füllt den Schritt automatisch mit „beliebige Person“ und führt den Kunden direkt zur Terminauswahl; über „Ändern“ kann er weiterhin eine bestimmte Person wählen.",
  customer_captcha_enabled_checkbox:
    "Buchungs-, Registrierungs- und Login-Formulare mit Google reCAPTCHA schützen",
  customer_captcha_enabled_tooltip:
    "<b>Was macht das?</b><br>Google reCAPTCHA läuft unsichtbar im Hintergrund und hält Bots davon ab, deinen Kalender mit falschen Buchungen zu füllen oder die Passwörter deiner Kunden zu erraten. Deine Kunden müssen nichts anklicken.<br><br><b>Was passiert beim Ausschalten?</b><br>Deine Buchungsseite lädt keine Google-Skripte mehr und setzt keine Google-Cookies, was sich in einer Cookie-Richtlinie leichter erklären lässt. Dafür verlieren deine Formulare den Bot-Filter. Wenn du es ausschaltest, aktiviere oben die E-Mail-Bestätigung für Buchungen, damit jeder, der ohne Konto bucht, seine Adresse bestätigen muss.",
  wb_cookie_banner_enabled: "Cookie-Banner auf der Website anzeigen",
  wb_cookie_banner_enabled_tooltip:
    "Besucher entscheiden selbst, ob sie Statistiken und Werbung zustimmen. Bis dahin warten Google Tag Manager und dein eigener Code, und es läuft nur, was die Seite zum Funktionieren braucht (Anmeldung, Buchungen, Zahlungen, Formularschutz). Jeden Text des Banners kannst du unten ändern.",
  wb_cookie_banner_edit_texts: "Einstellungen des Cookie-Banners",
  wb_google_tag_mode: "Google Tag Manager startet",
  wb_google_tag_mode_tooltip:
    "Wähle „Sofort“ nur, wenn du in deinem Google-Tag-Manager-Konto festgelegt hast, welche Tags eine Zustimmung brauchen. Sonst wartet der Container, bis der Besucher Statistiken oder Werbung akzeptiert.",
  wb_google_tag_mode_after_consent:
    "Nachdem der Besucher Cookies zugestimmt hat",
  wb_google_tag_mode_immediately:
    "Sofort, mit Übergabe der Besucherwahl an Google",
  wb_custom_code_mode: "Der Code unten startet",
  wb_custom_code_mode_tooltip:
    'Ein Schnipsel kann auf eine andere Einwilligung warten als der Rest. Ergänze data-category="analytics", "marketing" oder "functionality", dann zählt nur noch diese eine Einwilligung, zum Beispiel <script data-category="marketing" src="...">. Funktioniert in script, link und style. Meta läuft immer.',
  wb_custom_code_mode_always: "Sofort, ohne nach Einwilligung zu fragen",
  wb_custom_code_mode_functionality: "Nach Zustimmung zu Zusatzfunktionen",
  wb_custom_code_mode_analytics: "Nach Zustimmung zu Statistiken",
  wb_custom_code_mode_marketing: "Nach Zustimmung zu Werbung",
  wb_custom_code_blocked_info:
    "Schnipsel ohne eigene Kategorie: @{count}. Alle warten auf eine Einwilligung. Prüfe, ob keine Schriftart, kein Style und kein Chat darunter ist.",
  wb_custom_code_mode_hint_always:
    "Dieser Code läuft bei jedem Besucher, auch wenn er Cookies ablehnt. Lass hier nur Code, der niemanden verfolgt.",
  wb_custom_code_mode_hint_consent:
    'Lehnt ein Besucher Cookies ab, läuft dieser Code nicht. Soll ein Schnipsel trotzdem immer laufen, ergänze data-category="necessary":\n<script ... data-category="necessary">',
  wb_cookie_banner_title: "Banner-Titel",
  wb_cookie_banner_description: "Banner-Text",
  wb_cookie_banner_accept_all_button: "Button „Alle akzeptieren“",
  wb_cookie_banner_reject_all_button: "Button „Alle ablehnen“",
  wb_cookie_banner_settings_button: "Button „Einstellungen“",
  wb_cookie_banner_privacy_policy_page: "Seite mit der Datenschutzerklärung",
  wb_cookie_banner_privacy_policy_url: "Adresse der Datenschutzerklärung",
  wb_cookie_banner_privacy_policy_url_tooltip:
    "Ein Link zu einer Datenschutzerklärung außerhalb dieser Website. Wenn ausgefüllt, wird er statt der Seite oben verwendet.",
  wb_cookie_banner_privacy_policy_link: "Linktext zur Datenschutzerklärung",
  wb_cookie_banner_block_page: "Seite bis zur Entscheidung sperren",
  wb_cookie_banner_block_page_tooltip:
    "Standardmäßig aus: Besucher können buchen, bevor sie auf das Banner antworten.",
  wb_cookie_banner_preferences_title: "Titel des Einstellungsfensters",
  wb_cookie_banner_save_button: "Button „Speichern“",
  wb_cookie_banner_necessary_title: "Notwendig, Titel",
  wb_cookie_banner_necessary_description: "Notwendig, Beschreibung",
  wb_cookie_banner_functionality_title: "Zusatzfunktionen, Titel",
  wb_cookie_banner_functionality_description: "Zusatzfunktionen, Beschreibung",
  wb_cookie_banner_analytics_title: "Statistik, Titel",
  wb_cookie_banner_analytics_description: "Statistik, Beschreibung",
  wb_cookie_banner_marketing_title: "Werbung, Titel",
  wb_cookie_banner_marketing_description: "Werbung, Beschreibung",
  wb_cookie_banner_default_title: "Diese Website verwendet Cookies",
  wb_cookie_banner_default_description:
    "Cookies sind kleine Dateien, die in deinem Browser gespeichert werden. Notwendige Cookies sorgen für Anmeldung, Buchungen und Zahlungen und sind immer aktiv. Mit deiner Zustimmung nutzen wir Cookies auch für Besuchsstatistiken und passende Werbung. Du kannst deine Zustimmung jederzeit in den Cookie-Einstellungen ändern oder widerrufen.",
  wb_cookie_banner_default_accept_all_button: "Alle akzeptieren",
  wb_cookie_banner_default_reject_all_button: "Alle ablehnen",
  wb_cookie_banner_default_settings_button: "Cookie-Einstellungen",
  wb_cookie_banner_default_privacy_policy_link: "Datenschutzerklärung",
  wb_cookie_banner_default_preferences_title: "Datenschutzeinstellungen",
  wb_cookie_banner_default_save_button: "Meine Auswahl speichern",
  wb_cookie_banner_default_necessary_title: "Notwendig",
  wb_cookie_banner_default_necessary_description:
    "Diese Cookies sind für den Betrieb der Seite erforderlich und können nicht abgeschaltet werden. Sie werden als Reaktion auf deine Aktionen gesetzt, etwa Anmeldung, Buchung, Zahlung (Stripe) oder das Absenden eines Formulars (reCAPTCHA-Schutz). Du kannst sie im Browser blockieren, dann funktionieren Teile der Seite jedoch nicht mehr. Sie speichern keine Daten, die dich identifizieren.",
  wb_cookie_banner_default_functionality_title: "Zusatzfunktionen",
  wb_cookie_banner_default_functionality_description:
    "Diese Cookies erweitern die Seite um Zusatzfunktionen wie einen Chat, eine Karte oder eingebettete Videos. Sie können von den Anbietern dieser Dienste gesetzt werden. Ohne deine Zustimmung funktionieren diese Funktionen möglicherweise nicht oder nur eingeschränkt.",
  wb_cookie_banner_default_analytics_title: "Statistik",
  wb_cookie_banner_default_analytics_description:
    "Diese Cookies zählen Besuche und Zugriffsquellen, damit wir die Seite messen und verbessern können, zum Beispiel mit Google Analytics. Sie zeigen, welche Seiten am häufigsten besucht werden und wie sich Besucher bewegen. Die Daten sind zusammengefasst und anonym. Ohne deine Zustimmung wird dein Besuch nicht in der Statistik gezählt.",
  wb_cookie_banner_default_marketing_title: "Werbung",
  wb_cookie_banner_default_marketing_description:
    "Diese Cookies werden von Werbepartnern gesetzt, zum Beispiel Google Ads oder Meta. Sie erstellen ein Profil deiner Interessen und zeigen dir passende Werbung auf anderen Seiten. Sie speichern keine personenbezogenen Daten direkt, erkennen aber deinen Browser und dein Gerät. Ohne deine Zustimmung ist die Werbung weniger relevant.",
  wb_cookie_banner_enabled_info:
    "Das Banner ist aktiv. Texte, Kategorien, Datenschutz-Link und den Weg zurück zu den Einstellungen findest du unter dem Button unten oder per Klick auf das Banner in der Vorschau. Einstellungen, die vom Banner abhängen, haben links einen farbigen Balken.",
  wb_cookie_banner_preview_edit:
    "Klicken, um die Einstellungen des Cookie-Banners zu öffnen",
  wb_section_preview_edit:
    "Klicken, um die Einstellungen des Abschnitts zu öffnen",
  wb_navbar_preview_edit:
    "Klicken, um die Einstellungen der Kopfzeile zu öffnen",
  wb_footer_preview_edit:
    "Klicken, um die Einstellungen der Fußzeile zu öffnen",
  wb_cookie_banner_section_bar: "Cookie-Leiste",
  wb_cookie_banner_section_link: "Link zur Datenschutzerklärung",
  wb_cookie_banner_section_preferences: "Einstellungsfenster",
  wb_cookie_banner_privacy_policy_target: "Wohin führt der Link?",
  wb_cookie_banner_privacy_policy_target_none: "Kein Link",
  wb_cookie_banner_privacy_policy_target_page: "Eine Seite dieser Website",
  wb_cookie_banner_privacy_policy_target_url: "Eine externe Adresse",
  wb_cookie_banner_default_preferences_description:
    "Während du diese Seite nutzt, kann dein Browser Informationen speichern oder abrufen, meist in Form von Cookies. Sie können dich, deine Einstellungen oder dein Gerät betreffen und identifizieren dich in der Regel nicht direkt. Unten wählst du, welchen Arten von Cookies du zustimmst. Das Blockieren einiger davon kann Teile der Seite einschränken.",
  wb_cookie_banner_preferences_description:
    "Einstellungsfenster, Einleitungstext",
  wb_cookie_banner_categories: "Kategorien zur Auswahl für Besucher",
  wb_cookie_banner_categories_tooltip:
    "Entferne das Häkchen, um eine Kategorie im Einstellungsfenster auszublenden. Eine ausgeblendete Kategorie wird nie akzeptiert, also läuft ihr zugeordneter Code nie. Google Tag Manager im Modus „nach Zustimmung“ startet nur bei Zustimmung zu Statistiken oder Werbung, behalte also mindestens eine davon, wenn du ihn nutzt.",
  wb_cookie_banner_category_hidden: "ausgeblendet",
  wb_cookie_banner_reopen:
    "Wie kommt der Besucher zu den Cookie-Einstellungen zurück?",
  wb_cookie_banner_reopen_icon:
    "Ein kleines Cookie-Symbol in der Ecke der Seite",
  wb_cookie_banner_reopen_link:
    "Ein Link, den ich selbst einfüge (Menü, Fußzeile oder Button)",
  wb_cookie_banner_reopen_both: "Beides: das Symbol und mein eigener Link",
  wb_cookie_banner_reopen_link_info:
    "Das Symbol ist immer sichtbar, der Besucher kann seine Meinung jederzeit ändern, ohne dass du etwas tun musst. Wenn du lieber einen Link in der Fußzeile oder im Menü willst, füge einen Menüeintrag oder eine Weiterleitungsseite hinzu und verwende diese Adresse:",
  wb_cookie_banner_reopen_link_missing:
    "Noch nichts auf deiner Seite führt zu den Cookie-Einstellungen. Füge einen Menüeintrag, Fußzeilen-Link oder Button mit der obigen Adresse hinzu, sonst kann der Besucher seine Meinung nicht ändern.",
  wb_cookie_banner_reopen_tooltip:
    "Der Besucher kann die Zustimmung jederzeit ändern oder widerrufen. Wähle das Symbol, einen selbst platzierten Link (zum Beispiel in der Fußzeile, wie die meisten Websites) oder beides.",
  employee_no_panel_access: "Kein Zugang zum Panel",
  guest_retention_days_label: "Nach wie vielen Tagen löschen?",
  guest_retention_anchor_label: "Ab wann zählen die Tage?",
  guest_retention_anchor_last_booking:
    "ab der letzten Buchung dieser Person (empfohlen)",
  guest_retention_anchor_record_created: "ab der ersten Buchung dieser Person",
  client_password_min_length_label: "Mindestlänge des Passworts",
  client_password_classes_label: "Erforderliche Zeichenarten",
  client_password_class_upper: "Großbuchstabe",
  client_password_class_lower: "Kleinbuchstabe",
  client_password_class_digit: "Ziffer",
  client_password_class_special: "Sonderzeichen",
  client_password_breach_check_checkbox:
    "Passwörter aus bekannten Datenlecks ablehnen",
  client_password_breach_check_tooltip:
    "Wir prüfen, ob das Passwort in öffentlichen Datenlecks aufgetaucht ist. An den Prüfdienst geht nur ein Fragment des Passwort-Hashes, nie das Passwort selbst oder die E-Mail-Adresse. Antwortet der Dienst nicht, geht das Passwort ohne diese Prüfung durch.",
  client_password_email_similarity_checkbox:
    "Das Passwort darf den Teil der E-Mail-Adresse vor dem „@“ nicht enthalten",
  client_password_email_similarity_tooltip:
    "Wir prüfen den Teil der Adresse vor dem „@“, ohne Groß- und Kleinschreibung zu unterscheiden. Bei <b>anna.kowalska@example.com</b> wird das Passwort <b>Anna.Kowalska2024!</b> abgelehnt, <b>Kowalska2024!</b> geht durch. Ist dieser Teil kürzer als 4 Zeichen (z. B. <b>jk@</b>), blockiert die Regel nichts.",
  client_password_settings_tooltip:
    "Die Regeln gelten auf der Buchungsseite und in der Kunden-App. Die Passwörter deiner Mitarbeiter ändern sich nicht.",
  settings_privacy: "Datenschutz",
  privacy_account_card_title: "Was sehen Kunden nach dem Anmelden?",
  privacy_account_card_description:
    "Aktuell sehen Kunden nach dem Anmelden alle Buchungen, die mit ihrer E-Mail-Adresse gemacht wurden, auch die aus der Zeit vor dem Konto.",
  privacy_account_switch: "Kunden nur Buchungen ab der Kontoerstellung zeigen",
  privacy_account_warning:
    "Ältere Buchungen, Zahlungen und Dateien bleiben in deinem Panel, verschwinden aber aus dem Kundenkonto. Jeder neue Kunde kann sich erst anmelden, nachdem er auf den Link in der E-Mail geklickt hat. Kunden mit Konto, die ihre Adresse nie bestätigt haben, werden bei der nächsten Anmeldung um die Bestätigung gebeten: Es reicht, auf den Link in der E-Mail zu klicken oder „Passwort vergessen“ zu nutzen. Wer ohne Konto gebucht hat, registriert sich, denn „Passwort vergessen“ schickt ihm nichts. Für Mitarbeiter ändert sich nichts.",
  privacy_account_example_caption:
    "Beispiel: Anna hat ohne Konto gebucht und später ein Konto erstellt.",
  privacy_account_example_now: "Jetzt",
  privacy_account_example_after: "Wenn aktiviert",
  privacy_account_example_booking_before: "3. März: Buchung ohne Konto",
  privacy_account_example_signup: "10. Mai: Anna erstellt ein Konto",
  privacy_account_example_booking_after: "2. Oktober: Buchung über das Konto",
  privacy_account_example_hidden: "nur in deinem Panel sichtbar",
  guest_retention_example_last_booking:
    "Beispiel: Jemand bucht heute ohne Konto. Bucht die Person nichts mehr, löschen wir ihre Daten in der Nacht nach dem @{date}, aber nie vor dem Termin ihrer Buchung.",
  guest_retention_example_record_created:
    "Beispiel: Jemand bucht heute zum ersten Mal ohne Konto. Wir löschen die Daten in der Nacht nach dem @{date}, auch wenn die Person zwischendurch wieder bucht, aber nie vor dem Termin einer Buchung.",
  guest_retention_timeline_label: "Wie funktioniert das Löschen?",
  guest_retention_timeline_booking: "Buchung ohne Konto",
  guest_retention_timeline_booking_last:
    "gezählt ab der letzten Buchung dieser Person",
  guest_retention_timeline_booking_first:
    "gezählt ab der ersten Buchung dieser Person",
  guest_retention_timeline_wait: "@{days} Tag vergeht|@{days} Tage vergehen",
  guest_retention_timeline_wait_detail:
    "und es gibt keine geplante Buchung mehr",
  guest_retention_timeline_delete:
    "Wir löschen die Daten der Person in der Nacht",
  guest_retention_timeline_delete_detail:
    "Name, Kontaktdaten, gesendete Nachrichten, Dateien und Bewertungen",
  guest_retention_timeline_kept: "Die Buchung bleibt, ohne persönliche Daten",
  guest_retention_timeline_kept_detail:
    "Leistung, Mitarbeiter und Termin, damit deine Statistiken stimmen",
  guest_retention_advanced_title: "Erweiterte Einstellungen",
  guest_retention_scope_checkbox:
    "Auch die Daten der Person aus alten Buchungen ohne Konto löschen, selbst wenn sie später ein Konto erstellt hat",
  guest_retention_scope_hint:
    "Beispiel: Anna hat am 3. März ohne Konto gebucht und am 10. Mai ein Konto erstellt. Nach der festgelegten Zeit bleibt die Buchung vom 3. März in deinem Panel ohne ihre Daten (nur Leistung, Mitarbeiter und Termin) und gehört nicht mehr zu ihrem Konto. Annas Konto und ihre Buchungen ab dem 10. Mai ändern sich nicht. Buchungen mit Zahlung bleiben unverändert.",
  guest_retention_scope_why:
    "Warum? Diese Buchung könnte jemand anderes mit ihrer E-Mail-Adresse gemacht haben, und sie sieht sie nicht in ihrem Konto. Es gibt also keinen Grund, ihre Daten dort zu behalten.",
  guest_retention_never_title: "Wen löschen wir nie?",
  guest_retention_never_account: "Kunden mit Konto",
  guest_retention_never_payment: "Kunden mit Zahlung",
  guest_retention_never_subscription: "Kunden mit Abo",
  guest_retention_never_upcoming: "Kunden mit geplanter Buchung",
  guest_retention_never_manual: "Kunden, die du im Panel angelegt hast",
  client_password_preview_title: "Wie wirken diese Regeln an Beispielen?",
  client_password_preview_email:
    "Für eine Kundin mit der Adresse @{email}. Datenlecks prüfen wir erst, wenn das Passwort gesetzt wird.",
  client_password_preview_passes: "wird akzeptiert",
  client_password_preview_too_short: "zu kurz (mindestens @{min} Zeichen)",
  client_password_preview_missing: "fehlt: @{what}",
  client_password_preview_has_email: "enthält einen Teil der E-Mail-Adresse",
  guest_retention_scope_table_label: "Was diese Einstellung ändert",
  guest_retention_scope_table_booking: "Die Buchung vom 3. März",
  guest_retention_scope_table_unchecked: "Nicht angehakt",
  guest_retention_scope_table_checked: "Angehakt",
  guest_retention_scope_table_account: "In Annas Konto",
  guest_retention_scope_table_panel: "In deinem Panel",
  guest_retention_scope_table_hidden:
    "Nicht sichtbar, weil „Kunden nur Buchungen ab der Kontoerstellung zeigen“ aktiviert ist",
  guest_retention_scope_table_kept: "Bleibt mit Annas Daten, ohne Ende",
  guest_retention_scope_table_removed:
    "Nach @{days} Tag bleibt sie ohne ihre Daten: nur Leistung, Mitarbeiter und Termin|Nach @{days} Tagen bleibt sie ohne ihre Daten: nur Leistung, Mitarbeiter und Termin",
  guest_retention_scope_requires_account_history:
    "Funktioniert nur, wenn „Kunden nur Buchungen ab der Kontoerstellung zeigen“ unter „Was sehen Kunden nach dem Anmelden?“ aktiviert ist.",
  guest_retention_dpo_title: "Details für deinen Datenschutzbeauftragten",
  guest_retention_dpo_details:
    "<b>Was löschen wir?</b> Die Daten der Person (Name, E-Mail, Telefon, Adresse), an sie gesendete E-Mails und SMS, Einträge im Aktivitätsprotokoll, Anhänge und Bewertungen. Jede Buchung bleibt als Eintrag ohne persönliche Daten: Leistung, Mitarbeiter, Termin und Status.<br><br><b>Wen löschen wir nicht?</b> Personen mit Konto, mit Kontoanfrage oder mindestens einer Anmeldung. Personen mit Zahlung, Abo oder geplanter Buchung. Mitarbeiter, im Panel angelegte Kunden ohne Buchung und alle, deren Daten vor dem ersten Einschalten dazugekommen sind.<br><br><b>Backups</b> Gelöschte Daten verschwinden innerhalb von 21 Tagen aus den Backups.<br><br><b>Nachweis</b> Die Liste „Datenlöschungen“ zeigt jeden Lauf: Datum, gelöschte Personen, Buchungen ohne persönliche Daten, übersprungene Personen (Zahlung oder geplante Buchung) und Fehler. Wir speichern nur Zahlen. 90 Tage lang behalten wir einen nicht umkehrbaren Hash der gelöschten E-Mail-Adressen, um auf Anfrage zu prüfen, ob eine Adresse gelöscht wurde. „Probelauf“ heißt: ein Lauf, der nichts gelöscht hat.",
  privacy_retention_confirm_preview_bookings:
    "Außerdem entfernen wir die Daten aus @{bookings} alten Buchungen von Kunden, die später ein Konto erstellt haben.",
  client_password_extra_rules_title: "Zusätzliche Regeln",
  client_password_policy_empty:
    "Nur die Mindestlänge von 8 Zeichen ohne weitere Regel können wir nicht speichern. Wähle mindestens eine Zeichenart, erhöhe die Mindestlänge oder schalte eine der zusätzlichen Regeln ein.",
  client_password_weaker_than_default:
    "Diese Regeln sind lockerer als die aktuellen: Die Buchungsseite akzeptiert Passwörter ohne die abgewählten Zeichenarten.",
  logs_diff_account_requested_at: "Konto angefragt",
  logs_diff_account_requested_via: "Konto angefragt über",
  account_request_via_signup_form: "Registrierung auf der Seite",
  account_request_via_booking_form: "Buchungsformular",
  account_request_via_store_form: "Shop",
  account_request_via_admin_panel: "Panel (Mitarbeiter)",
  account_request_via_password_reset: "Passwort-Reset",
  account_request_via_backfill: "Konto von vor der Änderung",
  account_status_account: "Konto",
  account_status_pending: "Wartet auf Bestätigung",
  account_status_guest: "Kein Konto",
  account_status_blocked: "Gesperrt",
  account_status_filter: "Konto",
  account_status_account_details: "Konto bestätigt am @{date}",
  account_status_pending_details:
    "Konto angefragt am @{date} (@{via}), Adresse noch nicht bestätigt",
  account_status_guest_details: "Bucht ohne Konto",
  retention_forecast_kept: "Diese Daten löschen wir nicht: @{reason}.",
  retention_forecast_due_tonight: "Wir löschen die Daten heute Nacht.",
  retention_forecast_due_after:
    "Wir löschen die Daten frühestens in der Nacht nach dem @{date}.",
  retention_forecast_due_after_booking:
    "Wir löschen die Daten frühestens in der Nacht nach dem @{date}, sobald der Buchungstermin vorbei ist.",
  retention_forecast_reason_account: "der Kunde hat ein Konto",
  retention_forecast_reason_account_request:
    "der Kunde hat ein Konto angefragt",
  retention_forecast_reason_staff: "das ist ein Mitarbeiter",
  retention_forecast_reason_before_enabled:
    "die Daten stammen von vor dem Einschalten der Löschung",
  retention_forecast_reason_logged_in:
    "der Kunde hat sich auf der Seite angemeldet",
  retention_forecast_reason_no_booking: "der Kunde hat keine Buchungen",
  retention_forecast_reason_managed_by_staff:
    "eine Buchung für diesen Kunden wurde von einem Mitarbeiter oder per Import angelegt",
  event_customer_removed: "Kundendaten gelöscht",
  retention_forecast_reason_payment: "der Kunde hat eine Zahlung",
  retention_forecast_reason_subscription: "der Kunde hat ein Abonnement",
  privacy_account_confirm_warning:
    "Kunden sehen im Konto nur Buchungen ab der Kontoerstellung, und neue Kunden können sich erst nach der Bestätigung ihrer E-Mail-Adresse anmelden. Wer ohne Konto gebucht hat, muss sich registrieren. Alle Buchungen hast du weiterhin im Panel.",
  privacy_account_confirm_unconfirmed:
    "Kunden mit Konto, die ihre Adresse bei der nächsten Anmeldung bestätigen: @{count}.",
  privacy_retention_card_title: "Daten von Personen ohne Konto löschen",
  privacy_retention_card_description:
    "Aktuell bleiben die Daten von Personen, die ohne Konto buchen, dauerhaft im System.",
  privacy_retention_switch:
    "Diese Daten nach einer festgelegten Zeit automatisch löschen",
  privacy_retention_confirm_warning:
    "Ab jetzt löschen wir jede Nacht endgültig die Daten von Personen ohne Konto, bei denen @{days} Tag vergangen ist. Das lässt sich nicht rückgängig machen.|Ab jetzt löschen wir jede Nacht endgültig die Daten von Personen ohne Konto, bei denen @{days} Tage vergangen sind. Das lässt sich nicht rückgängig machen.",
  privacy_retention_confirm_reenable:
    "Die Option war bereits ab dem @{date} aktiv, daher betrifft sie auch Personen, die ohne Konto gebucht haben, während sie ausgeschaltet war.",
  privacy_password_card_title: "Kundenpasswörter",
  privacy_password_card_description:
    "Aktuell braucht ein Kundenpasswort mindestens 8 Zeichen, darunter einen Klein- und einen Großbuchstaben, eine Ziffer und ein Sonderzeichen wie ! oder #.",
  privacy_password_switch: "Eigene Passwortregeln festlegen",
  privacy_confirm_title: "Datenschutz-Änderungen speichern?",
  profile_account_details: "Kontodaten",
  guest_retention_coverage_on_save:
    "Gelöscht werden nur Personen, deren Daten nach dem Speichern dazukommen. Deine bisherigen Kunden löschen wir nicht.",
  guest_retention_coverage_since:
    "Wir löschen nur Personen, deren Daten ab dem @{date} dazugekommen sind. Kunden von davor löschen wir nie, auch nicht nach erneutem Einschalten.",
  guest_data_purges_title: "Datenlöschungen",
  guest_data_purges_description:
    "Hier wird jede nächtliche Löschung festgehalten. Du kannst die Liste als CSV für deinen Datenschutzbeauftragten herunterladen.",
  guest_data_purges_after_save:
    "Die Liste erscheint, sobald du speicherst. Wir prüfen die Daten jede Nacht, die ersten Personen löschen wir aber frühestens in der Nacht nach dem @{date}.",
  guest_data_purges_status_none:
    "Noch kein Lauf. Wir prüfen die Daten jede Nacht, die ersten Personen löschen wir frühestens in der Nacht nach dem @{date}.",
  guest_data_purges_status_last:
    "Letzter Durchlauf: @{date}, @{users} Personen entfernt.",
  guest_data_purges_none: "Noch keine Durchläufe.",
  guest_data_purges_none_with_changes:
    "Bisher hat kein Durchlauf etwas gelöscht. Alle Durchläufe findest du in der CSV-Datei.",
  guest_data_purges_rest_in_csv:
    "Die übrigen Durchläufe haben nichts gelöscht. Alle Durchläufe findest du in der CSV-Datei.",
  guest_data_purges_show_more: "Mehr anzeigen",
  guest_data_purges_export: "CSV herunterladen",
  guest_data_purges_dry_run: "Probelauf (nichts gelöscht)",
  guest_data_purges_col_run: "Durchlauf",
  guest_data_purges_col_users: "Entfernte Personen",
  guest_data_purges_col_bookings: "Anonymisierte Buchungen",
  guest_data_purges_col_excluded:
    "Übersprungen (Zahlung oder künftige Buchung)",
  guest_data_purges_col_errors: "Fehler",
  privacy_retention_confirm_preview:
    "Heute Nacht löschen wir die Daten von @{users} Personen ohne Konto.",
  guest_data_purges_load_failed:
    "Die Liste der Löschungen konnte nicht geladen werden. Deine Einstellungen sind gespeichert, lade die Seite neu, um die Liste zu sehen.",
  guest_data_purges_export_failed:
    "Die CSV-Datei konnte nicht heruntergeladen werden. Versuche es noch einmal.",
  plan_preview_title: "Was zahlen Sie heute?",
  plan_preview_subtotal: "Zwischensumme netto",
  plan_preview_discount: "Rabatt",
  plan_preview_tax: "MwSt.",
  plan_preview_credit_used: "Aus Ihrem Guthaben",
  plan_preview_amount_due: "Heute fällig",
  plan_preview_credit_after: "Bleibt als Guthaben: {amount}",
  plan_preview_renews_at: "Nächste Zahlung: {date}",
  plan_preview_no_change:
    "Das ist Ihr aktueller Tarif. Es ändert sich nichts und wir berechnen nichts.",
  plan_preview_resume:
    "Sie bleiben bei Ihrem aktuellen Tarif und die geplante Änderung entfällt. Heute berechnen wir nichts.",
  plan_preview_credit_note:
    "Die Differenz geht auf Ihr Guthaben und deckt die nächsten Zahlungen.",
  plan_preview_credit_covers:
    "Die nächsten Zahlungen von je {amount} deckt Ihr Guthaben. Ihre Karte wird erst am {date} belastet.",
  plan_preview_carried_to_next:
    "{amount} rechnen wir Ihrer nächsten Zahlung hinzu. So kleine Beträge lassen sich nicht per Karte abbuchen.",
  plan_preview_applied_discount:
    "Ihr Rabatt ({discount}) ist in diesen Preisen bereits enthalten.",
  plan_preview_loading: "Wir berechnen, was Sie heute zahlen…",
  plan_preview_discount_code: "Code {code}",
  plan_preview_discount_forever: "unbefristet",
  plan_preview_discount_until: "bis {date}",
  plan_preview_discount_once: "nur bei der ersten Zahlung",
  change_plan: "Tarif ändern",
  plan_changes_adding: "Sie fügen hinzu: {items}",
  plan_changes_removing: "Sie deaktivieren: {items}",
  plan_changes_changing: "Sie ändern: {items}",
  plan_changes_due_today: "Heute zahlen Sie: {amount}",
  max_gap_between_bookings_checkbox_text:
    "Abstand zwischen Buchungen eines Mitarbeiters begrenzen",
  max_gap_between_bookings: "Maximaler Abstand",
  max_gap_between_bookings_info:
    "Hat der Mitarbeiter an dem Tag bereits eine Buchung, sehen Kunden online nur Termine, die höchstens so viele Minuten davon entfernt liegen (Pausen vor und nach der Dienstleistung eingerechnet). Ein Tag ohne Buchungen zeigt alle Termine aus dem Plan. Ein beim Mitarbeiter gesetzter Abstand hat Vorrang vor diesem. Im Admin-Panel und in der Mitarbeiter-App kannst du Buchungen ohne diese Grenze anlegen.",
  logs_diff_max_gap_between_bookings: "Maximaler Abstand zwischen Buchungen",
  invoice_not_issued: "Rechnung nicht ausgestellt",
  invoice_retry_queued: "In der Warteschlange",
  invoice_retry_button: "Rechnung erneut ausstellen",
  invoice_retry_confirm_title: "Rechnung erneut ausstellen?",
  invoice_retry_confirm_warning:
    "Wir stellen die Rechnung noch einmal aus. Als Verkaufsdatum gilt das Zahlungsdatum, und der Kunde erhält sie wie jede andere Rechnung.",
  invoice_retry_queued_info:
    "Die Rechnung ist in der Warteschlange. Der Status aktualisiert sich in Kürze.",
  invoice_retry_skipped_already_issued:
    "Diese Rechnung wurde bereits ausgestellt.",
  invoice_retry_skipped_in_progress:
    "Diese Rechnung wartet bereits in der Warteschlange.",
  invoice_retry_skipped_not_eligible:
    "Für diese Zahlung lässt sich keine Rechnung mehr ausstellen.",
  invoice_retry_skipped_forbidden:
    "Du hast keine Berechtigung, diese Rechnung auszustellen.",
  event_bulk_count_bookings: "@{count} Buchung|@{count} Buchungen",
  event_bulk_count_blockades:
    "@{count} Kalendersperre|@{count} Kalendersperren",
  event_bulk_delete_summary: "Du löschst @{bookings} und @{blockades}.",
  event_bulk_delete_summary_bookings: "Du löschst @{bookings}.",
  event_bulk_delete_summary_blockades: "Du löschst @{blockades}.",
  event_deleting_bookings_title: "Buchungen löschen",
  event_deleting_blockades_title: "Kalendersperren löschen",
  event_bulk_status_summary:
    "@{count} Buchung erhält den Status „@{status}“.|@{count} Buchungen erhalten den Status „@{status}“.",
  event_bulk_status_skipped_blockades:
    "Wir überspringen @{blockades}, weil Kalendersperren keinen Status haben.",
  event_bulk_skipped_bookings_no_permission:
    "Wir überspringen @{bookings}, weil dir dafür die Berechtigung fehlt.",
  event_bulk_skipped_blockades_no_permission:
    "Wir überspringen @{blockades}, weil dir dafür die Berechtigung fehlt.",
  event_bulk_skipped_company_blockades:
    "Wir überspringen @{blockades} für das ganze Unternehmen (ohne zugewiesenen Mitarbeiter), weil du nach Mitarbeiter filterst.",
  event_bulk_no_filters_warning:
    "Es ist kein Filter gesetzt, daher betrifft der Vorgang alle Ereignisse im Konto.",
  event_bulk_over_limit_delete:
    "Du kannst höchstens @{limit} Ereignisse auf einmal löschen. Grenze die Filter ein, zum Beispiel auf einen kürzeren Zeitraum.",
  event_bulk_over_limit_update:
    "Du kannst den Status von höchstens @{limit} Buchungen auf einmal ändern. Grenze die Filter ein, zum Beispiel auf einen kürzeren Zeitraum.",
  event_bulk_nothing_to_process: "Dieser Vorgang betrifft kein Ereignis.",
  panel_company_account_not_found:
    "Wir konnten dieses Firmenkonto nicht finden. Möglicherweise wurde es gelöscht. Melde dich erneut an, um fortzufahren.",
  bulk_operation_completed_with_skipped:
    "Abgeschlossen. Verarbeitet: @{processed}, fehlgeschlagen: @{failed}, übersprungen: @{skipped}. Übersprungen wurden Einträge, die schon gelöscht waren oder für die dir die Berechtigung fehlt.",
  employee_panel_access_title: "Zugang zum Calendesk-Panel",
  employee_public_profile_title: "Für Kunden sichtbares Profil",
  employee_advanced_settings_title: "Erweiterte Einstellungen",
  employee_max_gap_card_info:
    "Der Verfügbarkeitsplan entscheidet weiterhin, wann dieser Mitarbeiter überhaupt Kunden empfängt. Der Abstand gilt nur an Tagen, an denen schon jemand gebucht hat: Der Kunde sieht dann Termine nahe an bestehenden Buchungen. An einem Tag ohne Buchungen sieht er alle Termine aus dem Plan. „Unbeschränkt“ schaltet die Grenze aus.",
  employee_max_gap_switch: "Eigener Abstand für diesen Mitarbeiter",
  employee_max_gap_none: "Unbeschränkt",
  employee_max_gap_title: "Maximaler Abstand zwischen Buchungen",
  max_gap_timeline_booking: "Buchung",
  max_gap_timeline_open: "Frei",
  max_gap_timeline_closed: "Ausgeblendet",
  max_gap_timeline_caption_limited:
    "Der Kunde sieht nur Termine im Abstand von höchstens @{gap} zur Buchung. Weiter entfernte Termine werden ausgeblendet, aber nur an Tagen, an denen schon jemand gebucht hat. Die Arbeitszeiten kommen weiterhin aus dem Verfügbarkeitsplan.",
  max_gap_timeline_caption_unlimited:
    "Unbeschränkt sieht der Kunde alle freien Termine aus dem Plan, egal was schon gebucht ist.",
  employee_services_section_title: "Dienstleistungen und Verfügbarkeitsplan",
  employee_availability_scope_from_employee:
    "Termine aus dem Verfügbarkeitsplan des Mitarbeiters",
  employee_availability_scope_own_schedule:
    "Termine aus dem Plan der Dienstleistung",
  employee_availability_scope_none_here: "Keine der gewählten Dienstleistungen",
  employee_availability_scope_caption:
    "Hat eine Dienstleistung einen eigenen Plan, sehen Kunden die Termine aus diesem Plan, und der Plan des Mitarbeiters wird dabei übergangen. Bei den übrigen Dienstleistungen sehen Kunden die Termine aus dem oben gewählten Verfügbarkeitsplan des Mitarbeiters.",
  employee_availability_scope_not_public:
    "Dieser Mitarbeiter nimmt keine Online-Buchungen an, daher sehen Kunden seine Termine in keiner Dienstleistung.",
  employee_availability_scope_no_services:
    "Wähle die Dienstleistungen, die dieser Mitarbeiter anbietet. Ohne sie können Kunden bei ihm nichts buchen.",
  employee_availability_scope_no_schedule:
    "Ohne Verfügbarkeitsplan sehen Kunden hier keine freien Termine.",
  employee_legacy_hours_warning:
    "Dieser Mitarbeiter nutzt noch den alten Arbeitsplan. Übertrage ihn in einen Verfügbarkeitsplan: denselben Plan kannst du anderen Personen zuweisen und an einer Stelle ändern.",
  employee_legacy_hours_migrate: "In Verfügbarkeitsplan übertragen",
  employee_legacy_hours_migrated:
    "Die Zeiten kommen in einen neuen Plan „@{name}“, sobald du den Mitarbeiter speicherst.",
  employee_legacy_schedule_name: "@{name} - Arbeitsplan",
  employee_public_preview_caption:
    "So sehen es Kunden. Je nach gewähltem Buchungskalender klappt eine längere Beschreibung nach @{limit} Zeichen hinter dem Link „Mehr anzeigen“ ein oder liegt samt Links hinter dem Pfeil neben dem Namen. Der Bereich Team auf deiner Website zeigt die ganze Beschreibung.",
  employee_public_preview_name_placeholder: "Vor- und Nachname",
  employee_public_preview_description_placeholder:
    "Hier erscheint die Beschreibung des Mitarbeiters.",
  employee_send_set_password_link:
    "Dem Mitarbeiter einen Link zum Festlegen des Passworts senden",
  employee_send_set_password_link_hint:
    "Der Link geht an @{email} in der Sprache des Mitarbeiters und gilt 7 Tage.",
  employee_role_matrix_label: "Rollenvergleich",
  employee_role_matrix_own_calendar: "Eigener Kalender und eigene Buchungen",
  employee_role_matrix_others_calendars: "Kalender anderer Mitarbeiter",
  employee_role_matrix_customers: "Kundendaten",
  employee_role_matrix_booking_payments: "Zahlungen für Buchungen",
  employee_role_matrix_team_services_website:
    "Mitarbeiter, Dienstleistungen und Website",
  employee_role_matrix_account_settings: "Kontoeinstellungen",
  employee_role_matrix_plan_invoices: "Calendesk-Plan und Rechnungen",
  employee_role_matrix_cell_yes: "Ja",
  employee_role_matrix_cell_no: "Nein",
  employee_role_matrix_cell_own: "Nur eigene",
  employee_role_matrix_cell_view: "Nur ansehen",
  employee_role_matrix_cell_booking_only: "Nur beim Anlegen einer Buchung",
  employee_role_matrix_cell_no_delete: "Ja, ohne Löschen",
  employee_locale_time_zone_title: "Sprache und Zeitzone",
  employee_locale_time_zone_info:
    "Die Sprache gilt für das Panel und die System-E-Mails von Calendesk an den Mitarbeiter, etwa den Link zum Festlegen des Passworts. Buchungsbenachrichtigungen gehen in der Sprache deiner Vorlagen raus. Die Zeitzone bestimmt die Uhrzeiten im Panel des Mitarbeiters. Leere Felder bedeuten die Einstellungen des gesamten Kontos.",
  employee_locale_time_zone_locked:
    "Eigene Sprache und Zeitzone für Mitarbeiter schaltest du in den Plattformeinstellungen frei.",
  employee_locale_time_zone_locked_link: "Zu den Einstellungen",
  max_gap_timeline_badge: "Beispiel",
  max_gap_timeline_title:
    "Ein Beispielarbeitstag aus dem Plan, mit einer Buchung",
  max_gap_timeline_row_without: "Ohne Abstand",
  max_gap_timeline_row_with: "Mit Abstand @{gap}",
  max_gap_timeline_row_empty: "Tag ohne Buchungen",
  max_gap_timeline_start: "Arbeitsbeginn",
  max_gap_timeline_end: "Arbeitsende",
  max_gap_timeline_caption_nothing_hidden:
    "In diesem Beispiel blendet ein Abstand von @{gap} nichts aus, weil der ganze Tag in seiner Reichweite liegt.",
  max_gap_timeline_empty_note:
    "Solange noch niemand gebucht hat, ändert der Abstand nichts: Der Kunde sieht alle Termine aus dem Plan.",
  employee_max_gap_subtitle:
    "Wie weit entfernt von einer bestehenden Buchung ein Kunde einen Termin wählen kann.",
  employee_max_gap_switch_hint_off:
    "Aktuell gilt der Abstand aus der jeweiligen Dienstleistung.",
  employee_max_gap_switch_hint_on:
    "Dieser Abstand gilt für alle Dienstleistungen dieses Mitarbeiters und ersetzt die Einstellungen der Dienstleistungen.",
  employee_public_preview_show_more: "Mehr anzeigen",
  employee_public_preview_collapse: "Einklappen",
  variable_booking_resources:
    "Ressourcen der Buchung mit Pool (z. B. Räume › Raum A)",
  variable_booking_resources_block:
    "Ressourcen der Buchung oder ein Text, wenn keine zugewiesen sind",
  booking_resources_block_with: "Zugewiesene Ressourcen: [BOOKING_RESOURCES]",
  booking_resources_block_without:
    "Die Ressourcen weisen wir vor dem Termin zu.",
  resource_example_name: "Raum A",
  booking_resources_preview_title: "Ressourcen in der Vorschau",
  booking_resources_preview_with: "Mit Ressource",
  booking_resources_preview_without: "Ohne Ressource",
  booking_resource_conflicts_dialog_title: "Ressourcenkonflikt",
  booking_resource_conflicts_dialog_message:
    "Zu dieser Zeit sind die gewählten Ressourcen schon anderen Buchungen zugewiesen:",
  booking_resource_conflicts_dialog_question: "Buchung trotzdem speichern?",
  booking_resource_conflicts_other_employee:
    "Buchung eines anderen Mitarbeiters",
  booking_resource_conflicts_truncated:
    "Es wird nur ein Teil der Überschneidungen angezeigt.",
  booking_resources_day_preview_title:
    "Buchungen mit diesen Ressourcen an diesem Tag",
  booking_reminder_custom_content_button: "Text bearbeiten",
  booking_reminder_custom_content_chip: "Eigener Text",
  booking_reminder_use_default_content_information:
    "Diese Erinnerung sendet wieder den Text der Vorlage „Buchungserinnerung“.",
  logs_subject_type_bookingresource: "Verknüpfung von Ressource und Buchung",
  booking_resources_info:
    "Wähle, was du dieser Buchung zuweist, z. B. einen Raum oder einen Saal. Der Kunde sieht es bei seiner Buchung und bekommt bei einer Änderung eine Benachrichtigung, wenn du Benachrichtigungen versendest.",
  booking_tags_info:
    "Etiketten siehst nur du und dein Team, deine Kunden nicht. Damit markierst du Buchungen und filterst die Buchungsliste.",
  resource_type_resource: "Ressource",
  resource_type_pool: "Pool",
  resource_group_usage_per_participant:
    "Jede teilnehmende Person belegt einen Platz",
  resource_group_usage_per_slot: "Die ganze Gruppe belegt einen Platz",
  resource_assignment_manual_only: "Niemandem, ich weise sie selbst zu",
  resource_assignment_always: "Allen Buchungen",
  resource_assignment_by_rule: "Nur ausgewählten Buchungen",
  resource_convert_to_pool: "In einen Pool umwandeln",
  resource_convert_to_pool_info:
    "Gib die Namen der Positionen ein. Ihre Zahl wird zur neuen Anzahl.",
  resource_convert_to_resource: "In eine einfache Ressource umwandeln",
  resource_convert_to_resource_info:
    "Wir löschen alle Positionen dieses Pools und entfernen sie aus den Buchungen. Das lässt sich nicht rückgängig machen.",
  booking_resources_group_locked:
    "Diese Position hat die ganze Gruppe. Du änderst sie in der Gruppenbuchung.",
  booking_resources_group_single_date:
    "Die Ressourcen der Gruppe änderst du nur für diesen Termin.",
  booking_resources_awaiting: "noch keine, wartet auf Zuweisung",
  booking_resources_awaiting_pool: "„@{pool}“: wartet auf Zuweisung",
  booking_resource_rule_mismatch_title_service:
    "Diese Position ist nicht für diesen Service gedacht",
  booking_resource_rule_mismatch_title_booking:
    "Diese Position ist nicht für diese Buchung gedacht",
  booking_resource_rule_only_services:
    "„@{resource}“ (Pool „@{pool}“) ist nur für: @{services}.",
  booking_resource_rule_only_employees:
    "„@{resource}“ (Pool „@{pool}“) ist nur für Buchungen bei: @{employees}.",
  booking_resource_rule_services_with_employees:
    "„@{resource}“ (Pool „@{pool}“) ist nur für: @{services}, und nur bei: @{employees}.",
  booking_resource_rule_services_or_employees:
    "„@{resource}“ (Pool „@{pool}“) ist nur für: @{services} oder für Buchungen bei: @{employees}.",
  booking_resource_rule_other:
    "„@{resource}“ (Pool „@{pool}“) hat eine Zuweisungsregel, die diese Buchung nicht abdeckt.",
  booking_resource_rule_booking: "Diese Buchung ist für: @{service}.",
  booking_resource_rule_booking_with_employee:
    "Diese Buchung ist für: @{service}, bei: @{employee}.",
  booking_resource_rule_mismatch_question_one:
    "Buchung trotzdem mit dieser Position speichern?",
  booking_resource_rule_mismatch_question_many:
    "Buchung trotzdem mit diesen Positionen speichern?",
  booking_resource_suggestions_none:
    "Im Pool „@{pool}“ ist zu dieser Zeit keine Position frei.",
  booking_resource_shortage_title: "Zu dieser Zeit ist keine Ressource frei",
  booking_resource_shortage_title_pool:
    "Zu dieser Zeit ist keine Position frei",
  booking_resource_shortage_pool:
    "Alle Positionen des Pools „@{pool}“ sind um @{time} belegt (@{used} von @{capacity}). Wenn du die Buchung speicherst, bekommt sie keine Position aus diesem Pool.",
  booking_resource_shortage_pool_rule:
    "Im Pool „@{pool}“ ist um @{time} keine Position für diese Buchung frei: Die freien Positionen sind für andere Buchungen gedacht. Wenn du die Buchung speicherst, bekommt sie keine Position aus diesem Pool.",
  booking_resource_shortage_resource:
    "Die Ressource „@{resource}“ ist um @{time} belegt (@{used} von @{capacity}).",
  booking_resource_suggestions_title: "Zu dieser Zeit frei und erlaubt:",
  availability_schedule_resources_condition_info:
    "Diese Zeiten gelten nur für Dienstleistungen, die die gewählten Ressourcen nutzen. Wählst du bestimmte Positionen, bekommt eine Buchung in diesen Zeiten eine davon.",
  resource_wizard_step_type: "Was du hinzufügst",
  resource_wizard_step_names: "Namen",
  resource_wizard_step_quantity: "Anzahl",
  resource_wizard_step_services: "Dienstleistungen",
  resource_wizard_step_group: "Gruppenbuchungen",
  resource_wizard_step_assignment: "Zuweisung",
  resource_wizard_step_summary: "Prüfen",
  resource_wizard_step_of: "Schritt @{step} von @{total}",
  resource_wizard_steps_label: "Schritte des Assistenten",
  resource_wizard_title_new_pool: "Neuer Pool „@{name}“",
  resource_wizard_title_new_resource: "Neue Ressource „@{name}“",
  resource_wizard_title_edit: "„@{name}“ bearbeiten",
  resource_wizard_title_add_position: "Position zu „@{name}“ hinzufügen",
  resource_wizard_type_title: "Was möchtest du hinzufügen?",
  resource_wizard_type_subtitle: "Wähle, was zu deiner Situation passt.",
  resource_wizard_type_resource_title: "Mehrere gleiche Dinge",
  resource_wizard_type_resource_info:
    "Zum Beispiel 2 Säle oder 3 Beamer. Welches Exemplar eine Buchung bekommt, spielt keine Rolle.",
  resource_wizard_type_pool_title: "Dinge mit eigenen Namen",
  resource_wizard_type_pool_info:
    "Zum Beispiel die Räume 106, 107 und 108. Jede Buchung bekommt einen davon, und du siehst, welchen.",
  resource_wizard_name_label: "Wie soll es heißen?",
  resource_wizard_name_hint_pool: "Name für den ganzen Pool, z. B. „Räume“.",
  resource_wizard_name_hint_resource: "Z. B. „Säle“ oder „Beamer“.",
  resource_wizard_names_title: "Was gehört zum Pool „@{name}“?",
  resource_wizard_names_subtitle:
    "Gib die Namen ein, die du und dein Team sehen werdet. Du brauchst mindestens zwei verschiedene Positionen.",
  resource_wizard_position_name: "Name",
  resource_wizard_add_position: "Position hinzufügen",
  resource_wizard_empty_rows_skipped: "Leere Zeilen lassen wir weg.",
  resource_wizard_removed_positions_info:
    "Wenn du speicherst, nehmen wir die entfernten Positionen auch aus den Buchungen, denen sie zugewiesen waren. Die Buchungen selbst bleiben.",
  resource_guide_title: "Wie funktionieren Ressourcen?",
  resource_guide_intro:
    "Eine Ressource ist etwas, das eine Buchung braucht und von dem du nur eine bestimmte Menge hast: ein Büro, ein Raum, Geräte. Ist alles belegt, sehen Kunden keinen freien Termin.",
  resource_guide_resource_text:
    "Du zählst nur Stück. Drei Beamer bedeuten höchstens drei Buchungen zur gleichen Zeit, ohne festzulegen, welcher Beamer.",
  resource_guide_pool_text:
    "Jedes Stück hat einen eigenen Namen, z. B. die Räume 106, 107 und 108. Eine Buchung bekommt eine bestimmte Position, und du siehst sie im Kalender und im Buchungsfenster.",
  resource_guide_assignment_title: "Wer bekommt eine Position?",
  resource_guide_assignment_always:
    "Jede Buchung einer Dienstleistung, die den Pool nutzt.",
  resource_guide_assignment_by_rule:
    "Nur ausgewählte Personen oder Dienstleistungen, z. B. Raum 108 nur für Paartherapie.",
  resource_guide_assignment_manual_only:
    "Die Buchung wartet, bis du im Buchungsfenster eine Position auswählst. Diese Buchungen findest du in der Buchungsliste mit dem Filter „Wartet auf Ressource“.",
  resource_guide_schedules_title: "Ressourcen in Verfügbarkeitsplänen",
  resource_guide_schedules_text:
    "Im Verfügbarkeitsplan kannst du einen Pool oder bestimmte Positionen angeben. Eine Buchung in diesen Stunden bekommt eine davon. Eine Position, die du selbst zuweist, öffnet keine freien Termine, gib also automatisch zugewiesene an.",
  resource_guide_groups_title: "Gruppentermine",
  resource_guide_groups_text:
    "Bei jeder Ressource legst du fest, ob jeder Teilnehmer einen Platz belegt oder die ganze Gruppe einen.",
  resource_delete_pool_info:
    "Wenn du einen Pool löschst, löschst du auch seine Positionen und nimmst sie aus den Buchungen, denen sie zugewiesen waren. Die Buchungen selbst bleiben.",
  delete_failed_for: "Gelöscht: @{deleted}. Nicht gelöscht: @{failed}",
  delete_failed_item: "„@{name}“: @{reason}",
  resource_wizard_quantity_title: "Wie viele „@{name}“ hast du?",
  resource_wizard_quantity_subtitle:
    "So viele Buchungen kannst du zur selben Zeit annehmen.",
  resource_wizard_quantity_less: "Weniger",
  resource_wizard_quantity_more: "Mehr",
  resource_wizard_services_title: "Welche Dienstleistungen nutzen „@{name}“?",
  resource_wizard_services_subtitle_pool:
    "Jede Buchung einer ausgewählten Dienstleistung belegt eine Position aus dem Pool. Das kannst du später in den Einstellungen der Dienstleistung ändern.",
  resource_wizard_services_subtitle_resource:
    "Jede Buchung einer ausgewählten Dienstleistung belegt eine Einheit. Das kannst du später in den Einstellungen der Dienstleistung ändern.",
  resource_wizard_no_services:
    "Du hast noch keine Dienstleistungen. Sobald du welche anlegst, wählst du die Ressource in den Einstellungen der Dienstleistung.",
  resource_wizard_services_online_note:
    "Online-Dienstleistungen musst du hier meist nicht auswählen.",
  resource_wizard_service_minutes: "@{minutes} Min.",
  resource_wizard_service_group: "Gruppe, bis zu @{max} Personen",
  resource_wizard_group_title:
    "@{service}: Wie viele Plätze in „@{name}“ belegt eine Gruppe?",
  resource_wizard_group_subtitle:
    "Das ist eine Gruppendienstleistung, deshalb musst du das festlegen.",
  resource_wizard_group_one_position: "eine Position von „@{name}“",
  resource_wizard_group_one_unit: "eine Einheit von „@{name}“",
  resource_wizard_group_per_participant_info: "Jede Person belegt @{unit}.",
  resource_wizard_group_per_slot_info:
    "Die ganze Gruppe belegt @{unit}, egal wie viele Personen teilnehmen. Der Rest bleibt für andere Buchungen frei.",
  resource_wizard_assignment_title:
    "Wie sollen Positionen aus dem Pool „@{name}“ vergeben werden?",
  resource_wizard_assignment_subtitle:
    "Jede neue Buchung bekommt automatisch eine freie Position. Hier kannst du das einschränken. Wenn es dir egal ist, welche Buchung welche Position bekommt, lass alles, wie es ist.",
  resource_wizard_assignment_question: "Wem darf das System „@{name}“ geben?",
  resource_wizard_assignment_always_info:
    "Das System kann diese Position jeder Buchung der ausgewählten Dienstleistungen geben.",
  resource_wizard_assignment_by_rule_info:
    "Du wählst, bei wem und für welche Dienstleistungen das System diese Position vergeben darf. Du kannst Personen, Dienstleistungen oder beides auswählen. Die übrigen Buchungen bekommen eine andere Position aus dem Pool.",
  resource_wizard_assignment_manual_only_info:
    "Das System vergibt diese Position nie selbst, das machst du im Buchungsfenster. Sie zählt trotzdem zum Limit: Bei @{positions} Position können Kunden höchstens @{count} Buchung zur selben Zeit machen, auch bevor du etwas zugewiesen hast.|Das System vergibt diese Position nie selbst, das machst du im Buchungsfenster. Sie zählt trotzdem zum Limit: Bei @{positions} Positionen können Kunden höchstens @{count} Buchungen zur selben Zeit machen, auch bevor du etwas zugewiesen hast.",
  resource_wizard_set_all_always: "Überall „Allen Buchungen“ einstellen",
  resource_wizard_rule_employees: "Bei wem?",
  resource_wizard_rule_services: "Bei welchen Dienstleistungen?",
  resource_wizard_rule_empty_means_all: "Ein leeres Feld heißt „alle“.",
  resource_wizard_rule_match_question:
    "Du hast Personen und Dienstleistungen ausgewählt. Wer kann diese Position bekommen?",
  resource_wizard_rule_match_all: "Beides muss passen",
  resource_wizard_rule_match_all_example:
    "Z. B. nur „@{service}“, wenn @{employee} zuständig ist.",
  resource_wizard_rule_match_any: "Eines reicht",
  resource_wizard_rule_match_any_example:
    "Z. B. jede Buchung, für die @{employee} zuständig ist, und jede Buchung von „@{service}“.",
  resource_wizard_rule_needs_services:
    "Wähle zuerst im Schritt „Dienstleistungen“ etwas aus.",
  resource_wizard_rule_pool_without_services:
    "Dieser Pool ist noch mit keiner Dienstleistung verknüpft.",
  resource_wizard_rule_advanced:
    "Diese Position hat eine per API festgelegte Regel, die hier nicht angezeigt werden kann. Sie bleibt unverändert, bis du sie ersetzt.",
  resource_wizard_rule_replace: "Durch einfache Auswahl ersetzen",
  resource_wizard_rule_advanced_short: "Regel aus der API",
  resource_wizard_or: "oder",
  resource_wizard_summary_title: "Prüfe alles, bevor du speicherst",
  resource_wizard_summary_subtitle:
    "Rechts: derselbe Beispieltag mit deinen Einstellungen.",
  resource_wizard_summary_type: "Art",
  resource_wizard_summary_name: "Name",
  resource_wizard_summary_positions: "Positionen",
  resource_wizard_summary_quantity: "Anzahl",
  resource_wizard_summary_services: "Dienstleistungen",
  resource_wizard_summary_group: "Gruppenbuchungen",
  resource_wizard_summary_assignment: "Zuweisung",
  resource_wizard_summary_no_services:
    "Keine, du fügst sie später in der Dienstleistung hinzu",
  resource_wizard_change: "Ändern",
  resource_wizard_create_pool: "Pool erstellen",
  resource_wizard_create_resource: "Ressource erstellen",
  resource_wizard_count_positions: "@{count} Position|@{count} Positionen",
  resource_wizard_count_units: "@{count} Einheit|@{count} Einheiten",
  resource_wizard_error_name_required: "Gib einen Namen ein.",
  resource_wizard_error_name_too_long:
    "Der Name darf höchstens @{max} Zeichen haben.",
  resource_wizard_error_name_characters:
    "Der Name darf keine eckigen oder geschweiften Klammern und keine Zeichen < oder > enthalten.",
  resource_wizard_error_duplicate: "Dieser Name steht schon auf der Liste.",
  resource_wizard_error_two_names:
    "Gib mindestens zwei verschiedene Namen ein.",
  resource_wizard_error_too_many:
    "Ein Pool kann höchstens 200 Positionen haben.",
  resource_wizard_error_quantity: "Gib eine Zahl von 1 bis @{max} ein.",
  resource_wizard_error_rule_empty:
    "Wähle mindestens eine Person oder Dienstleistung aus.",
  resource_wizard_close_title: "Ohne Speichern schließen?",
  resource_wizard_close_warning:
    "Die eingegebenen Namen und Einstellungen werden nicht gespeichert.",
  resource_wizard_close_keep: "Zurück zum Assistenten",
  resource_wizard_close_discard: "Ohne Speichern schließen",
  resource_wizard_pool_added: "Pool „@{name}“ hinzugefügt.",
  resource_wizard_resource_added: "Ressource „@{name}“ hinzugefügt.",
  resource_wizard_saved: "Änderungen gespeichert.",
  resource_wizard_in_practice: "Was das in der Praxis heißt",
  resource_wizard_example_always:
    "Jede Buchung einer Dienstleistung, die den Pool „@{pool}“ nutzt, kann „@{name}“ bekommen, wenn dort zu dieser Zeit keine andere Buchung ist.",
  resource_wizard_example_manual:
    "Das System vergibt „@{name}“ nie selbst. Du weist es im Buchungsfenster zu.",
  resource_wizard_example_manual_counts:
    "Eine Buchung, die auf deine Zuweisung wartet, belegt trotzdem einen Platz im Pool. Wenn alle Positionen belegt sind oder auf eine Zuweisung warten, sehen Kunden diese Zeit nicht.",
  resource_wizard_example_fits:
    "@{service} bei @{employee}: kann „@{name}“ bekommen, wenn dort zu dieser Zeit keine andere Buchung ist.",
  resource_wizard_example_misses:
    "@{service} bei @{employee}: bekommt „@{name}“ nicht. Das System vergibt eine andere freie Position.",
  resource_wizard_preview_example_title: "An deinem Beispiel",
  resource_wizard_preview_type_name_first:
    "Gib links einen Namen ein, dann zeigen wir dir, wie er in der Buchung aussieht.",
  resource_wizard_preview_label_title: "So siehst du es in der Buchung",
  resource_wizard_preview_label_caption: "Im Buchungsfenster und im Kalender.",
  resource_wizard_preview_booking_resources: "Ressourcen der Buchung",
  resource_wizard_preview_label_pool_note:
    "Statt „…“ steht hier der Name einer Position aus dem Pool „@{name}“. Die Namen gibst du im nächsten Schritt ein.",
  resource_wizard_preview_label_resource_note:
    "Wie viele „@{name}“ du hast, legst du im nächsten Schritt fest.",
  resource_wizard_preview_names_caption:
    "Jede Buchung bekommt eine dieser Positionen. Im Kalender und im Buchungsfenster siehst du sie zusammen mit dem Namen des Pools.",
  resource_wizard_preview_names_examples: "Ressourcen der Buchung, Beispiele",
  resource_wizard_preview_names_empty: "Gib links die Namen ein.",
  resource_wizard_preview_names_note:
    "@{positions} Position bedeutet höchstens @{bookings} Buchung zur selben Zeit. Wer sie bekommt, legst du im Schritt „Zuweisung“ fest.|@{positions} Positionen bedeuten höchstens @{bookings} Buchungen zur selben Zeit. Wer sie bekommt, legst du im Schritt „Zuweisung“ fest.",
  resource_wizard_preview_more_positions:
    "und @{count} weitere Position|und @{count} weitere Positionen",
  resource_wizard_preview_quantity_title: "Wie viele Buchungen gleichzeitig?",
  resource_wizard_preview_quantity_caption:
    "So viele Buchungen können „@{name}“ zur selben Zeit belegen.",
  resource_wizard_preview_quantity_at_once:
    "@{count} Buchung gleichzeitig|@{count} Buchungen gleichzeitig",
  resource_wizard_preview_quantity_note:
    "Der Kalender zeigt diese Zeit als verfügbar an, bis @{count} Buchung vorliegt.|Der Kalender zeigt diese Zeit als verfügbar an, bis @{count} Buchungen vorliegen.",
  resource_wizard_preview_services_title: "Welche Buchungen belegen „@{name}“?",
  resource_wizard_preview_services_caption:
    "Anhand der Dienstleistungen, die du auswählst.",
  resource_wizard_preview_services_empty: "Wähle links Dienstleistungen aus.",
  resource_wizard_preview_service_one_place: "Belegt einen Platz.",
  resource_wizard_preview_service_group_one_place:
    "Belegt einen Platz für die ganze Gruppe.",
  resource_wizard_preview_service_run_by: "Zuständig: @{names}",
  resource_wizard_insight_people_one_service:
    "Für diese Dienstleistung ist @{count} Person zuständig|Für diese Dienstleistung sind @{count} Personen zuständig",
  resource_wizard_insight_people_services:
    "Für diese Dienstleistungen ist @{count} Person zuständig|Für diese Dienstleistungen sind @{count} Personen zuständig",
  resource_wizard_insight_pool_capacity:
    "und der Pool „@{name}“ hat @{count} Position.|und der Pool „@{name}“ hat @{count} Positionen.",
  resource_wizard_insight_resource_capacity:
    "und die verfügbare Anzahl von „@{name}“ ist @{count}.",
  resource_wizard_insight_short:
    "Zur selben Zeit lässt der Kalender bei einer von ihnen keine Buchung zu.|Zur selben Zeit lässt der Kalender bei @{count} von ihnen keine Buchung zu.",
  resource_wizard_insight_enough_all:
    "Es ist genug Platz, auch wenn alle zur selben Zeit arbeiten.",
  resource_wizard_insight_enough: "Es ist genug Platz.",
  resource_wizard_preview_group_caption:
    "Bis zu @{max} Personen pro Termin. „@{name}“: @{units}.",
  resource_wizard_preview_group_slot_box:
    "@{service}, @{max} angemeldete Personen",
  resource_wizard_preview_group_slot_takes:
    "belegt 1 von @{capacity} Plätzen in „@{name}“",
  resource_wizard_preview_group_left_positions:
    "Für andere Buchungen zu dieser Zeit bleibt @{count} Position frei.|Für andere Buchungen zu dieser Zeit bleiben @{count} Positionen frei.",
  resource_wizard_preview_group_left_units:
    "Für andere Buchungen zu dieser Zeit bleibt @{count} Einheit frei.|Für andere Buchungen zu dieser Zeit bleiben @{count} Einheiten frei.",
  resource_wizard_preview_group_none_left:
    "Zu dieser Zeit passt keine weitere Buchung mehr.",
  resource_wizard_preview_group_participants_fit:
    "Höchstens @{count} Person kann sich anmelden|Höchstens @{count} Personen können sich anmelden",
  resource_wizard_preview_group_participants_left:
    "Jede Person belegt ihren eigenen Platz. Für andere Buchungen zu dieser Zeit bleibt @{count} Platz frei.|Jede Person belegt ihren eigenen Platz. Für andere Buchungen zu dieser Zeit bleiben @{count} Plätze frei.",
  resource_wizard_preview_group_too_small:
    "Die Dienstleistung nimmt bis zu @{max} Personen auf, aber jede braucht einen eigenen Platz, und du hast nur @{capacity}. Wenn die Gruppe einen gemeinsamen Platz nutzt, wähle die zweite Option.",
  resource_wizard_preview_day_title: "Beispieltag",
  resource_wizard_preview_day_caption:
    "Alle haben um 10:00 eine Buchung, @{first} auch um 11:00.",
  resource_wizard_preview_bookings_row: "Buchungen",
  resource_wizard_preview_legend_gets: "hat einen Platz",
  resource_wizard_preview_legend_waits: "wartet auf Zuweisung",
  resource_wizard_preview_legend_missed:
    "kein Platz, Kunden sehen diese Uhrzeit nicht",
  resource_wizard_preview_day_needs_services:
    "Wähle im Schritt „Dienstleistungen“ etwas aus, dann zeigen wir dir einen Beispieltag mit deinen Mitarbeitern.",
  resource_wizard_preview_taken: "Belegt",
  resource_wizard_preview_customers_see: "Kunden sehen",
  resource_wizard_preview_free: "frei",
  resource_wizard_preview_gone: "ausgeblendet",
  resource_wizard_preview_log_takes:
    "@{employee}, @{hour}, @{service}: belegt eine Einheit von „@{resource}“.",
  resource_wizard_preview_log_gets:
    "@{employee}, @{hour}, @{service}: bekommt „@{unit}“.",
  resource_wizard_preview_log_waits:
    "@{employee}, @{hour}, @{service}: Das System hat nichts, was es selbst vergeben kann. Die Buchung wird gespeichert und wartet, bis du ihr etwas zuweist. Bis dahin belegt sie einen Platz, z. B. „@{unit}“.",
  resource_wizard_preview_log_full:
    "@{employee}, @{hour}, @{service}: kein freier Platz, daher sehen Kunden diese Zeit bei dieser Person nicht. Im Panel kannst du so eine Buchung trotzdem speichern.",
  resource_wizard_preview_log_no_match:
    "@{employee}, @{hour}, @{service}: Keine freie Position ist für diese Buchung vorgesehen, daher sehen Kunden diese Zeit bei dieser Person nicht.",
  resource_wizard_preview_manual_note:
    "Eine Buchung, die auf manuelle Zuweisung wartet, belegt trotzdem einen Platz. Deshalb nimmt „@{name}“ höchstens @{count} Buchung zur selben Zeit an, auch bevor du etwas zugewiesen hast.|Eine Buchung, die auf manuelle Zuweisung wartet, belegt trotzdem einen Platz. Deshalb nimmt „@{name}“ höchstens @{count} Buchungen zur selben Zeit an, auch bevor du etwas zugewiesen hast.",
  resource_wizard_preview_order_note:
    "Passen mehrere freie Positionen, vergibt das System zuerst die, die für die kleinste Gruppe von Buchungen vorgesehen ist, und hebt Positionen mit „Allen Buchungen“ bis zuletzt auf. So sehen Kunden möglichst viele freie Zeiten.",
  resource_wizard_example_no_fit:
    "Gerade passt keine Buchung zu dieser Auswahl, daher gibt das System „@{name}“ niemandem.",
  booking_awaiting_resource: "Wartet auf Ressource",
  booking_not_awaiting_resource: "Wartet nicht auf Ressource",
  booking_awaiting_resource_info:
    "Die Leistung dieser Buchung nutzt einen Ressourcen-Pool, aber es ist noch keine Position zugewiesen. Weise sie beim Bearbeiten der Buchung zu.",
  availability_schedule_resource_blocked:
    "@{employee}: Kunden sehen in diesen Stunden keine freien Termine. Die gewählten Positionen des Pools „@{pool}“ sind für andere Buchungen gedacht.",
  availability_schedule_resource_manual:
    "@{employee}: Kunden sehen in diesen Stunden keine freien Termine, weil du die gewählten Positionen des Pools „@{pool}“ selbst zuweist. Stell sie auf „Allen Buchungen“ oder „Nur ausgewählten Buchungen“ um oder wähl andere Positionen.",
  resource_wizard_schedule_blocked:
    "Im Plan „@{schedule}“ sind für @{employee} nur Positionen dieses Pools eingetragen. Nach dem Speichern sehen Kunden bei dieser Person in diesen Stunden keine freien Termine.",
  recurring_series_length_locked:
    "Die Anzahl der Wiederholungen einer bestehenden Serie lässt sich nicht ändern. Zum Kürzen löschst du ab dem ersten Termin, den du nicht mehr brauchst, „Diese Veranstaltung und alle folgenden“. Zum Verlängern legst du eine neue Serie an.",
  recurring_series_day_move_not_possible:
    "Diese Serie lässt sich nicht auf den gewählten Tag verschieben, weil ihr Rhythmus (zum Beispiel „der letzte Werktag im Monat“) danach nicht mehr stimmt. Lösche „Diese Veranstaltung und alle folgenden“ und leg ab dem gewünschten Tag eine neue Serie an.",
  recurring_series_changed_meanwhile:
    "Diese Serie hat sich inzwischen geändert. Lade den Kalender neu und versuch es noch einmal.",
  class_capacity_exceeded:
    "Dieser Kurs hat Platz für @{max} Personen. Nach dieser Änderung wären es @{total}.",
  remove_tag_title: "Etikett entfernen",
  remove_tag_named:
    "Das Etikett „@{name}“ verschwindet aus allen Buchungen und bei allen Kunden, die es haben.",
  remove_group_title: "Gruppe entfernen",
  remove_group_named:
    "Die Kunden der Gruppe „@{name}“ gehören ihr danach nicht mehr an. Die Kunden selbst bleiben.",
  remove_resource_title: "Ressource entfernen",
  remove_resource_named:
    "Die Ressource „@{name}“ verschwindet aus ihren Diensten und aus allen Buchungen, die sie haben. Die Buchungen bleiben.",
  remove_pool_title: "Pool entfernen",
  remove_pool_named:
    "Der Pool „@{name}“ verschwindet samt seinen Positionen aus seinen Diensten, und die Positionen verschwinden aus den Buchungen, denen sie zugewiesen waren. Die Buchungen bleiben.",
  remove_position_title: "Position entfernen",
  remove_position_named:
    "Die Position „@{name}“ verschwindet aus allen Buchungen, die sie haben. Die Buchungen bleiben.",
  resource_wizard_remove_positions_title: "Positionen entfernen?",
  resource_wizard_remove_positions_warning:
    "Du entfernst: @{names}. Buchungen ab heute mit diesen Positionen: @{count}. Sie verlieren die Positionen, bleiben aber bestehen.",
  resource_wizard_remove_positions_button: "Positionen entfernen",
  resource_wizard_remove_positions_warning_no_count:
    "Du entfernst: @{names}. Buchungen mit diesen Positionen verlieren sie, bleiben aber bestehen.",
  service_description_title: "Beschreibung des Service",
  service_description_hint: "Kunden sehen sie, wenn sie den Service auswählen.",
  service_description_placeholder:
    "Beschreibe kurz, worum es bei dem Service geht",
  service_advanced_texts_title: "Texte für Kunden",
  service_advanced_texts_hint:
    "Zusätzliche Inhalte bei der Buchung und in Buchungs-E-Mails.",
  upselling_description_placeholder: "Z. B. ein Tipp zu einem Zusatzprodukt",
  additional_information_after_booking_placeholder:
    "Z. B. die Anfahrt oder was man mitbringen sollte",
  additional_information_after_booking_variable_info:
    "Wenn deine Benachrichtigungen einen eigenen Text haben, füge ihnen die Variable [ADDITIONAL_INFORMATION_AFTER_BOOKING] hinzu. Ohne sie erscheinen diese Infos nicht.",
  service_advanced_availability_title: "Verfügbarkeit und Ressourcen",
  service_advanced_availability_hint:
    "Zusätzliche Einschränkung der Buchungszeiten und die Ressourcen, die der Service braucht.",
  service_advanced_resources_title: "Ressourcen",
  service_advanced_resources_hint: "Räume und Geräte, die der Service braucht.",
  recurrence_too_long:
    "Diese Serie hat zu viele Wiederholungen. Wähl ein früheres Enddatum oder weniger Wiederholungen.",
  overlap_check_occurrences_truncated:
    "Wir haben nur die ersten 1000 Wiederholungen dieser Serie geprüft.",
  series_saved_occurrences_truncated:
    "Gespeichert. Auf Konflikte haben wir nur die ersten 1000 Wiederholungen dieser Serie geprüft.",
  location_skype_retired_info:
    "Skype funktioniert seit Mai 2025 nicht mehr. Wähl Microsoft Teams oder einen anderen Standort.",
  service_resource_hold_checkbox:
    "Ressourcen vor dem Ende der Buchung freigeben",
  service_resource_hold_label: "Belegungszeit",
  service_resource_hold_whole: "Ganze Buchung",
  service_resource_hold_info:
    "Nach dieser Zeit ist die Ressource wieder für andere Buchungen frei, obwohl diese noch läuft. Der Mitarbeiter bleibt bis zum Ende belegt. Die Änderung gilt auch für Buchungen, die schon im Kalender stehen.",
  resource_daily_limit_checkbox: "Tageslimit festlegen",
  resource_daily_limit_label: "Limit",
  resource_daily_limit_unit_minutes: "Minuten",
  resource_daily_limit_unit_bookings: "Buchungen",
  resource_daily_limit_per_day: "pro Tag",
  resource_daily_limit_per_position: "für jede Position",
  resource_daily_limit_per_unit: "für jedes Stück",
  resource_daily_limit_total:
    "Insgesamt @{total} pro Tag (@{units} × @{limit})",
  resource_daily_limit_bookings_count: "@{count} Buchung|@{count} Buchungen",
  resource_daily_limit_caption: "Limit @{limit} pro Tag",
  resource_wizard_error_daily_limit_minutes: "Gib 1 bis 1440 Minuten ein.",
  resource_wizard_error_daily_limit_bookings: "Gib 1 bis 100 Buchungen ein.",
  resource_daily_usage_minutes: "@{used} von @{limit} Min.",
  resource_daily_usage_bookings: "@{used} von @{limit} Buchungen",
  resource_daily_over_limit: "über dem Limit",
  resource_limit_warning_title: "Tageslimit der Ressource",
  resource_limit_warning_minutes:
    "@{label}: Am @{date} sind @{used} von @{limit} Min. belegt, nach dieser Buchung @{after}.",
  resource_limit_warning_bookings:
    "@{label}: Am @{date} sind @{used} von @{limit} Buchungen belegt, mit dieser @{after}.",
  resource_limit_warnings_truncated:
    "Es gibt weitere Termine über dem Limit, hier stehen nur die ersten.",
  booking_helper_tile: "Hilfe",
  booking_helper_led_by: "Leitung:",
  booking_helpers_preview_label: "Helfende",
  booking_helpers_title: "Personen bei dieser Buchung",
  booking_helpers_role_lead: "Leitet",
  booking_helpers_role_helper: "Hilft",
  booking_helpers_window_whole_booking: "Ganze Buchung",
  booking_helpers_window_outside: "Außerhalb der Buchung",
  booking_helpers_window_title: "Hilfezeit für alle Helfenden",
  booking_helpers_offset_label: "Hilfe beginnt",
  booking_helpers_offset_zero: "Mit Beginn der Buchung",
  booking_helpers_minutes_label: "Wie lange geholfen wird",
  booking_helpers_minutes_zero: "Bis zum Ende der Buchung",
  booking_helpers_help_one:
    "Bei @{name} wird @{window} gesperrt. Die Zeit steht im Calendesk-Kalender und in der App.",
  booking_helpers_help_two:
    "Bei @{first} und @{second} wird @{window} gesperrt. Die Zeit steht im Calendesk-Kalender und in der App.",
  booking_helpers_help_many:
    "Bei den @{count} ausgewählten Mitarbeitern wird @{window} gesperrt. Die Zeit steht im Calendesk-Kalender und in der App.",
  booking_helpers_help_outside:
    "Die Hilfe beginnt nach dem Ende der Buchung, also wird bei niemandem Zeit gesperrt. Ändere den Beginn der Hilfe.",
  booking_helpers_remove: "Person entfernen",
  booking_helpers_hint:
    "Zuletzt bei dieser Leistung dabei: @{names} (@{window}). Wieder hinzufügen?",
  booking_helpers_hint_dismiss: "Nicht jetzt",
  booking_helpers_window_whole: "ganze Buchung",
  booking_helpers_window_first: "erste @{minutes} Min.",
  booking_helpers_window_from_for: "@{minutes} Min. ab Minute @{offset}",
  booking_helpers_window_from_to_end: "ab Minute @{offset} bis zum Ende",
  booking_helpers_add: "Person hinzufügen",
  booking_helper_busy_chip: "Hilfe nicht verfügbar",
  booking_helper_conflicts_title: "Nicht alle können dann helfen",
  booking_helper_conflict_outside_hours:
    "@{name}: @{when}-@{end}, außerhalb der Arbeitszeit.",
  booking_helper_conflict_booking:
    "@{name}: @{when}-@{end}, hat eine andere Buchung.",
  booking_helper_conflict_booking_details:
    "@{name}: @{when}-@{end}, hat eine Buchung: @{details}.",
  booking_helper_conflict_blockade:
    "@{name}: @{when}-@{end}, hat eine Sperrung im Kalender.",
  booking_helper_conflict_helper_time:
    "@{name}: @{when}-@{end}, hilft schon bei einer anderen Buchung.",
  booking_helper_conflict_helper_time_details:
    "@{name}: @{when}-@{end}, hilft schon bei einer Buchung: @{details}.",
  booking_helper_conflicts_truncated: "Wir zeigen nur die ersten Konflikte.",
  booking_helper_conflicts_question: "Trotzdem speichern?",
  helper_time_overlaps_count: "Hilfe bei anderen Buchungen",
  helper_notifications_headline: "Helfende bei Buchungen",
  helper_notifications_checkbox:
    "Benachrichtigungen zu den Buchungen senden, bei denen sie helfen",
  helper_notifications_info:
    "Sie bekommen dieselben Benachrichtigungen wie die leitende Person: neue Buchung, Änderung, Stornierung und Erinnerung. Sie gehen per E-Mail, SMS und an die App, so wie deine Kanäle für Mitarbeiter eingestellt sind. SMS verbrauchen das SMS-Paket des Kontos.",
  resource_example_label: "Räume › Raum A",
  variable_booking_resource_names:
    "Namen der Ressourcen ohne Pool (z. B. Raum A)",
  booking_helpers_add_label: "Wer hilft?",
  cookie_settings: "Cookie-Einstellungen",
};
